/*
Impulse by Archetype Themes (https://archetypethemes.co)
Plugins:
jQuery                  3.1.0
Enqurie                 2.1.2
Slick Slider            1.6.0 with customizations by Archetype
Handlebars JS           4.0.5
Prepare Transition      1.0.0
Instafeed               1.0.0
JavaScript Cookie       2.2.0
AOS                     2.3.4
Photoswipe              4.1.3
Photoswipe UI           4.1.2 with customizations by Archetype

Lazysizes for image loading:
core                    4.0.2
respimg                 4.0.1
rias                    4.0.1
bgset                   4.0.1
object-fit              4.1.2
parent-fit              4.1.2

Polyfills:
object-assign for IE11  1.0.0
promise                 1.0.0
*/
/*! jQuery v3.1.0 | (c) jQuery Foundation | jquery.org/license */

    (theme.jQuery = jQuery) /*! enquire.js v2.1.2 - http://wicky.nillia.ms/enquire.js */,
    !(function (e, t, n) {
      var i = window.matchMedia;
      "undefined" != typeof module && module.exports
        ? (module.exports = n(i))
        : "function" == typeof define && define.amd
        ? define(function () {
            return (t[e] = n(i));
          })
        : (t[e] = n(i));
    })("enquire", this, function (e) {
      "use strict";
      function t(e, t) {
        var n,
          i = 0,
          o = e.length;
        for (i; o > i && ((n = t(e[i], i)), n !== !1); i++);
      }
      function n(e) {
        return "[object Array]" === Object.prototype.toString.apply(e);
      }
      function i(e) {
        return "function" == typeof e;
      }
      function o(e) {
        (this.options = e), !e.deferSetup && this.setup();
      }
      function r(t, n) {
        (this.query = t), (this.isUnconditional = n), (this.handlers = []), (this.mql = e(t));
        var i = this;
        (this.listener = function (e) {
          (i.mql = e), i.assess();
        }),
          this.mql.addListener(this.listener);
      }
      function s() {
        if (!e) throw new Error("matchMedia not present, legacy browsers require a polyfill");
        (this.queries = {}), (this.browserIsIncapable = !e("only all").matches);
      }
      return (
        (o.prototype = {
          setup: function () {
            this.options.setup && this.options.setup(), (this.initialised = !0);
          },
          on: function () {
            !this.initialised && this.setup(), this.options.match && this.options.match();
          },
          off: function () {
            this.options.unmatch && this.options.unmatch();
          },
          destroy: function () {
            this.options.destroy ? this.options.destroy() : this.off();
          },
          equals: function (e) {
            return this.options === e || this.options.match === e;
          },
        }),
        (r.prototype = {
          addHandler: function (e) {
            var t = new o(e);
            this.handlers.push(t), this.matches() && t.on();
          },
          removeHandler: function (e) {
            var n = this.handlers;
            t(n, function (t, i) {
              return t.equals(e) ? (t.destroy(), !n.splice(i, 1)) : void 0;
            });
          },
          matches: function () {
            return this.mql.matches || this.isUnconditional;
          },
          clear: function () {
            t(this.handlers, function (e) {
              e.destroy();
            }),
              this.mql.removeListener(this.listener),
              (this.handlers.length = 0);
          },
          assess: function () {
            var e = this.matches() ? "on" : "off";
            t(this.handlers, function (t) {
              t[e]();
            });
          },
        }),
        (s.prototype = {
          register: function (e, o, s) {
            var a = this.queries,
              l = s && this.browserIsIncapable;
            return (
              a[e] || (a[e] = new r(e, l)),
              i(o) && (o = { match: o }),
              n(o) || (o = [o]),
              t(o, function (t) {
                i(t) && (t = { match: t }), a[e].addHandler(t);
              }),
              this
            );
          },
          unregister: function (e, t) {
            var n = this.queries[e];
            return n && (t ? n.removeHandler(t) : (n.clear(), delete this.queries[e])), this;
          },
        }),
        new s()
      );
    }),
    !(function (e) {
      function t() {}
      function n(e, t) {
        return function () {
          e.apply(t, arguments);
        };
      }
      function i(e) {
        if ("object" != typeof this) throw new TypeError("Promises must be constructed via new");
        if ("function" != typeof e) throw new TypeError("not a function");
        (this._state = 0), (this._handled = !1), (this._value = void 0), (this._deferreds = []), c(e, this);
      }
      function o(e, t) {
        for (; 3 === e._state; ) e = e._value;
        return 0 === e._state
          ? void e._deferreds.push(t)
          : ((e._handled = !0),
            void i._immediateFn(function () {
              var n = 1 === e._state ? t.onFulfilled : t.onRejected;
              if (null === n) return void (1 === e._state ? r : s)(t.promise, e._value);
              var i;
              try {
                i = n(e._value);
              } catch (e) {
                return void s(t.promise, e);
              }
              r(t.promise, i);
            }));
      }
      function r(e, t) {
        try {
          if (t === e) throw new TypeError("A promise cannot be resolved with itself.");
          if (t && ("object" == typeof t || "function" == typeof t)) {
            var o = t.then;
            if (t instanceof i) return (e._state = 3), (e._value = t), void a(e);
            if ("function" == typeof o) return void c(n(o, t), e);
          }
          (e._state = 1), (e._value = t), a(e);
        } catch (t) {
          s(e, t);
        }
      }
      function s(e, t) {
        (e._state = 2), (e._value = t), a(e);
      }
      function a(e) {
        2 === e._state &&
          0 === e._deferreds.length &&
          i._immediateFn(function () {
            e._handled || i._unhandledRejectionFn(e._value);
          });
        for (var t = 0, n = e._deferreds.length; t < n; t++) o(e, e._deferreds[t]);
        e._deferreds = null;
      }
      function l(e, t, n) {
        (this.onFulfilled = "function" == typeof e ? e : null), (this.onRejected = "function" == typeof t ? t : null), (this.promise = n);
      }
      function c(e, t) {
        var n = !1;
        try {
          e(
            function (e) {
              n || ((n = !0), r(t, e));
            },
            function (e) {
              n || ((n = !0), s(t, e));
            }
          );
        } catch (e) {
          if (n) return;
          (n = !0), s(t, e);
        }
      }
      var u = setTimeout;
      (i.prototype.catch = function (e) {
        return this.then(null, e);
      }),
        (i.prototype.then = function (e, n) {
          var i = new this.constructor(t);
          return o(this, new l(e, n, i)), i;
        }),
        (i.all = function (e) {
          var t = Array.prototype.slice.call(e);
          return new i(function (e, n) {
            function i(r, s) {
              try {
                if (s && ("object" == typeof s || "function" == typeof s)) {
                  var a = s.then;
                  if ("function" == typeof a)
                    return void a.call(
                      s,
                      function (e) {
                        i(r, e);
                      },
                      n
                    );
                }
                (t[r] = s), 0 === --o && e(t);
              } catch (e) {
                n(e);
              }
            }
            if (0 === t.length) return e([]);
            for (var o = t.length, r = 0; r < t.length; r++) i(r, t[r]);
          });
        }),
        (i.resolve = function (e) {
          return e && "object" == typeof e && e.constructor === i
            ? e
            : new i(function (t) {
                t(e);
              });
        }),
        (i.reject = function (e) {
          return new i(function (t, n) {
            n(e);
          });
        }),
        (i.race = function (e) {
          return new i(function (t, n) {
            for (var i = 0, o = e.length; i < o; i++) e[i].then(t, n);
          });
        }),
        (i._immediateFn =
          ("function" == typeof setImmediate &&
            function (e) {
              setImmediate(e);
            }) ||
          function (e) {
            u(e, 0);
          }),
        (i._unhandledRejectionFn = function (e) {
          "undefined" != typeof console && console && console.warn("Possible Unhandled Promise Rejection:", e);
        }),
        (i._setImmediateFn = function (e) {
          i._immediateFn = e;
        }),
        (i._setUnhandledRejectionFn = function (e) {
          i._unhandledRejectionFn = e;
        }),
        "undefined" != typeof module && module.exports ? (module.exports = i) : e.Promise || (e.Promise = i);
    })(this),
    "function" != typeof Object.assign &&
      Object.defineProperty(Object, "assign", {
        value: function (e, t) {
          if (null == e) throw new TypeError("Cannot convert undefined or null to object");
          for (var n = Object(e), i = 1; i < arguments.length; i++) {
            var o = arguments[i];
            if (null != o) for (var r in o) Object.prototype.hasOwnProperty.call(o, r) && (n[r] = o[r]);
          }
          return n;
        },
        writable: !0,
        configurable: !0,
      }),
    (function (e) {
      "use strict";
      "function" == typeof define && define.amd ? define(["jquery"], e) : "undefined" != typeof exports ? (module.exports = e(require("jquery"))) : e(jQuery);
    })(function (e) {
      "use strict";
      var t = window.Slick || {};
      (t = (function () {
        function t(t, i) {
          var o,
            r = this;
          (r.defaults = {
            accessibility: !0,
            adaptiveHeight: !1,
            appendArrows: e(t),
            appendDots: e(t),
            arrows: !0,
            asNavFor: null,
            prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
            nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
            autoplay: !1,
            autoplaySpeed: 3e3,
            centerMode: !1,
            centerPadding: "50px",
            cssEase: "ease",
            customPaging: function (t, n) {
              return e('<button type="button" data-role="none" role="button" tabindex="0" />').text(n + 1);
            },
            dots: !1,
            dotsClass: "slick-dots",
            draggable: !0,
            easing: "linear",
            edgeFriction: 0.35,
            fade: !1,
            focusOnSelect: !1,
            infinite: !0,
            initialSlide: 0,
            mobileFirst: !1,
            pauseOnHover: !0,
            pauseOnFocus: !0,
            pauseOnDotsHover: !1,
            respondTo: "window",
            responsive: null,
            rows: 1,
            rtl: !1,
            slide: "",
            slidesPerRow: 1,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 500,
            swipe: !0,
            swipeToSlide: !1,
            touchMove: !0,
            touchThreshold: 5,
            useCSS: !0,
            useTransform: !0,
            variableWidth: !1,
            vertical: !1,
            verticalSwiping: !1,
            waitForAnimate: !0,
            zIndex: 1e3,
            customHeightMatching: !1,
            customSlideAdvancement: !1,
          }),
            (r.initials = {
              animating: !1,
              dragging: !1,
              autoPlayTimer: null,
              currentDirection: 0,
              currentLeft: null,
              currentSlide: 0,
              direction: 1,
              $dots: null,
              listWidth: null,
              listHeight: null,
              loadIndex: 0,
              $nextArrow: null,
              $prevArrow: null,
              slideCount: null,
              slideWidth: null,
              $slideTrack: null,
              $slides: null,
              sliding: !1,
              slideOffset: 0,
              swipeLeft: null,
              $list: null,
              touchObject: {},
              transformsEnabled: !1,
              unslicked: !1,
            }),
            e.extend(r, r.initials),
            (r.activeBreakpoint = null),
            (r.animType = null),
            (r.animProp = null),
            (r.breakpoints = []),
            (r.breakpointSettings = []),
            (r.cssTransitions = !1),
            (r.focussed = !1),
            (r.interrupted = !1),
            (r.hidden = "hidden"),
            (r.paused = !0),
            (r.positionProp = null),
            (r.respondTo = null),
            (r.rowCount = 1),
            (r.shouldClick = !0),
            (r.$slider = e(t)),
            (r.$slidesCache = null),
            (r.transformType = null),
            (r.transitionType = null),
            (r.visibilityChange = "visibilitychange"),
            (r.windowWidth = 0),
            (r.windowTimer = null),
            (o = e(t).data("slick") || {}),
            (r.options = e.extend({}, r.defaults, i, o)),
            (r.currentSlide = r.options.initialSlide),
            (r.originalSettings = r.options),
            "undefined" != typeof document.mozHidden
              ? ((r.hidden = "mozHidden"), (r.visibilityChange = "mozvisibilitychange"))
              : "undefined" != typeof document.webkitHidden && ((r.hidden = "webkitHidden"), (r.visibilityChange = "webkitvisibilitychange")),
            (r.autoPlay = e.proxy(r.autoPlay, r)),
            (r.autoPlayClear = e.proxy(r.autoPlayClear, r)),
            (r.autoPlayIterator = e.proxy(r.autoPlayIterator, r)),
            (r.changeSlide = e.proxy(r.changeSlide, r)),
            (r.clickHandler = e.proxy(r.clickHandler, r)),
            (r.selectHandler = e.proxy(r.selectHandler, r)),
            (r.setPosition = e.proxy(r.setPosition, r)),
            (r.swipeHandler = e.proxy(r.swipeHandler, r)),
            (r.dragHandler = e.proxy(r.dragHandler, r)),
            (r.keyHandler = e.proxy(r.keyHandler, r)),
            (r.instanceUid = n++),
            (r.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
            r.registerBreakpoints(),
            r.init(!0);
        }
        var n = 0;
        return t;
      })()),
        (t.prototype.activateADA = function () {
          var e = this;
          e.$slideTrack.find(".slick-active").attr({ "aria-hidden": "false" }).find("a, input, button, select").attr({ tabindex: "0" });
        }),
        (t.prototype.addSlide = t.prototype.slickAdd = function (t, n, i) {
          var o = this;
          if ("boolean" == typeof n) (i = n), (n = null);
          else if (n < 0 || n >= o.slideCount) return !1;
          o.unload(),
            "number" == typeof n
              ? 0 === n && 0 === o.$slides.length
                ? e(t).appendTo(o.$slideTrack)
                : i
                ? e(t).insertBefore(o.$slides.eq(n))
                : e(t).insertAfter(o.$slides.eq(n))
              : i === !0
              ? e(t).prependTo(o.$slideTrack)
              : e(t).appendTo(o.$slideTrack),
            (o.$slides = o.$slideTrack.children(this.options.slide)),
            o.$slideTrack.children(this.options.slide).detach(),
            o.$slideTrack.append(o.$slides),
            o.$slides.each(function (t, n) {
              e(n).attr("data-slick-index", t);
            }),
            (o.$slidesCache = o.$slides),
            o.reinit();
        }),
        (t.prototype.animateHeight = function () {
          var e = this;
          if (1 === e.options.slidesToShow && e.options.adaptiveHeight === !0 && e.options.vertical === !1) {
            var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
            e.$list.animate({ height: t }, e.options.speed);
          }
        }),
        (t.prototype.animateSlide = function (t, n) {
          var i = {},
            o = this;
          o.animateHeight(),
            o.options.rtl === !0 && o.options.vertical === !1 && (t = -t),
            o.transformsEnabled === !1
              ? o.options.vertical === !1
                ? o.$slideTrack.animate({ left: t }, o.options.speed, o.options.easing, n)
                : o.$slideTrack.animate({ top: t }, o.options.speed, o.options.easing, n)
              : o.cssTransitions === !1
              ? (o.options.rtl === !0 && (o.currentLeft = -o.currentLeft),
                e({ animStart: o.currentLeft }).animate(
                  { animStart: t },
                  {
                    duration: o.options.speed,
                    easing: o.options.easing,
                    step: function (e) {
                      (e = Math.ceil(e)), o.options.vertical === !1 ? ((i[o.animType] = "translate(" + e + "px, 0px)"), o.$slideTrack.css(i)) : ((i[o.animType] = "translate(0px," + e + "px)"), o.$slideTrack.css(i));
                    },
                    complete: function () {
                      n && n.call();
                    },
                  }
                ))
              : (o.applyTransition(),
                (t = Math.ceil(t)),
                o.options.vertical === !1 ? (i[o.animType] = "translate3d(" + t + "px, 0px, 0px)") : (i[o.animType] = "translate3d(0px," + t + "px, 0px)"),
                o.$slideTrack.css(i),
                n &&
                  setTimeout(function () {
                    o.disableTransition(), n.call();
                  }, o.options.speed));
        }),
        (t.prototype.getNavTarget = function () {
          var t = this,
            n = t.options.asNavFor;
          return n && null !== n && (n = e(n).not(t.$slider)), n;
        }),
        (t.prototype.asNavFor = function (t) {
          var n = this,
            i = n.getNavTarget();
          null !== i &&
            "object" == typeof i &&
            i.each(function () {
              var n = e(this).slick("getSlick");
              n.unslicked || n.slideHandler(t, !0);
            });
        }),
        (t.prototype.applyTransition = function (e) {
          var t = this,
            n = {};
          t.options.fade === !1 ? (n[t.transitionType] = t.transformType + " " + t.options.speed + "ms " + t.options.cssEase) : (n[t.transitionType] = "opacity " + t.options.speed + "ms " + t.options.cssEase),
            t.options.fade === !1 ? t.$slideTrack.css(n) : t.$slides.eq(e).css(n);
        }),
        (t.prototype.autoPlay = function () {
          var e = this;
          e.autoPlayClear(), e.slideCount > e.options.slidesToShow && (e.autoPlayTimer = setInterval(e.autoPlayIterator, e.options.autoplaySpeed));
        }),
        (t.prototype.autoPlayClear = function () {
          var e = this;
          e.autoPlayTimer && clearInterval(e.autoPlayTimer);
        }),
        (t.prototype.autoPlayIterator = function () {
          var e = this,
            t = e.currentSlide + e.options.slidesToScroll;
          e.paused ||
            e.interrupted ||
            e.focussed ||
            (e.options.infinite === !1 &&
              (1 === e.direction && e.currentSlide + 1 === e.slideCount - 1 ? (e.direction = 0) : 0 === e.direction && ((t = e.currentSlide - e.options.slidesToScroll), e.currentSlide - 1 === 0 && (e.direction = 1))),
            e.slideHandler(t));
        }),
        (t.prototype.buildArrows = function () {
          var t = this;
          t.options.arrows === !0 &&
            ((t.$prevArrow = e(t.options.prevArrow).addClass("slick-arrow")),
            (t.$nextArrow = e(t.options.nextArrow).addClass("slick-arrow")),
            t.slideCount > t.options.slidesToShow
              ? (t.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                t.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.prependTo(t.options.appendArrows),
                t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.appendTo(t.options.appendArrows),
                t.options.infinite !== !0 && t.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"))
              : t.$prevArrow.add(t.$nextArrow).addClass("slick-hidden").attr({ "aria-disabled": "true", tabindex: "-1" }));
        }),
        (t.prototype.buildDots = function () {
          var t,
            n,
            i = this;
          if (i.options.dots === !0 && i.slideCount > i.options.slidesToShow) {
            for (i.$slider.addClass("slick-dotted"), n = e("<ul />").addClass(i.options.dotsClass), t = 0; t <= i.getDotCount(); t += 1) n.append(e("<li />").append(i.options.customPaging.call(this, i, t)));
            (i.$dots = n.appendTo(i.options.appendDots)), i.$dots.find("li").first().addClass("slick-active").attr("aria-hidden", "false");
          }
        }),
        (t.prototype.buildOut = function () {
          var t = this;
          (t.$slides = t.$slider.children(t.options.slide + ":not(.slick-cloned)").addClass("slick-slide")),
            (t.slideCount = t.$slides.length),
            t.$slides.each(function (t, n) {
              e(n)
                .attr("data-slick-index", t)
                .data("originalStyling", e(n).attr("style") || "");
            }),
            t.$slider.addClass("slick-slider"),
            (t.$slideTrack = 0 === t.slideCount ? e('<div class="slick-track"/>').appendTo(t.$slider) : t.$slides.wrapAll('<div class="slick-track"/>').parent()),
            (t.$list = t.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent()),
            t.$slideTrack.css("opacity", 0),
            (t.options.centerMode !== !0 && t.options.swipeToSlide !== !0) || (t.options.slidesToScroll = 1),
            t.setupInfinite(),
            t.buildArrows(),
            t.buildDots(),
            t.updateDots(),
            t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0),
            t.options.draggable === !0 && t.$list.addClass("draggable");
        }),
        (t.prototype.buildRows = function () {
          var e,
            t,
            n,
            i,
            o,
            r,
            s,
            a = this;
          if (((i = document.createDocumentFragment()), (r = a.$slider.children()), a.options.rows > 1)) {
            for (s = a.options.slidesPerRow * a.options.rows, o = Math.ceil(r.length / s), e = 0; e < o; e++) {
              var l = document.createElement("div");
              for (t = 0; t < a.options.rows; t++) {
                var c = document.createElement("div");
                for (n = 0; n < a.options.slidesPerRow; n++) {
                  var u = e * s + (t * a.options.slidesPerRow + n);
                  r.get(u) && c.appendChild(r.get(u));
                }
                l.appendChild(c);
              }
              i.appendChild(l);
            }
            a.$slider.empty().append(i),
              a.$slider
                .children()
                .children()
                .children()
                .css({ width: 100 / a.options.slidesPerRow + "%", display: "inline-block" });
          }
        }),
        (t.prototype.checkResponsive = function (t, n) {
          var i,
            o,
            r,
            s = this,
            a = !1,
            l = s.$slider.width(),
            c = window.innerWidth || e(window).width();
          if (("window" === s.respondTo ? (r = c) : "slider" === s.respondTo ? (r = l) : "min" === s.respondTo && (r = Math.min(c, l)), s.options.responsive && s.options.responsive.length && null !== s.options.responsive)) {
            o = null;
            for (i in s.breakpoints) s.breakpoints.hasOwnProperty(i) && (s.originalSettings.mobileFirst === !1 ? r < s.breakpoints[i] && (o = s.breakpoints[i]) : r > s.breakpoints[i] && (o = s.breakpoints[i]));
            null !== o
              ? null !== s.activeBreakpoint
                ? (o !== s.activeBreakpoint || n) &&
                  ((s.activeBreakpoint = o),
                  "unslick" === s.breakpointSettings[o] ? s.unslick(o) : ((s.options = e.extend({}, s.originalSettings, s.breakpointSettings[o])), t === !0 && (s.currentSlide = s.options.initialSlide), s.refresh(t)),
                  (a = o))
                : ((s.activeBreakpoint = o),
                  "unslick" === s.breakpointSettings[o] ? s.unslick(o) : ((s.options = e.extend({}, s.originalSettings, s.breakpointSettings[o])), t === !0 && (s.currentSlide = s.options.initialSlide), s.refresh(t)),
                  (a = o))
              : null !== s.activeBreakpoint && ((s.activeBreakpoint = null), (s.options = s.originalSettings), t === !0 && (s.currentSlide = s.options.initialSlide), s.refresh(t), (a = o)),
              t || a === !1 || s.$slider.trigger("breakpoint", [s, a]);
          }
        }),
        (t.prototype.changeSlide = function (t, n) {
          var i,
            o,
            r,
            s = this,
            a = e(t.currentTarget);
          switch ((a.is("a") && t.preventDefault(), a.is("li") || (a = a.closest("li")), (r = s.slideCount % s.options.slidesToScroll !== 0), (i = r ? 0 : (s.slideCount - s.currentSlide) % s.options.slidesToScroll), t.data.message)) {
            case "previous":
              (o = 0 === i ? s.options.slidesToScroll : s.options.slidesToShow - i), s.slideCount > s.options.slidesToShow && s.slideHandler(s.currentSlide - o, !1, n);
              break;
            case "next":
              (o = 0 === i ? s.options.slidesToScroll : i), s.slideCount > s.options.slidesToShow && s.slideHandler(s.currentSlide + o, !1, n);
              break;
            case "index":
              var l = 0 === t.data.index ? 0 : t.data.index || a.index() * s.options.slidesToScroll;
              s.slideHandler(s.checkNavigable(l), !1, n), a.children().trigger("focus");
              break;
            default:
              return;
          }
        }),
        (t.prototype.checkNavigable = function (e) {
          var t,
            n,
            i = this;
          if (((t = i.getNavigableIndexes()), (n = 0), e > t[t.length - 1])) e = t[t.length - 1];
          else
            for (var o in t) {
              if (e < t[o]) {
                e = n;
                break;
              }
              n = t[o];
            }
          return e;
        }),
        (t.prototype.cleanUpEvents = function () {
          var t = this;
          t.options.dots && null !== t.$dots && e("li", t.$dots).off("click.slick", t.changeSlide).off("mouseenter.slick", e.proxy(t.interrupt, t, !0)).off("mouseleave.slick", e.proxy(t.interrupt, t, !1)),
            t.$slider.off("focus.slick blur.slick"),
            t.options.arrows === !0 && t.slideCount > t.options.slidesToShow && (t.$prevArrow && t.$prevArrow.off("click.slick", t.changeSlide), t.$nextArrow && t.$nextArrow.off("click.slick", t.changeSlide)),
            t.$list.off("touchstart.slick mousedown.slick", t.swipeHandler),
            t.$list.off("touchmove.slick mousemove.slick", t.swipeHandler),
            t.$list.off("touchend.slick mouseup.slick", t.swipeHandler),
            t.$list.off("touchcancel.slick mouseleave.slick", t.swipeHandler),
            t.$list.off("click.slick", t.clickHandler),
            e(document).off(t.visibilityChange, t.visibility),
            t.cleanUpSlideEvents(),
            t.options.accessibility === !0 && t.$list.off("keydown.slick", t.keyHandler),
            t.options.focusOnSelect === !0 && e(t.$slideTrack).children().off("click.slick", t.selectHandler),
            e(window).off("orientationchange.slick.slick-" + t.instanceUid, t.orientationChange),
            e(window).off("resize.slick.slick-" + t.instanceUid, t.resize),
            e("[draggable!=true]", t.$slideTrack).off("dragstart", t.preventDefault),
            e(window).off("load.slick.slick-" + t.instanceUid, t.setPosition),
            e(document).off("ready.slick.slick-" + t.instanceUid, t.setPosition);
        }),
        (t.prototype.cleanUpSlideEvents = function () {
          var t = this;
          t.$list.off("mouseenter.slick", e.proxy(t.interrupt, t, !0)), t.$list.off("mouseleave.slick", e.proxy(t.interrupt, t, !1));
        }),
        (t.prototype.cleanUpRows = function () {
          var e,
            t = this;
          t.options.rows > 1 && ((e = t.$slides.children().children()), e.removeAttr("style"), t.$slider.empty().append(e));
        }),
        (t.prototype.clickHandler = function (e) {
          var t = this;
          t.shouldClick === !1 && (e.stopImmediatePropagation(), e.stopPropagation(), e.preventDefault());
        }),
        (t.prototype.destroy = function (t) {
          var n = this;
          n.autoPlayClear(),
            (n.touchObject = {}),
            n.cleanUpEvents(),
            e(".slick-cloned", n.$slider).detach(),
            n.$dots && n.$dots.remove(),
            n.$prevArrow &&
              n.$prevArrow.length &&
              (n.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), n.htmlExpr.test(n.options.prevArrow) && n.$prevArrow.remove()),
            n.$nextArrow &&
              n.$nextArrow.length &&
              (n.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), n.htmlExpr.test(n.options.nextArrow) && n.$nextArrow.remove()),
            n.$slides &&
              (n.$slides
                .removeClass("slick-slide slick-active slick-center slick-visible slick-current")
                .removeAttr("aria-hidden")
                .removeAttr("data-slick-index")
                .each(function () {
                  e(this).attr("style", e(this).data("originalStyling"));
                }),
              n.$slideTrack.children(this.options.slide).detach(),
              n.$slideTrack.detach(),
              n.$list.detach(),
              n.$slider.append(n.$slides)),
            n.cleanUpRows(),
            n.$slider.removeClass("slick-slider"),
            n.$slider.removeClass("slick-initialized"),
            n.$slider.removeClass("slick-dotted"),
            (n.unslicked = !0),
            t || n.$slider.trigger("destroy", [n]);
        }),
        (t.prototype.disableTransition = function (e) {
          var t = this,
            n = {};
          (n[t.transitionType] = ""), t.options.fade === !1 ? t.$slideTrack.css(n) : t.$slides.eq(e).css(n);
        }),
        (t.prototype.fadeSlide = function (e, t) {
          var n = this;
          n.cssTransitions === !1
            ? (n.$slides.eq(e).css({ zIndex: n.options.zIndex }), n.$slides.eq(e).animate({ opacity: 1 }, 0, n.options.easing, t))
            : (n.applyTransition(e),
              n.$slides.eq(e).css({ opacity: 1, zIndex: n.options.zIndex }),
              t &&
                setTimeout(function () {
                  n.disableTransition(e), t.call();
                }, n.options.speed));
        }),
        (t.prototype.fadeSlideOut = function (e) {
          var t = this;
          t.cssTransitions === !1 ? t.$slides.eq(e).animate({ opacity: 1, zIndex: t.options.zIndex - 2 }, t.options.speed, t.options.easing) : (t.applyTransition(e), t.$slides.eq(e).css({ opacity: 1, zIndex: t.options.zIndex - 2 }));
        }),
        (t.prototype.filterSlides = t.prototype.slickFilter = function (e) {
          var t = this;
          null !== e && ((t.$slidesCache = t.$slides), t.unload(), t.$slideTrack.children(this.options.slide).detach(), t.$slidesCache.filter(e).appendTo(t.$slideTrack), t.reinit());
        }),
        (t.prototype.focusHandler = function () {
          var t = this;
          t.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*:not(.slick-arrow)", function (n) {
            n.stopImmediatePropagation();
            var i = e(this);
            setTimeout(function () {
              t.options.pauseOnFocus && ((t.focussed = i.is(":focus")), t.autoPlay());
            }, 0);
          });
        }),
        (t.prototype.getCurrent = t.prototype.slickCurrentSlide = function () {
          var e = this;
          return e.currentSlide;
        }),
        (t.prototype.getDotCount = function () {
          var e = this,
            t = 0,
            n = 0,
            i = 0;
          if (e.options.infinite === !0) for (; t < e.slideCount; ) ++i, (t = n + e.options.slidesToScroll), (n += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow);
          else if (e.options.centerMode === !0) i = e.slideCount;
          else if (e.options.asNavFor) for (; t < e.slideCount; ) ++i, (t = n + e.options.slidesToScroll), (n += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow);
          else i = 1 + Math.ceil((e.slideCount - e.options.slidesToShow) / e.options.slidesToScroll);
          return i - 1;
        }),
        (t.prototype.getLeft = function (e) {
          var t,
            n,
            i,
            o = this,
            r = 0;
          return (
            (o.slideOffset = 0),
            (n = o.$slides.first().outerHeight(!0)),
            o.options.infinite === !0
              ? (o.slideCount > o.options.slidesToShow && ((o.slideOffset = o.slideWidth * o.options.slidesToShow * -1), (r = n * o.options.slidesToShow * -1)),
                o.slideCount % o.options.slidesToScroll !== 0 &&
                  e + o.options.slidesToScroll > o.slideCount &&
                  o.slideCount > o.options.slidesToShow &&
                  (e > o.slideCount
                    ? ((o.slideOffset = (o.options.slidesToShow - (e - o.slideCount)) * o.slideWidth * -1), (r = (o.options.slidesToShow - (e - o.slideCount)) * n * -1))
                    : ((o.slideOffset = (o.slideCount % o.options.slidesToScroll) * o.slideWidth * -1), (r = (o.slideCount % o.options.slidesToScroll) * n * -1))))
              : e + o.options.slidesToShow > o.slideCount && ((o.slideOffset = (e + o.options.slidesToShow - o.slideCount) * o.slideWidth), (r = (e + o.options.slidesToShow - o.slideCount) * n)),
            o.slideCount <= o.options.slidesToShow && ((o.slideOffset = 0), (r = 0)),
            o.options.centerMode === !0 && o.options.infinite === !0
              ? (o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2) - o.slideWidth)
              : o.options.centerMode === !0 && ((o.slideOffset = 0), (o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2))),
            (t = o.options.vertical === !1 ? e * o.slideWidth * -1 + o.slideOffset : e * n * -1 + r),
            o.options.variableWidth === !0 &&
              ((i = o.slideCount <= o.options.slidesToShow || o.options.infinite === !1 ? o.$slideTrack.children(".slick-slide").eq(e) : o.$slideTrack.children(".slick-slide").eq(e + o.options.slidesToShow)),
              (t = o.options.rtl === !0 ? (i[0] ? (o.$slideTrack.width() - i[0].offsetLeft - i.width()) * -1 : 0) : i[0] ? i[0].offsetLeft * -1 : 0),
              o.options.centerMode === !0 &&
                ((i = o.slideCount <= o.options.slidesToShow || o.options.infinite === !1 ? o.$slideTrack.children(".slick-slide").eq(e) : o.$slideTrack.children(".slick-slide").eq(e + o.options.slidesToShow + 1)),
                (t = o.options.rtl === !0 ? (i[0] ? (o.$slideTrack.width() - i[0].offsetLeft - i.width()) * -1 : 0) : i[0] ? i[0].offsetLeft * -1 : 0),
                (t += (o.$list.width() - i.outerWidth()) / 2))),
            t
          );
        }),
        (t.prototype.getOption = t.prototype.slickGetOption = function (e) {
          var t = this;
          return t.options[e];
        }),
        (t.prototype.getNavigableIndexes = function () {
          var e,
            t = this,
            n = 0,
            i = 0,
            o = [];
          for (t.options.infinite === !1 ? (e = t.slideCount) : ((n = t.options.slidesToScroll * -1), (i = t.options.slidesToScroll * -1), (e = 2 * t.slideCount)); n < e; )
            o.push(n), (n = i + t.options.slidesToScroll), (i += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow);
          return o;
        }),
        (t.prototype.getSlick = function () {
          return this;
        }),
        (t.prototype.getSlideCount = function () {
          var t,
            n,
            i,
            o = this;
          return (
            (i = o.options.centerMode === !0 ? o.slideWidth * Math.floor(o.options.slidesToShow / 2) : 0),
            o.options.swipeToSlide === !0
              ? (o.$slideTrack.find(".slick-slide").each(function (t, r) {
                  if (r.offsetLeft - i + e(r).outerWidth() / 2 > o.swipeLeft * -1) return (n = r), !1;
                }),
                (t = Math.abs(e(n).attr("data-slick-index") - o.currentSlide) || 1))
              : o.options.slidesToScroll
          );
        }),
        (t.prototype.goTo = t.prototype.slickGoTo = function (e, t) {
          var n = this;
          n.changeSlide({ data: { message: "index", index: parseInt(e) } }, t);
        }),
        (t.prototype.init = function (t) {
          var n = this;
          if (
            (e(n.$slider).hasClass("slick-initialized") ||
              (e(n.$slider).addClass("slick-initialized"), n.buildRows(), n.buildOut(), n.setProps(), n.startLoad(), n.loadSlider(), n.initializeEvents(), n.updateArrows(), n.updateDots(), n.checkResponsive(!0), n.focusHandler()),
            t && n.$slider.trigger("init", [n]),
            n.options.accessibility === !0 && n.initADA(),
            n.options.autoplay && ((n.paused = !1), n.autoPlay()),
            n.options.customSlideAdvancement)
          ) {
            var i = n.options.initialSlide ? n.options.initialSlide : 0;
            n.changeSlide({ data: { message: "index", index: parseInt(i) } });
          }
        }),
        (t.prototype.initADA = function () {
          var t = this;
          t.$slides.add(t.$slideTrack.find(".slick-cloned")).attr({ "aria-hidden": "true", tabindex: "-1" }).find("a, input, button, select").attr({ tabindex: "-1" }),
            t.$slideTrack.attr("role", "listbox"),
            t.$slides.not(t.$slideTrack.find(".slick-cloned")).each(function (n) {
              e(this).attr({ role: "option", "aria-describedby": "slick-slide" + t.instanceUid + n });
            }),
            null !== t.$dots &&
              t.$dots
                .attr("role", "tablist")
                .find("li")
                .each(function (n) {
                  e(this).attr({ role: "presentation", "aria-selected": "false", "aria-controls": "navigation" + t.instanceUid + n, id: "slick-slide" + t.instanceUid + n });
                })
                .first()
                .attr("aria-selected", "true")
                .end()
                .find("button")
                .attr("role", "button")
                .end()
                .closest("div")
                .attr("role", "toolbar"),
            t.activateADA();
        }),
        (t.prototype.initArrowEvents = function () {
          var e = this;
          e.options.arrows === !0 &&
            e.slideCount > e.options.slidesToShow &&
            (e.$prevArrow.off("click.slick").on("click.slick", { message: "previous" }, e.changeSlide), e.$nextArrow.off("click.slick").on("click.slick", { message: "next" }, e.changeSlide));
        }),
        (t.prototype.initDotEvents = function () {
          var t = this;
          t.options.dots === !0 && t.slideCount > t.options.slidesToShow && e("li", t.$dots).on("click.slick", { message: "index" }, t.changeSlide),
            t.options.dots === !0 && t.options.pauseOnDotsHover === !0 && e("li", t.$dots).on("mouseenter.slick", e.proxy(t.interrupt, t, !0)).on("mouseleave.slick", e.proxy(t.interrupt, t, !1));
        }),
        (t.prototype.initSlideEvents = function () {
          var t = this;
          t.options.pauseOnHover && (t.$list.on("mouseenter.slick", e.proxy(t.interrupt, t, !0)), t.$list.on("mouseleave.slick", e.proxy(t.interrupt, t, !1)));
        }),
        (t.prototype.initializeEvents = function () {
          var t = this;
          t.initArrowEvents(),
            t.initDotEvents(),
            t.initSlideEvents(),
            t.$list.on("touchstart.slick mousedown.slick", { action: "start" }, t.swipeHandler),
            t.$list.on("touchmove.slick mousemove.slick", { action: "move" }, t.swipeHandler),
            t.$list.on("touchend.slick mouseup.slick", { action: "end" }, t.swipeHandler),
            t.$list.on("touchcancel.slick mouseleave.slick", { action: "end" }, t.swipeHandler),
            t.$list.on("click.slick", t.clickHandler),
            e(document).on(t.visibilityChange, e.proxy(t.visibility, t)),
            t.options.accessibility === !0 && t.$list.on("keydown.slick", t.keyHandler),
            t.options.focusOnSelect === !0 && e(t.$slideTrack).children().on("click.slick", t.selectHandler),
            e(window).on("orientationchange.slick.slick-" + t.instanceUid, e.proxy(t.orientationChange, t)),
            e(window).on("resize.slick.slick-" + t.instanceUid, e.proxy(t.resize, t)),
            e("[draggable!=true]", t.$slideTrack).on("dragstart", t.preventDefault),
            e(window).on("load.slick.slick-" + t.instanceUid, t.setPosition),
            e(document).on("ready.slick.slick-" + t.instanceUid, t.setPosition);
        }),
        (t.prototype.initUI = function () {
          var e = this;
          e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && (e.$prevArrow.show(), e.$nextArrow.show()), e.options.dots === !0 && e.slideCount > e.options.slidesToShow && e.$dots.show();
        }),
        (t.prototype.keyHandler = function (e) {
          var t = this;
          e.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
            (37 === e.keyCode && t.options.accessibility === !0
              ? t.changeSlide({ data: { message: t.options.rtl === !0 ? "next" : "previous" } })
              : 39 === e.keyCode && t.options.accessibility === !0 && t.changeSlide({ data: { message: t.options.rtl === !0 ? "previous" : "next" } }));
        }),
        (t.prototype.loadSlider = function () {
          var e = this;
          e.setPosition(), e.$slideTrack.css({ opacity: 1 }), e.$slider.removeClass("slick-loading"), e.initUI();
        }),
        (t.prototype.next = t.prototype.slickNext = function () {
          var e = this;
          e.changeSlide({ data: { message: "next" } });
        }),
        (t.prototype.orientationChange = function () {
          var e = this;
          e.checkResponsive(), e.setPosition();
        }),
        (t.prototype.pause = t.prototype.slickPause = function () {
          var e = this;
          e.autoPlayClear(), (e.paused = !0);
        }),
        (t.prototype.play = t.prototype.slickPlay = function () {
          var e = this;
          e.autoPlay(), (e.options.autoplay = !0), (e.paused = !1), (e.focussed = !1), (e.interrupted = !1);
        }),
        (t.prototype.postSlide = function (e) {
          var t = this;
          t.unslicked || (t.$slider.trigger("afterChange", [t, e]), (t.animating = !1), t.setPosition(), (t.swipeLeft = null), t.options.autoplay && t.autoPlay(), t.options.accessibility === !0 && t.initADA());
        }),
        (t.prototype.prev = t.prototype.slickPrev = function () {
          var e = this;
          e.changeSlide({ data: { message: "previous" } });
        }),
        (t.prototype.preventDefault = function (e) {
          e.preventDefault();
        }),
        (t.prototype.refresh = function (t) {
          var n,
            i,
            o = this;
          (i = o.slideCount - o.options.slidesToShow),
            !o.options.infinite && o.currentSlide > i && (o.currentSlide = i),
            o.slideCount <= o.options.slidesToShow && (o.currentSlide = 0),
            (n = o.currentSlide),
            o.destroy(!0),
            e.extend(o, o.initials, { currentSlide: n }),
            o.init(),
            t || o.changeSlide({ data: { message: "index", index: n } }, !1);
        }),
        (t.prototype.registerBreakpoints = function () {
          var t,
            n,
            i,
            o = this,
            r = o.options.responsive || null;
          if ("array" === e.type(r) && r.length) {
            o.respondTo = o.options.respondTo || "window";
            for (t in r)
              if (((i = o.breakpoints.length - 1), (n = r[t].breakpoint), r.hasOwnProperty(t))) {
                for (; i >= 0; ) o.breakpoints[i] && o.breakpoints[i] === n && o.breakpoints.splice(i, 1), i--;
                o.breakpoints.push(n), (o.breakpointSettings[n] = r[t].settings);
              }
            o.breakpoints.sort(function (e, t) {
              return o.options.mobileFirst ? e - t : t - e;
            });
          }
        }),
        (t.prototype.reinit = function () {
          var t = this;
          (t.$slides = t.$slideTrack.children(t.options.slide).addClass("slick-slide")),
            (t.slideCount = t.$slides.length),
            t.currentSlide >= t.slideCount && 0 !== t.currentSlide && (t.currentSlide = t.currentSlide - t.options.slidesToScroll),
            t.slideCount <= t.options.slidesToShow && (t.currentSlide = 0),
            t.registerBreakpoints(),
            t.setProps(),
            t.setupInfinite(),
            t.buildArrows(),
            t.updateArrows(),
            t.initArrowEvents(),
            t.buildDots(),
            t.updateDots(),
            t.initDotEvents(),
            t.cleanUpSlideEvents(),
            t.initSlideEvents(),
            t.checkResponsive(!1, !0),
            t.options.focusOnSelect === !0 && e(t.$slideTrack).children().on("click.slick", t.selectHandler),
            t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0),
            t.setPosition(),
            t.focusHandler(),
            (t.paused = !t.options.autoplay),
            t.autoPlay(),
            t.$slider.trigger("reInit", [t]);
        }),
        (t.prototype.resize = function () {
          var t = this;
          e(window).width() !== t.windowWidth &&
            (clearTimeout(t.windowDelay),
            (t.windowDelay = window.setTimeout(function () {
              (t.windowWidth = e(window).width()), t.checkResponsive(), t.unslicked || t.setPosition();
            }, 50)));
        }),
        (t.prototype.removeSlide = t.prototype.slickRemove = function (e, t, n) {
          var i = this;
          return (
            "boolean" == typeof e ? ((t = e), (e = t === !0 ? 0 : i.slideCount - 1)) : (e = t === !0 ? --e : e),
            !(i.slideCount < 1 || e < 0 || e > i.slideCount - 1) &&
              (i.unload(),
              n === !0 ? i.$slideTrack.children().remove() : i.$slideTrack.children(this.options.slide).eq(e).remove(),
              (i.$slides = i.$slideTrack.children(this.options.slide)),
              i.$slideTrack.children(this.options.slide).detach(),
              i.$slideTrack.append(i.$slides),
              (i.$slidesCache = i.$slides),
              void i.reinit())
          );
        }),
        (t.prototype.setCSS = function (e) {
          var t,
            n,
            i = this,
            o = {};
          i.options.rtl === !0 && (e = -e),
            (t = "left" == i.positionProp ? Math.ceil(e) + "px" : "0px"),
            (n = "top" == i.positionProp ? Math.ceil(e) + "px" : "0px"),
            (o[i.positionProp] = e),
            i.transformsEnabled === !1
              ? i.$slideTrack.css(o)
              : ((o = {}),
                i.cssTransitions === !1
                  ? ((o[i.animType] = "translate(" + t + ", " + n + ")"), i.$slideTrack.css(o))
                  : (i.options.customSlideAdvancement !== !0 && (o[i.animType] = "translate3d(" + t + ", " + n + ", 0px)"), i.$slideTrack.css(o)));
        }),
        (t.prototype.setDimensions = function () {
          var e,
            t = this,
            n = t.options.customHeightMatching && t.options.asNavFor;
          n && (e = t.getNavTarget().height()),
            (!n || e < 50) && (e = t.$slides.first().outerHeight(!0) * t.options.slidesToShow),
            t.options.vertical === !1
              ? t.options.centerMode === !0 && t.$list.css({ padding: "0px " + t.options.centerPadding })
              : (t.$list.height(e), t.options.centerMode === !0 && t.$list.css({ padding: t.options.centerPadding + " 0px" })),
            (t.listWidth = t.$list.width()),
            (t.listHeight = t.$list.height()),
            t.options.vertical === !1 && t.options.variableWidth === !1
              ? ((t.slideWidth = Math.ceil(t.listWidth / t.options.slidesToShow)), t.$slideTrack.width(Math.ceil(t.slideWidth * t.$slideTrack.children(".slick-slide").length)))
              : t.options.variableWidth === !0
              ? t.$slideTrack.width(5e3 * t.slideCount)
              : ((t.slideWidth = Math.ceil(t.listWidth)), t.$slideTrack.height(Math.ceil(t.$slides.first().outerHeight(!0) * t.$slideTrack.children(".slick-slide").length)));
          var i = t.$slides.first().outerWidth(!0) - t.$slides.first().width();
          t.options.variableWidth === !1 && t.$slideTrack.children(".slick-slide").width(t.slideWidth - i);
        }),
        (t.prototype.setFade = function () {
          var t,
            n = this;
          n.$slides.each(function (i, o) {
            (t = n.slideWidth * i * -1),
              n.options.rtl === !0 ? e(o).css({ position: "relative", right: t, top: 0, zIndex: n.options.zIndex - 2, opacity: 1 }) : e(o).css({ position: "relative", left: t, top: 0, zIndex: n.options.zIndex - 2, opacity: 1 });
          }),
            n.$slides.eq(n.currentSlide).css({ zIndex: n.options.zIndex - 1, opacity: 1 });
        }),
        (t.prototype.setHeight = function () {
          var e = this;
          if (1 === e.options.slidesToShow && e.options.adaptiveHeight === !0 && e.options.vertical === !1) {
            var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
            e.$list.css("height", t);
          }
        }),
        (t.prototype.setOption = t.prototype.slickSetOption = function () {
          var t,
            n,
            i,
            o,
            r,
            s = this,
            a = !1;
          if (
            ("object" === e.type(arguments[0])
              ? ((i = arguments[0]), (a = arguments[1]), (r = "multiple"))
              : "string" === e.type(arguments[0]) &&
                ((i = arguments[0]), (o = arguments[1]), (a = arguments[2]), "responsive" === arguments[0] && "array" === e.type(arguments[1]) ? (r = "responsive") : "undefined" != typeof arguments[1] && (r = "single")),
            "single" === r)
          )
            s.options[i] = o;
          else if ("multiple" === r)
            e.each(i, function (e, t) {
              s.options[e] = t;
            });
          else if ("responsive" === r)
            for (n in o)
              if ("array" !== e.type(s.options.responsive)) s.options.responsive = [o[n]];
              else {
                for (t = s.options.responsive.length - 1; t >= 0; ) s.options.responsive[t].breakpoint === o[n].breakpoint && s.options.responsive.splice(t, 1), t--;
                s.options.responsive.push(o[n]);
              }
          a && (s.unload(), s.reinit());
        }),
        (t.prototype.setPosition = function () {
          var e = this;
          e.setDimensions(), e.setHeight(), e.options.fade === !1 ? e.setCSS(e.getLeft(e.currentSlide)) : e.setFade(), e.$slider.trigger("setPosition", [e]);
        }),
        (t.prototype.setProps = function () {
          var e = this,
            t = document.body.style;
          (e.positionProp = e.options.vertical === !0 ? "top" : "left"),
            "top" === e.positionProp ? e.$slider.addClass("slick-vertical") : e.$slider.removeClass("slick-vertical"),
            (void 0 === t.WebkitTransition && void 0 === t.MozTransition && void 0 === t.msTransition) || (e.options.useCSS === !0 && (e.cssTransitions = !0)),
            e.options.fade && ("number" == typeof e.options.zIndex ? e.options.zIndex < 3 && (e.options.zIndex = 3) : (e.options.zIndex = e.defaults.zIndex)),
            void 0 !== t.OTransform && ((e.animType = "OTransform"), (e.transformType = "-o-transform"), (e.transitionType = "OTransition"), void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)),
            void 0 !== t.MozTransform && ((e.animType = "MozTransform"), (e.transformType = "-moz-transform"), (e.transitionType = "MozTransition"), void 0 === t.perspectiveProperty && void 0 === t.MozPerspective && (e.animType = !1)),
            void 0 !== t.webkitTransform &&
              ((e.animType = "webkitTransform"), (e.transformType = "-webkit-transform"), (e.transitionType = "webkitTransition"), void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)),
            void 0 !== t.msTransform && ((e.animType = "msTransform"), (e.transformType = "-ms-transform"), (e.transitionType = "msTransition"), void 0 === t.msTransform && (e.animType = !1)),
            void 0 !== t.transform && e.animType !== !1 && ((e.animType = "transform"), (e.transformType = "transform"), (e.transitionType = "transition")),
            (e.transformsEnabled = e.options.useTransform && null !== e.animType && e.animType !== !1);
        }),
        (t.prototype.setSlideClasses = function (e) {
          var t,
            n,
            i,
            o,
            r = this;
          (n = r.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true")),
            r.$slides.eq(e).addClass("slick-current"),
            r.options.centerMode === !0
              ? ((t = Math.floor(r.options.slidesToShow / 2)),
                r.options.infinite === !0 &&
                  (e >= t && e <= r.slideCount - 1 - t
                    ? r.$slides
                        .slice(e - t, e + t + 1)
                        .addClass("slick-active")
                        .attr("aria-hidden", "false")
                    : ((i = r.options.slidesToShow + e),
                      n
                        .slice(i - t + 1, i + t + 2)
                        .addClass("slick-active")
                        .attr("aria-hidden", "false")),
                  0 === e ? n.eq(n.length - 1 - r.options.slidesToShow).addClass("slick-center") : e === r.slideCount - 1 && n.eq(r.options.slidesToShow).addClass("slick-center")),
                r.$slides.eq(e).addClass("slick-center"))
              : e >= 0 && e <= r.slideCount - r.options.slidesToShow
              ? r.$slides
                  .slice(e, e + r.options.slidesToShow)
                  .addClass("slick-active")
                  .attr("aria-hidden", "false")
              : n.length <= r.options.slidesToShow
              ? n.addClass("slick-active").attr("aria-hidden", "false")
              : ((o = r.slideCount % r.options.slidesToShow),
                (i = r.options.infinite === !0 ? r.options.slidesToShow + e : e),
                r.options.slidesToShow == r.options.slidesToScroll && r.slideCount - e < r.options.slidesToShow
                  ? n
                      .slice(i - (r.options.slidesToShow - o), i + o)
                      .addClass("slick-active")
                      .attr("aria-hidden", "false")
                  : n
                      .slice(i, i + r.options.slidesToShow)
                      .addClass("slick-active")
                      .attr("aria-hidden", "false"));
        }),
        (t.prototype.setupInfinite = function () {
          var t,
            n,
            i,
            o = this;
          if ((o.options.fade === !0 && (o.options.centerMode = !1), o.options.infinite === !0 && o.options.fade === !1 && ((n = null), o.slideCount > o.options.slidesToShow))) {
            for (i = o.options.centerMode === !0 ? o.options.slidesToShow + 1 : o.options.slidesToShow, t = o.slideCount; t > o.slideCount - i; t -= 1)
              (n = t - 1),
                e(o.$slides[n])
                  .clone(!0)
                  .attr("id", "")
                  .attr("data-slick-index", n - o.slideCount)
                  .prependTo(o.$slideTrack)
                  .addClass("slick-cloned");
            for (t = 0; t < i; t += 1)
              (n = t),
                e(o.$slides[n])
                  .clone(!0)
                  .attr("id", "")
                  .attr("data-slick-index", n + o.slideCount)
                  .appendTo(o.$slideTrack)
                  .addClass("slick-cloned");
            o.$slideTrack
              .find(".slick-cloned")
              .find("[id]")
              .each(function () {
                e(this).attr("id", "");
              });
          }
        }),
        (t.prototype.interrupt = function (e) {
          var t = this;
          e || t.autoPlay(), (t.interrupted = e);
        }),
        (t.prototype.selectHandler = function (t) {
          var n = this,
            i = e(t.target).is(".slick-slide") ? e(t.target) : e(t.target).parents(".slick-slide"),
            o = parseInt(i.attr("data-slick-index"));
          return o || (o = 0), n.slideCount <= n.options.slidesToShow ? (n.setSlideClasses(o), void n.asNavFor(o)) : void n.slideHandler(o);
        }),
        (t.prototype.slideHandler = function (t, n, i) {
          var o,
            r,
            s,
            a,
            l = null,
            c = this;
          if (((n = n || !1), !((c.animating === !0 && c.options.waitForAnimate === !0) || (c.options.fade === !0 && c.currentSlide === t)))) {
            n === !1 && c.asNavFor(t), (o = t), (l = c.getLeft(o));
            var u = !1;
            if ((c.slideCount <= c.options.slidesToShow && (u = !0), c.options.customSlideAdvancement)) {
              var p = "beside" === c.$slider.data("position"),
                d = c.$slider.find(".slick-slide[data-slick-index=" + o + "]"),
                f = d.length,
                h = c.$slider.find(".slick-track"),
                m = 0,
                v = p ? c.$list.height() : c.$list.width();
              h.find(".slick-slide").each(function () {
                m += p ? e(this).outerHeight(!0) : e(this).outerWidth(!0);
              });
              var g = (p ? h.position().top * -1 : h.position().left * -1, m > v);
              if (g) {
                var y,
                  b,
                  w,
                  x = m - v;
                p ? ((w = f ? d.outerHeight(!0) : 0), (y = f ? d.position().top : 0), (b = y - w)) : ((w = f ? d.outerWidth(!0) : 0), (y = f ? d.position().left : 0), (b = y - w)),
                  b >= 0 && (y = b),
                  (1 !== t && 0 !== t) || (y = 0),
                  y > x && (y = x);
              }
              (l = y * -1), m <= v && (u = !0);
            }
            if (((a = c.getLeft(c.currentSlide)), (c.currentLeft = null === c.swipeLeft ? a : c.swipeLeft), c.options.infinite === !1 && c.options.centerMode === !1 && (t < 0 || t > c.getDotCount() * c.options.slidesToScroll))) {
              if (u) return;
              return void (
                c.options.fade === !1 &&
                ((o = c.currentSlide),
                i !== !0
                  ? c.animateSlide(a, function () {
                      c.postSlide(o);
                    })
                  : c.postSlide(o))
              );
            }
            return c.options.infinite === !1 && c.options.centerMode === !0 && (t < 0 || t > c.slideCount - c.options.slidesToScroll)
              ? void (
                  c.options.fade === !1 &&
                  ((o = c.currentSlide),
                  i !== !0
                    ? c.animateSlide(a, function () {
                        c.postSlide(o);
                      })
                    : c.postSlide(o))
                )
              : (c.options.autoplay && clearInterval(c.autoPlayTimer),
                (r =
                  o < 0
                    ? c.slideCount % c.options.slidesToScroll !== 0
                      ? c.slideCount - (c.slideCount % c.options.slidesToScroll)
                      : c.slideCount + o
                    : o >= c.slideCount
                    ? c.slideCount % c.options.slidesToScroll !== 0
                      ? 0
                      : o - c.slideCount
                    : o),
                (c.animating = !0),
                c.$slider.trigger("beforeChange", [c, c.currentSlide, r]),
                (s = c.currentSlide),
                (c.currentSlide = r),
                c.setSlideClasses(c.currentSlide),
                c.options.vertical && u && (i = !0),
                c.updateDots(),
                c.updateArrows(),
                c.options.fade === !0
                  ? (i !== !0
                      ? (c.fadeSlideOut(s),
                        c.fadeSlide(r, function () {
                          c.postSlide(r);
                        }))
                      : c.postSlide(r),
                    void c.animateHeight())
                  : void (i !== !0
                      ? (0 === r && c.options.vertical && (l = 0),
                        c.animateSlide(l, function () {
                          c.postSlide(r);
                        }))
                      : c.postSlide(r)));
          }
        }),
        (t.prototype.startLoad = function () {
          var e = this;
          e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && (e.$prevArrow.hide(), e.$nextArrow.hide()), e.options.dots === !0 && e.slideCount > e.options.slidesToShow && e.$dots.hide(), e.$slider.addClass("slick-loading");
        }),
        (t.prototype.swipeDirection = function () {
          var e,
            t,
            n,
            i,
            o = this;
          return (
            (e = o.touchObject.startX - o.touchObject.curX),
            (t = o.touchObject.startY - o.touchObject.curY),
            (n = Math.atan2(t, e)),
            (i = Math.round((180 * n) / Math.PI)),
            i < 0 && (i = 360 - Math.abs(i)),
            i <= 45 && i >= 0
              ? o.options.rtl === !1
                ? "left"
                : "right"
              : i <= 360 && i >= 315
              ? o.options.rtl === !1
                ? "left"
                : "right"
              : i >= 135 && i <= 225
              ? o.options.rtl === !1
                ? "right"
                : "left"
              : o.options.verticalSwiping === !0
              ? i >= 35 && i <= 135
                ? "down"
                : "up"
              : "vertical"
          );
        }),
        (t.prototype.swipeEnd = function (e) {
          var t,
            n,
            i = this;
          if (((i.dragging = !1), (i.interrupted = !1), (i.shouldClick = !(i.touchObject.swipeLength > 10)), void 0 === i.touchObject.curX)) return !1;
          if ((i.touchObject.edgeHit === !0 && i.$slider.trigger("edge", [i, i.swipeDirection()]), i.touchObject.swipeLength >= i.touchObject.minSwipe)) {
            switch ((n = i.swipeDirection())) {
              case "left":
              case "down":
                (t = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide + i.getSlideCount()) : i.currentSlide + i.getSlideCount()), (i.currentDirection = 0);
                break;
              case "right":
              case "up":
                (t = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide - i.getSlideCount()) : i.currentSlide - i.getSlideCount()), (i.currentDirection = 1);
            }
            "vertical" != n && (i.slideHandler(t), (i.touchObject = {}), i.$slider.trigger("swipe", [i, n]));
          } else i.touchObject.startX !== i.touchObject.curX && (i.slideHandler(i.currentSlide), (i.touchObject = {}));
        }),
        (t.prototype.swipeHandler = function (e) {
          var t = this;
          if (!(t.options.swipe === !1 || ("ontouchend" in document && t.options.swipe === !1) || (t.options.draggable === !1 && e.type.indexOf("mouse") !== -1)))
            switch (
              ((t.touchObject.fingerCount = e.originalEvent && void 0 !== e.originalEvent.touches ? e.originalEvent.touches.length : 1),
              (t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold),
              t.options.verticalSwiping === !0 && (t.touchObject.minSwipe = t.listHeight / t.options.touchThreshold),
              e.data.action)
            ) {
              case "start":
                t.swipeStart(e);
                break;
              case "move":
                t.swipeMove(e);
                break;
              case "end":
                t.swipeEnd(e);
            }
        }),
        (t.prototype.swipeMove = function (e) {
          var t,
            n,
            i,
            o,
            r,
            s = this;
          return (
            (r = void 0 !== e.originalEvent ? e.originalEvent.touches : null),
            !(!s.dragging || (r && 1 !== r.length)) &&
              ((t = s.getLeft(s.currentSlide)),
              (s.touchObject.curX = void 0 !== r ? r[0].pageX : e.clientX),
              (s.touchObject.curY = void 0 !== r ? r[0].pageY : e.clientY),
              (s.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(s.touchObject.curX - s.touchObject.startX, 2)))),
              s.options.verticalSwiping === !0 && (s.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(s.touchObject.curY - s.touchObject.startY, 2)))),
              (n = s.swipeDirection()),
              "vertical" !== n
                ? (void 0 !== e.originalEvent && s.touchObject.swipeLength > 4 && e.preventDefault(),
                  (o = (s.options.rtl === !1 ? 1 : -1) * (s.touchObject.curX > s.touchObject.startX ? 1 : -1)),
                  s.options.verticalSwiping === !0 && (o = s.touchObject.curY > s.touchObject.startY ? 1 : -1),
                  (i = s.touchObject.swipeLength),
                  (s.touchObject.edgeHit = !1),
                  s.options.infinite === !1 && ((0 === s.currentSlide && "right" === n) || (s.currentSlide >= s.getDotCount() && "left" === n)) && ((i = s.touchObject.swipeLength * s.options.edgeFriction), (s.touchObject.edgeHit = !0)),
                  s.options.vertical === !1 ? (s.swipeLeft = t + i * o) : (s.swipeLeft = t + i * (s.$list.height() / s.listWidth) * o),
                  s.options.verticalSwiping === !0 && (s.swipeLeft = t + i * o),
                  s.options.fade !== !0 && s.options.touchMove !== !1 && (s.animating === !0 ? ((s.swipeLeft = null), !1) : void s.setCSS(s.swipeLeft)))
                : void 0)
          );
        }),
        (t.prototype.swipeStart = function (e) {
          var t,
            n = this;
          return (
            (n.interrupted = !0),
            1 !== n.touchObject.fingerCount || n.slideCount <= n.options.slidesToShow
              ? ((n.touchObject = {}), !1)
              : (void 0 !== e.originalEvent && void 0 !== e.originalEvent.touches && (t = e.originalEvent.touches[0]),
                (n.touchObject.startX = n.touchObject.curX = void 0 !== t ? t.pageX : e.clientX),
                (n.touchObject.startY = n.touchObject.curY = void 0 !== t ? t.pageY : e.clientY),
                void (n.dragging = !0))
          );
        }),
        (t.prototype.unfilterSlides = t.prototype.slickUnfilter = function () {
          var e = this;
          null !== e.$slidesCache && (e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.appendTo(e.$slideTrack), e.reinit());
        }),
        (t.prototype.unload = function () {
          var t = this;
          e(".slick-cloned", t.$slider).remove(),
            t.$dots && t.$dots.remove(),
            t.$prevArrow && t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove(),
            t.$nextArrow && t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove(),
            t.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "");
        }),
        (t.prototype.unslick = function (e) {
          var t = this;
          t.$slider.trigger("unslick", [t, e]), t.destroy();
        }),
        (t.prototype.updateArrows = function () {
          var e,
            t = this;
          (e = Math.floor(t.options.slidesToShow / 2)),
            t.options.arrows === !0 &&
              t.slideCount > t.options.slidesToShow &&
              !t.options.infinite &&
              (t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
              t.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
              0 === t.currentSlide
                ? (t.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), t.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"))
                : t.currentSlide >= t.slideCount - t.options.slidesToShow && t.options.centerMode === !1
                ? (t.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"))
                : t.currentSlide >= t.slideCount - 1 && t.options.centerMode === !0 && (t.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")));
        }),
        (t.prototype.updateDots = function () {
          var e = this;
          null !== e.$dots &&
            (e.$dots.find("li").removeClass("slick-active").attr("aria-hidden", "true"),
            e.$dots
              .find("li")
              .eq(Math.floor(e.currentSlide / e.options.slidesToScroll))
              .addClass("slick-active")
              .attr("aria-hidden", "false"));
        }),
        (t.prototype.visibility = function () {
          var e = this;
          e.options.autoplay && (document[e.hidden] ? (e.interrupted = !0) : (e.interrupted = !1));
        }),
        (e.fn.slick = function () {
          var e,
            n,
            i = this,
            o = arguments[0],
            r = Array.prototype.slice.call(arguments, 1),
            s = i.length;
          for (e = 0; e < s; e++) if (("object" == typeof o || "undefined" == typeof o ? (i[e].slick = new t(i[e], o)) : (n = i[e].slick[o].apply(i[e].slick, r)), "undefined" != typeof n)) return n;
          return i;
        });
    }) /*! lazysizes respimg - v4.0.1 */,
    !(function (e, t) {
      var n = function () {
        t(e.lazySizes), e.removeEventListener("lazyunveilread", n, !0);
      };
      (t = t.bind(null, e, e.document)), "object" == typeof module && module.exports ? t(require("lazysizes"), require("../fix-ios-sizes/fix-ios-sizes")) : e.lazySizes ? n() : e.addEventListener("lazyunveilread", n, !0);
    })(window, function (e, t, n) {
      "use strict";
      var i,
        o = (n && n.cfg) || e.lazySizesConfig,
        r = t.createElement("img"),
        s = "sizes" in r && "srcset" in r,
        a = /\s+\d+h/g,
        l = (function () {
          var e = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
            n = Array.prototype.forEach;
          return function (i) {
            var o = t.createElement("img"),
              r = function (t) {
                var n,
                  i = t.getAttribute(lazySizesConfig.srcsetAttr);
                i && (i.match(e) && ((n = "w" == RegExp.$2 ? RegExp.$1 / RegExp.$3 : RegExp.$3 / RegExp.$1), n && t.setAttribute("data-aspectratio", n)), t.setAttribute(lazySizesConfig.srcsetAttr, i.replace(a, "")));
              },
              s = function (e) {
                var t = e.target.parentNode;
                t && "PICTURE" == t.nodeName && n.call(t.getElementsByTagName("source"), r), r(e.target);
              },
              l = function () {
                o.currentSrc && t.removeEventListener("lazybeforeunveil", s);
              };
            i[1] && (t.addEventListener("lazybeforeunveil", s), (o.onload = l), (o.onerror = l), (o.srcset = "data:,a 1w 1h"), o.complete && l());
          };
        })();
      if (
        (o || ((o = {}), (e.lazySizesConfig = o)),
        o.supportsType ||
          (o.supportsType = function (e) {
            return !e;
          }),
        !e.picturefill && !o.pf)
      ) {
        if (e.HTMLPictureElement && s) return t.msElementsFromPoint && l(navigator.userAgent.match(/Edge\/(\d+)/)), void (o.pf = function () {});
        (o.pf = function (t) {
          var n, o;
          if (!e.picturefill) for (n = 0, o = t.elements.length; o > n; n++) i(t.elements[n]);
        }),
          (i = (function () {
            var r = function (e, t) {
                return e.w - t.w;
              },
              l = /^\s*\d+\.*\d*px\s*$/,
              c = function (e) {
                var t,
                  n,
                  i = e.length,
                  o = e[i - 1],
                  r = 0;
                for (r; i > r; r++)
                  if (((o = e[r]), (o.d = o.w / e.w), o.d >= e.d)) {
                    !o.cached && (t = e[r - 1]) && t.d > e.d - 0.13 * Math.pow(e.d, 2.2) && ((n = Math.pow(t.d - 0.6, 1.6)), t.cached && (t.d += 0.15 * n), t.d + (o.d - e.d) * n > e.d && (o = t));
                    break;
                  }
                return o;
              },
              u = (function () {
                var e,
                  t = /(([^,\s].[^\s]+)\s+(\d+)w)/g,
                  n = /\s/,
                  i = function (t, n, i, o) {
                    e.push({ c: n, u: i, w: 1 * o });
                  };
                return function (o) {
                  return (e = []), (o = o.trim()), o.replace(a, "").replace(t, i), e.length || !o || n.test(o) || e.push({ c: o, u: o, w: 99 }), e;
                };
              })(),
              p = function () {
                p.init ||
                  ((p.init = !0),
                  addEventListener(
                    "resize",
                    (function () {
                      var e,
                        n = t.getElementsByClassName("lazymatchmedia"),
                        o = function () {
                          var e, t;
                          for (e = 0, t = n.length; t > e; e++) i(n[e]);
                        };
                      return function () {
                        clearTimeout(e), (e = setTimeout(o, 66));
                      };
                    })()
                  ));
              },
              d = function (t, i) {
                var r,
                  s = t.getAttribute("srcset") || t.getAttribute(o.srcsetAttr);
                !s && i && (s = t._lazypolyfill ? t._lazypolyfill._set : t.getAttribute(o.srcAttr) || t.getAttribute("src")),
                  (t._lazypolyfill && t._lazypolyfill._set == s) ||
                    ((r = u(s || "")),
                    i && t.parentNode && ((r.isPicture = "PICTURE" == t.parentNode.nodeName.toUpperCase()), r.isPicture && e.matchMedia && (n.aC(t, "lazymatchmedia"), p())),
                    (r._set = s),
                    Object.defineProperty(t, "_lazypolyfill", { value: r, writable: !0 }));
              },
              f = function (t) {
                var i = e.devicePixelRatio || 1,
                  o = n.getX && n.getX(t);
                return Math.min(o || i, 2.5, i);
              },
              h = function (t) {
                return e.matchMedia
                  ? (h = function (e) {
                      return !e || (matchMedia(e) || {}).matches;
                    })(t)
                  : !t;
              },
              m = function (e) {
                var t, i, s, a, u, p, m;
                if (((a = e), d(a, !0), (u = a._lazypolyfill), u.isPicture))
                  for (i = 0, t = e.parentNode.getElementsByTagName("source"), s = t.length; s > i; i++)
                    if (o.supportsType(t[i].getAttribute("type"), e) && h(t[i].getAttribute("media"))) {
                      (a = t[i]), d(a), (u = a._lazypolyfill);
                      break;
                    }
                return (
                  u.length > 1
                    ? ((m = a.getAttribute("sizes") || ""), (m = (l.test(m) && parseInt(m, 10)) || n.gW(e, e.parentNode)), (u.d = f(e)), !u.src || !u.w || u.w < m ? ((u.w = m), (p = c(u.sort(r))), (u.src = p)) : (p = u.src))
                    : (p = u[0]),
                  p
                );
              },
              v = function (e) {
                if (!s || !e.parentNode || "PICTURE" == e.parentNode.nodeName.toUpperCase()) {
                  var t = m(e);
                  t && t.u && e._lazypolyfill.cur != t.u && ((e._lazypolyfill.cur = t.u), (t.cached = !0), e.setAttribute(o.srcAttr, t.u), e.setAttribute("src", t.u));
                }
              };
            return (v.parse = u), v;
          })()),
          o.loadedClass &&
            o.loadingClass &&
            !(function () {
              var e = [];
              ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(function (t) {
                e.push(t + o.loadedClass), e.push(t + o.loadingClass);
              }),
                o.pf({ elements: t.querySelectorAll(e.join(", ")) });
            })();
      }
    }) /*! lazysizes rias - v4.0.1 */,
    !(function (e, t) {
      var n = function () {
        t(e.lazySizes), e.removeEventListener("lazyunveilread", n, !0);
      };
      (t = t.bind(null, e, e.document)), "object" == typeof module && module.exports ? t(require("lazysizes")) : e.lazySizes ? n() : e.addEventListener("lazyunveilread", n, !0);
    })(window, function (e, t, n) {
      "use strict";
      function i(t, n) {
        var i,
          o,
          r,
          s,
          a = e.getComputedStyle(t);
        (o = t.parentNode),
          (s = { isPicture: !(!o || !d.test(o.nodeName || "")) }),
          (r = function (e, n) {
            var i = t.getAttribute("data-" + e);
            if (!i) {
              var o = a.getPropertyValue("--ls-" + e);
              o && (i = o.trim());
            }
            if (i) {
              if ("true" == i) i = !0;
              else if ("false" == i) i = !1;
              else if (p.test(i)) i = parseFloat(i);
              else if ("function" == typeof c[e]) i = c[e](t, i);
              else if (v.test(i))
                try {
                  i = JSON.parse(i);
                } catch (e) {}
              s[e] = i;
            } else e in c && "function" != typeof c[e] ? (s[e] = c[e]) : n && "function" == typeof c[e] && (s[e] = c[e](t, i));
          });
        for (i in c) r(i);
        return (
          n.replace(m, function (e, t) {
            t in s || r(t, !0);
          }),
          s
        );
      }
      function o(e, t) {
        var n = [],
          i = function (e, n) {
            return u[typeof t[n]] ? t[n] : e;
          };
        return (
          (n.srcset = []),
          t.absUrl && (y.setAttribute("href", e), (e = y.href)),
          (e = ((t.prefix || "") + e + (t.postfix || "")).replace(m, i)),
          t.widths.forEach(function (i) {
            var o = t.widthmap[i] || i,
              r = { u: e.replace(f, o).replace(h, t.ratio ? Math.round(i * t.ratio) : ""), w: i };
            n.push(r), n.srcset.push((r.c = r.u + " " + i + "w"));
          }),
          n
        );
      }
      function r(e, n, i) {
        var r = 0,
          s = 0,
          a = i;
        if (e) {
          if ("container" === n.ratio) {
            for (r = a.scrollWidth, s = a.scrollHeight; !((r && s) || a === t); ) (a = a.parentNode), (r = a.scrollWidth), (s = a.scrollHeight);
            r && s && (n.ratio = s / r);
          }
          (e = o(e, n)),
            (e.isPicture = n.isPicture),
            w && "IMG" == i.nodeName.toUpperCase() ? i.removeAttribute(l.srcsetAttr) : i.setAttribute(l.srcsetAttr, e.srcset.join(", ")),
            Object.defineProperty(i, "_lazyrias", { value: e, writable: !0 });
        }
      }
      function s(e, t) {
        var o = i(e, t);
        return c.modifyOptions.call(e, { target: e, details: o, detail: o }), n.fire(e, "lazyriasmodifyoptions", o), o;
      }
      function a(e) {
        return e.getAttribute(e.getAttribute("data-srcattr") || c.srcAttr) || e.getAttribute(l.srcsetAttr) || e.getAttribute(l.srcAttr) || e.getAttribute("data-pfsrcset") || "";
      }
      var l,
        c,
        u = { string: 1, number: 1 },
        p = /^\-*\+*\d+\.*\d*$/,
        d = /^picture$/i,
        f = /\s*\{\s*width\s*\}\s*/i,
        h = /\s*\{\s*height\s*\}\s*/i,
        m = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
        v = /^\[.*\]|\{.*\}$/,
        g = /^(?:auto|\d+(px)?)$/,
        y = t.createElement("a"),
        b = t.createElement("img"),
        w = "srcset" in b && !("sizes" in b),
        x = !!e.HTMLPictureElement && !w;
      !(function () {
        var t,
          i = function () {},
          o = { prefix: "", postfix: "", srcAttr: "data-src", absUrl: !1, modifyOptions: i, widthmap: {}, ratio: !1 };
        (l = (n && n.cfg) || e.lazySizesConfig),
          l || ((l = {}), (e.lazySizesConfig = l)),
          l.supportsType ||
            (l.supportsType = function (e) {
              return !e;
            }),
          l.rias || (l.rias = {}),
          (c = l.rias),
          "widths" in c ||
            ((c.widths = []),
            (function (e) {
              for (var t, n = 0; !t || 3e3 > t; ) (n += 5), n > 30 && (n += 1), (t = 36 * n), e.push(t);
            })(c.widths));
        for (t in o) t in c || (c[t] = o[t]);
      })(),
        addEventListener(
          "lazybeforesizes",
          function (e) {
            if (e.detail.instance == n) {
              var t, i, o, u, p, d, h, m, v, y, b, w, S;
              if (((t = e.target), e.detail.dataAttr && !e.defaultPrevented && !c.disabled && (v = t.getAttribute(l.sizesAttr) || t.getAttribute("sizes")) && g.test(v))) {
                if (((i = a(t)), (o = s(t, i)), (b = f.test(o.prefix) || f.test(o.postfix)), o.isPicture && (u = t.parentNode)))
                  for (p = u.getElementsByTagName("source"), d = 0, h = p.length; h > d; d++) (b || f.test((m = a(p[d])))) && (r(m, o, p[d]), (w = !0));
                b || f.test(i) ? (r(i, o, t), (w = !0)) : w && ((S = []), (S.srcset = []), (S.isPicture = !0), Object.defineProperty(t, "_lazyrias", { value: S, writable: !0 })),
                  w && (x ? t.removeAttribute(l.srcAttr) : "auto" != v && ((y = { width: parseInt(v, 10) }), k({ target: t, detail: y })));
              }
            }
          },
          !0
        );
      var k = (function () {
        var i = function (e, t) {
            return e.w - t.w;
          },
          o = function (e) {
            var t,
              n,
              i = e.length,
              o = e[i - 1],
              r = 0;
            for (r; i > r; r++)
              if (((o = e[r]), (o.d = o.w / e.w), o.d >= e.d)) {
                !o.cached && (t = e[r - 1]) && t.d > e.d - 0.13 * Math.pow(e.d, 2.2) && ((n = Math.pow(t.d - 0.6, 1.6)), t.cached && (t.d += 0.15 * n), t.d + (o.d - e.d) * n > e.d && (o = t));
                break;
              }
            return o;
          },
          r = function (e, t) {
            var i;
            return (
              !e._lazyrias &&
                n.pWS &&
                (i = n.pWS(e.getAttribute(l.srcsetAttr || ""))).length &&
                (Object.defineProperty(e, "_lazyrias", { value: i, writable: !0 }), t && e.parentNode && (i.isPicture = "PICTURE" == e.parentNode.nodeName.toUpperCase())),
              e._lazyrias
            );
          },
          s = function (t) {
            var i = e.devicePixelRatio || 1,
              o = n.getX && n.getX(t);
            return Math.min(o || i, 2.4, i);
          },
          a = function (t, n) {
            var a, l, c, u, p, d;
            if (((p = t._lazyrias), p.isPicture && e.matchMedia))
              for (l = 0, a = t.parentNode.getElementsByTagName("source"), c = a.length; c > l; l++)
                if (r(a[l]) && !a[l].getAttribute("type") && (!(u = a[l].getAttribute("media")) || (matchMedia(u) || {}).matches)) {
                  p = a[l]._lazyrias;
                  break;
                }
            return (!p.w || p.w < n) && ((p.w = n), (p.d = s(t)), (d = o(p.sort(i)))), d;
          },
          c = function (i) {
            if (i.detail.instance == n) {
              var o,
                s = i.target;
              return !w && (e.respimage || e.picturefill || lazySizesConfig.pf)
                ? void t.removeEventListener("lazybeforesizes", c)
                : void (
                    ("_lazyrias" in s || (i.detail.dataAttr && r(s, !0))) &&
                    ((o = a(s, i.detail.width)),
                    o &&
                      o.u &&
                      s._lazyrias.cur != o.u &&
                      ((s._lazyrias.cur = o.u),
                      (o.cached = !0),
                      n.rAF(function () {
                        s.setAttribute(l.srcAttr, o.u), s.setAttribute("src", o.u);
                      })))
                  );
            }
          };
        return x ? (c = function () {}) : addEventListener("lazybeforesizes", c), c;
      })();
    }) /*! lazysizes bgset - v4.0.1 */,
    !(function (e, t) {
      var n = function () {
        t(e.lazySizes), e.removeEventListener("lazyunveilread", n, !0);
      };
      (t = t.bind(null, e, e.document)), "object" == typeof module && module.exports ? t(require("lazysizes")) : e.lazySizes ? n() : e.addEventListener("lazyunveilread", n, !0);
    })(window, function (e, t, n) {
      "use strict";
      if (e.addEventListener) {
        var i = /\s+/g,
          o = /\s*\|\s+|\s+\|\s*/g,
          r = /^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/,
          s = /\(|\)|'/,
          a = { contain: 1, cover: 1 },
          l = function (e) {
            var t = n.gW(e, e.parentNode);
            return (!e._lazysizesWidth || t > e._lazysizesWidth) && (e._lazysizesWidth = t), e._lazysizesWidth;
          },
          c = function (e) {
            var t;
            return (t = (getComputedStyle(e) || { getPropertyValue: function () {} }).getPropertyValue("background-size")), !a[t] && a[e.style.backgroundSize] && (t = e.style.backgroundSize), t;
          },
          u = function (e, n, s) {
            var a = t.createElement("picture"),
              l = n.getAttribute(lazySizesConfig.sizesAttr),
              c = n.getAttribute("data-ratio"),
              u = n.getAttribute("data-optimumx");
            n._lazybgset && n._lazybgset.parentNode == n && n.removeChild(n._lazybgset),
              Object.defineProperty(s, "_lazybgset", { value: n, writable: !0 }),
              Object.defineProperty(n, "_lazybgset", { value: a, writable: !0 }),
              (e = e.replace(i, " ").split(o)),
              (a.style.display = "none"),
              (s.className = lazySizesConfig.lazyClass),
              1 != e.length || l || (l = "auto"),
              e.forEach(function (e) {
                var n = t.createElement("source");
                l && "auto" != l && n.setAttribute("sizes", l),
                  e.match(r) && (n.setAttribute(lazySizesConfig.srcsetAttr, RegExp.$1), RegExp.$2 && n.setAttribute("media", lazySizesConfig.customMedia[RegExp.$2] || RegExp.$2)),
                  a.appendChild(n);
              }),
              l && (s.setAttribute(lazySizesConfig.sizesAttr, l), n.removeAttribute(lazySizesConfig.sizesAttr), n.removeAttribute("sizes")),
              u && s.setAttribute("data-optimumx", u),
              c && s.setAttribute("data-ratio", c),
              a.appendChild(s),
              n.appendChild(a);
          },
          p = function (e) {
            if (e.target._lazybgset) {
              var t = e.target,
                i = t._lazybgset,
                o = t.currentSrc || t.src;
              o && (i.style.backgroundImage = "url(" + (s.test(o) ? JSON.stringify(o) : o) + ")"), t._lazybgsetLoading && (n.fire(i, "_lazyloaded", {}, !1, !0), delete t._lazybgsetLoading);
            }
          };
        addEventListener("lazybeforeunveil", function (e) {
          var i, o, r;
          !e.defaultPrevented &&
            (i = e.target.getAttribute("data-bgset")) &&
            ((r = e.target),
            (o = t.createElement("img")),
            (o.alt = ""),
            (o._lazybgsetLoading = !0),
            (e.detail.firesLoad = !0),
            u(i, r, o),
            setTimeout(function () {
              n.loader.unveil(o),
                n.rAF(function () {
                  n.fire(o, "_lazyloaded", {}, !0, !0), o.complete && p({ target: o });
                });
            }));
        }),
          t.addEventListener("load", p, !0),
          e.addEventListener(
            "lazybeforesizes",
            function (e) {
              if (e.detail.instance == n && e.target._lazybgset && e.detail.dataAttr) {
                var t = e.target._lazybgset,
                  i = c(t);
                a[i] &&
                  ((e.target._lazysizesParentFit = i),
                  n.rAF(function () {
                    e.target.setAttribute("data-parent-fit", i), e.target._lazysizesParentFit && delete e.target._lazysizesParentFit;
                  }));
              }
            },
            !0
          ),
          t.documentElement.addEventListener("lazybeforesizes", function (e) {
            !e.defaultPrevented && e.target._lazybgset && e.detail.instance == n && (e.detail.width = l(e.target._lazybgset));
          });
      }
    }) /*! lazysizes object-fit - v4.1.2 */,
    !(function (e, t) {
      var n = function (i) {
        t(e.lazySizes, i), e.removeEventListener("lazyunveilread", n, !0);
      };
      (t = t.bind(null, e, e.document)), "object" == typeof module && module.exports ? t(require("lazysizes")) : e.lazySizes ? n() : e.addEventListener("lazyunveilread", n, !0);
    })(window, function (e, t, n, i) {
      "use strict";
      function o(e) {
        var t = getComputedStyle(e, null) || {},
          n = t.fontFamily || "",
          i = n.match(c) || "",
          o = (i && n.match(u)) || "";
        return o && (o = o[1]), { fit: (i && i[1]) || "", position: f[o] || o || "center" };
      }
      function r(e, t) {
        var i,
          o,
          r = n.cfg,
          s = e.cloneNode(!1),
          a = s.style,
          l = function () {
            var t = e.currentSrc || e.src;
            t && o !== t && ((o = t), (a.backgroundImage = "url(" + (d.test(t) ? JSON.stringify(t) : t) + ")"), i || ((i = !0), n.rC(s, r.loadingClass), n.aC(s, r.loadedClass)));
          },
          c = function () {
            n.rAF(l);
          };
        (e._lazysizesParentFit = t.fit),
          e.addEventListener("lazyloaded", c, !0),
          e.addEventListener("load", c, !0),
          s.addEventListener("load", function () {
            var e = s.currentSrc || s.src;
            e && e != p && ((s.src = p), (s.srcset = ""));
          }),
          n.rAF(function () {
            var i = e,
              o = e.parentNode;
            "PICTURE" == o.nodeName.toUpperCase() && ((i = o), (o = o.parentNode)),
              n.rC(s, r.loadedClass),
              n.rC(s, r.lazyClass),
              n.aC(s, r.loadingClass),
              n.aC(s, r.objectFitClass || "lazysizes-display-clone"),
              s.getAttribute(r.srcsetAttr) && s.setAttribute(r.srcsetAttr, ""),
              s.getAttribute(r.srcAttr) && s.setAttribute(r.srcAttr, ""),
              (s.src = p),
              (s.srcset = ""),
              (a.backgroundRepeat = "no-repeat"),
              (a.backgroundPosition = t.position),
              (a.backgroundSize = t.fit),
              (i.style.display = "none"),
              e.setAttribute("data-parent-fit", t.fit),
              e.setAttribute("data-parent-container", "prev"),
              o.insertBefore(s, i),
              e._lazysizesParentFit && delete e._lazysizesParentFit,
              e.complete && l();
          });
      }
      var s = t.createElement("a").style,
        a = "objectFit" in s,
        l = a && "objectPosition" in s,
        c = /object-fit["']*\s*:\s*["']*(contain|cover)/,
        u = /object-position["']*\s*:\s*["']*(.+?)(?=($|,|'|"|;))/,
        p = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
        d = /\(|\)|'/,
        f = { center: "center", "50% 50%": "center" };
      if (!a || !l) {
        var h = function (e) {
          if (e.detail.instance == n) {
            var t = e.target,
              i = o(t);
            !i.fit || (a && "center" == i.position) || r(t, i);
          }
        };
        e.addEventListener("lazyunveilread", h, !0), i && i.detail && h(i);
      }
    }) /*! lazysizes parent-fit - v4.1.2 */,
    !(function (e, t) {
      var n = function () {
        t(e.lazySizes), e.removeEventListener("lazyunveilread", n, !0);
      };
      (t = t.bind(null, e, e.document)), "object" == typeof module && module.exports ? t(require("lazysizes")) : e.lazySizes ? n() : e.addEventListener("lazyunveilread", n, !0);
    })(window, function (e, t, n) {
      "use strict";
      if (e.addEventListener) {
        var i = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
          o = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/,
          r = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/,
          s = /^picture$/i,
          a = function (e) {
            return getComputedStyle(e, null) || {};
          },
          l = {
            getParent: function (t, n) {
              var i = t,
                o = t.parentNode;
              return (
                (n && "prev" != n) || !o || !s.test(o.nodeName || "") || (o = o.parentNode),
                "self" != n && (i = "prev" == n ? t.previousElementSibling : n && (o.closest || e.jQuery) ? (o.closest ? o.closest(n) : jQuery(o).closest(n)[0]) || o : o),
                i
              );
            },
            getFit: function (e) {
              var t,
                n,
                i = a(e),
                s = i.content || i.fontFamily,
                c = { fit: e._lazysizesParentFit || e.getAttribute("data-parent-fit") };
              return (
                !c.fit && s && (t = s.match(o)) && (c.fit = t[1]),
                c.fit ? ((n = e._lazysizesParentContainer || e.getAttribute("data-parent-container")), !n && s && (t = s.match(r)) && (n = t[1]), (c.parent = l.getParent(e, n))) : (c.fit = i.objectFit),
                c
              );
            },
            getImageRatio: function (t) {
              var n,
                o,
                r,
                a,
                l,
                c = t.parentNode,
                u = c && s.test(c.nodeName || "") ? c.querySelectorAll("source, img") : [t];
              for (n = 0; n < u.length; n++)
                if (
                  ((t = u[n]),
                  (o = t.getAttribute(lazySizesConfig.srcsetAttr) || t.getAttribute("srcset") || t.getAttribute("data-pfsrcset") || t.getAttribute("data-risrcset") || ""),
                  (r = t._lsMedia || t.getAttribute("media")),
                  (r = lazySizesConfig.customMedia[t.getAttribute("data-media") || r] || r),
                  o && (!r || ((e.matchMedia && matchMedia(r)) || {}).matches))
                ) {
                  (a = parseFloat(t.getAttribute("data-aspectratio"))), !a && (l = o.match(i)) && (a = "w" == l[2] ? l[1] / l[3] : l[3] / l[1]);
                  break;
                }
              return a;
            },
            calculateSize: function (e, t) {
              var n,
                i,
                o,
                r,
                s = this.getFit(e),
                a = s.fit,
                l = s.parent;
              return "width" == a || (("contain" == a || "cover" == a) && (o = this.getImageRatio(e)))
                ? (l ? (t = l.clientWidth) : (l = e), (r = t), "width" == a ? (r = t) : ((i = l.clientHeight), i > 40 && (n = t / i) && (("cover" == a && o > n) || ("contain" == a && n > o)) && (r = t * (o / n))), r)
                : t;
            },
          };
        (n.parentFit = l),
          t.addEventListener("lazybeforesizes", function (e) {
            if (!e.defaultPrevented && e.detail.instance == n) {
              var t = e.target;
              e.detail.width = l.calculateSize(t, e.detail.width);
            }
          });
      }
    }) /*! lazysizes - v4.0.2 */,
    !(function (e, t) {
      var n = t(e, e.document);
      (e.lazySizes = n), "object" == typeof module && module.exports && (module.exports = n);
    })(window, function (e, t) {
      "use strict";
      if (t.getElementsByClassName) {
        var n,
          i,
          o = t.documentElement,
          r = e.Date,
          s = e.HTMLPictureElement,
          a = "addEventListener",
          l = "getAttribute",
          c = e[a],
          u = e.setTimeout,
          p = e.requestAnimationFrame || u,
          d = e.requestIdleCallback,
          f = /^picture$/i,
          h = ["load", "error", "lazyincluded", "_lazyloaded"],
          m = {},
          v = Array.prototype.forEach,
          g = function (e, t) {
            return m[t] || (m[t] = new RegExp("(\\s|^)" + t + "(\\s|$)")), m[t].test(e[l]("class") || "") && m[t];
          },
          y = function (e, t) {
            g(e, t) || e.setAttribute("class", (e[l]("class") || "").trim() + " " + t);
          },
          b = function (e, t) {
            var n;
            (n = g(e, t)) && e.setAttribute("class", (e[l]("class") || "").replace(n, " "));
          },
          w = function (e, t, n) {
            var i = n ? a : "removeEventListener";
            n && w(e, t),
              h.forEach(function (n) {
                e[i](n, t);
              });
          },
          x = function (e, i, o, r, s) {
            var a = t.createEvent("CustomEvent");
            return o || (o = {}), (o.instance = n), a.initCustomEvent(i, !r, !s, o), e.dispatchEvent(a), a;
          },
          k = function (t, n) {
            var o;
            !s && (o = e.picturefill || i.pf) ? o({ reevaluate: !0, elements: [t] }) : n && n.src && (t.src = n.src);
          },
          S = function (e, t) {
            return (getComputedStyle(e, null) || {})[t];
          },
          C = function (e, t, n) {
            for (n = n || e.offsetWidth; n < i.minSize && t && !e._lazysizesWidth; ) (n = t.offsetWidth), (t = t.parentNode);
            return n;
          },
          T = (function () {
            var e,
              n,
              i = [],
              o = [],
              r = i,
              s = function () {
                var t = r;
                for (r = i.length ? o : i, e = !0, n = !1; t.length; ) t.shift()();
                e = !1;
              },
              a = function (i, o) {
                e && !o ? i.apply(this, arguments) : (r.push(i), n || ((n = !0), (t.hidden ? u : p)(s)));
              };
            return (a._lsFlush = s), a;
          })(),
          E = function (e, t) {
            return t
              ? function () {
                  T(e);
                }
              : function () {
                  var t = this,
                    n = arguments;
                  T(function () {
                    e.apply(t, n);
                  });
                };
          },
          _ = function (e) {
            var t,
              n = 0,
              o = i.throttleDelay,
              s = i.ricTimeout,
              a = function () {
                (t = !1), (n = r.now()), e();
              },
              l =
                d && s > 49
                  ? function () {
                      d(a, { timeout: s }), s !== i.ricTimeout && (s = i.ricTimeout);
                    }
                  : E(function () {
                      u(a);
                    }, !0);
            return function (e) {
              var i;
              (e = !0 === e) && (s = 33), t || ((t = !0), (i = o - (r.now() - n)), i < 0 && (i = 0), e || i < 9 ? l() : u(l, i));
            };
          },
          A = function (e) {
            var t,
              n,
              i = 99,
              o = function () {
                (t = null), e();
              },
              s = function () {
                var e = r.now() - n;
                e < i ? u(s, i - e) : (d || o)(o);
              };
            return function () {
              (n = r.now()), t || (t = u(s, i));
            };
          };
        !(function () {
          var t,
            n = {
              lazyClass: "lazyload",
              loadedClass: "lazyloaded",
              loadingClass: "lazyloading",
              preloadClass: "lazypreload",
              errorClass: "lazyerror",
              autosizesClass: "lazyautosizes",
              srcAttr: "data-src",
              srcsetAttr: "data-srcset",
              sizesAttr: "data-sizes",
              minSize: 40,
              customMedia: {},
              init: !0,
              expFactor: 1.5,
              hFac: 0.8,
              loadMode: 2,
              loadHidden: !0,
              ricTimeout: 0,
              throttleDelay: 125,
            };
          i = e.lazySizesConfig || e.lazysizesConfig || {};
          for (t in n) t in i || (i[t] = n[t]);
          (e.lazySizesConfig = i),
            u(function () {
              i.init && N();
            });
        })();
        var P = (function () {
            var s,
              p,
              d,
              h,
              m,
              C,
              P,
              N,
              I,
              $,
              D,
              L,
              z,
              M,
              j = /^img$/i,
              H = /^iframe$/i,
              F = "onscroll" in e && !/glebot/.test(navigator.userAgent),
              R = 0,
              q = 0,
              B = 0,
              W = -1,
              U = function (e) {
                B--, e && e.target && w(e.target, U), (!e || B < 0 || !e.target) && (B = 0);
              },
              Z = function (e, n) {
                var i,
                  r = e,
                  s = "hidden" == S(t.body, "visibility") || "hidden" != S(e, "visibility");
                for (N -= n, D += n, I -= n, $ += n; s && (r = r.offsetParent) && r != t.body && r != o; )
                  (s = (S(r, "opacity") || 1) > 0) && "visible" != S(r, "overflow") && ((i = r.getBoundingClientRect()), (s = $ > i.left && I < i.right && D > i.top - 1 && N < i.bottom + 1));
                return s;
              },
              K = function () {
                var e,
                  r,
                  a,
                  c,
                  u,
                  d,
                  f,
                  m,
                  v,
                  g = n.elements;
                if ((h = i.loadMode) && B < 8 && (e = g.length)) {
                  (r = 0),
                    W++,
                    null == z && ("expand" in i || (i.expand = o.clientHeight > 500 && o.clientWidth > 500 ? 500 : 370), (L = i.expand), (z = L * i.expFactor)),
                    q < z && B < 1 && W > 2 && h > 2 && !t.hidden ? ((q = z), (W = 0)) : (q = h > 1 && W > 1 && B < 6 ? L : R);
                  for (; r < e; r++)
                    if (g[r] && !g[r]._lazyRace)
                      if (F)
                        if (
                          (((m = g[r][l]("data-expand")) && (d = 1 * m)) || (d = q),
                          v !== d && ((C = innerWidth + d * M), (P = innerHeight + d), (f = -1 * d), (v = d)),
                          (a = g[r].getBoundingClientRect()),
                          (D = a.bottom) >= f &&
                            (N = a.top) <= P &&
                            ($ = a.right) >= f * M &&
                            (I = a.left) <= C &&
                            (D || $ || I || N) &&
                            (i.loadHidden || "hidden" != S(g[r], "visibility")) &&
                            ((p && B < 3 && !m && (h < 3 || W < 4)) || Z(g[r], d)))
                        ) {
                          if ((te(g[r]), (u = !0), B > 9)) break;
                        } else !u && p && !c && B < 4 && W < 4 && h > 2 && (s[0] || i.preloadAfterLoad) && (s[0] || (!m && (D || $ || I || N || "auto" != g[r][l](i.sizesAttr)))) && (c = s[0] || g[r]);
                      else te(g[r]);
                  c && !u && te(c);
                }
              },
              V = _(K),
              X = function (e) {
                y(e.target, i.loadedClass), b(e.target, i.loadingClass), w(e.target, G), x(e.target, "lazyloaded");
              },
              Y = E(X),
              G = function (e) {
                Y({ target: e.target });
              },
              J = function (e, t) {
                try {
                  e.contentWindow.location.replace(t);
                } catch (n) {
                  e.src = t;
                }
              },
              Q = function (e) {
                var t,
                  n = e[l](i.srcsetAttr);
                (t = i.customMedia[e[l]("data-media") || e[l]("media")]) && e.setAttribute("media", t), n && e.setAttribute("srcset", n);
              },
              ee = E(function (e, t, n, o, r) {
                var s, a, c, p, h, m;
                (h = x(e, "lazybeforeunveil", t)).defaultPrevented ||
                  (o && (n ? y(e, i.autosizesClass) : e.setAttribute("sizes", o)),
                  (a = e[l](i.srcsetAttr)),
                  (s = e[l](i.srcAttr)),
                  r && ((c = e.parentNode), (p = c && f.test(c.nodeName || ""))),
                  (m = t.firesLoad || ("src" in e && (a || s || p))),
                  (h = { target: e }),
                  m && (w(e, U, !0), clearTimeout(d), (d = u(U, 2500)), y(e, i.loadingClass), w(e, G, !0)),
                  p && v.call(c.getElementsByTagName("source"), Q),
                  a ? e.setAttribute("srcset", a) : s && !p && (H.test(e.nodeName) ? J(e, s) : (e.src = s)),
                  r && (a || p) && k(e, { src: s })),
                  e._lazyRace && delete e._lazyRace,
                  b(e, i.lazyClass),
                  T(function () {
                    (!m || (e.complete && e.naturalWidth > 1)) && (m ? U(h) : B--, X(h));
                  }, !0);
              }),
              te = function (e) {
                var t,
                  n = j.test(e.nodeName),
                  o = n && (e[l](i.sizesAttr) || e[l]("sizes")),
                  r = "auto" == o;
                ((!r && p) || !n || (!e[l]("src") && !e.srcset) || e.complete || g(e, i.errorClass) || !g(e, i.lazyClass)) &&
                  ((t = x(e, "lazyunveilread").detail), r && O.updateElem(e, !0, e.offsetWidth), (e._lazyRace = !0), B++, ee(e, t, r, o, n));
              },
              ne = function () {
                if (!p) {
                  if (r.now() - m < 999) return void u(ne, 999);
                  var e = A(function () {
                    (i.loadMode = 3), V();
                  });
                  (p = !0),
                    (i.loadMode = 3),
                    V(),
                    c(
                      "scroll",
                      function () {
                        3 == i.loadMode && (i.loadMode = 2), e();
                      },
                      !0
                    );
                }
              };
            return {
              _: function () {
                (m = r.now()),
                  (n.elements = t.getElementsByClassName(i.lazyClass)),
                  (s = t.getElementsByClassName(i.lazyClass + " " + i.preloadClass)),
                  (M = i.hFac),
                  c("scroll", V, !0),
                  c("resize", V, !0),
                  e.MutationObserver ? new MutationObserver(V).observe(o, { childList: !0, subtree: !0, attributes: !0 }) : (o[a]("DOMNodeInserted", V, !0), o[a]("DOMAttrModified", V, !0), setInterval(V, 999)),
                  c("hashchange", V, !0),
                  ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (e) {
                    t[a](e, V, !0);
                  }),
                  /d$|^c/.test(t.readyState) ? ne() : (c("load", ne), t[a]("DOMContentLoaded", V), u(ne, 2e4)),
                  n.elements.length ? (K(), T._lsFlush()) : V();
              },
              checkElems: V,
              unveil: te,
            };
          })(),
          O = (function () {
            var e,
              n = E(function (e, t, n, i) {
                var o, r, s;
                if (((e._lazysizesWidth = i), (i += "px"), e.setAttribute("sizes", i), f.test(t.nodeName || ""))) for (o = t.getElementsByTagName("source"), r = 0, s = o.length; r < s; r++) o[r].setAttribute("sizes", i);
                n.detail.dataAttr || k(e, n.detail);
              }),
              o = function (e, t, i) {
                var o,
                  r = e.parentNode;
                r && ((i = C(e, r, i)), (o = x(e, "lazybeforesizes", { width: i, dataAttr: !!t })), o.defaultPrevented || ((i = o.detail.width) && i !== e._lazysizesWidth && n(e, r, o, i)));
              },
              r = function () {
                var t,
                  n = e.length;
                if (n) for (t = 0; t < n; t++) o(e[t]);
              },
              s = A(r);
            return {
              _: function () {
                (e = t.getElementsByClassName(i.autosizesClass)), c("resize", s);
              },
              checkElems: s,
              updateElem: o,
            };
          })(),
          N = function () {
            N.i || ((N.i = !0), O._(), P._());
          };
        return (n = { cfg: i, autoSizer: O, loader: P, init: N, uP: k, aC: y, rC: b, hC: g, fire: x, gW: C, rAF: T });
      }
    }),
    !(function (e, t) {
      "object" == typeof exports && "object" == typeof module ? (module.exports = t()) : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? (exports.Handlebars = t()) : (e.Handlebars = t());
    })(this, function () {
      return (function (e) {
        function t(i) {
          if (n[i]) return n[i].exports;
          var o = (n[i] = { exports: {}, id: i, loaded: !1 });
          return e[i].call(o.exports, o, o.exports, t), (o.loaded = !0), o.exports;
        }
        var n = {};
        return (t.m = e), (t.c = n), (t.p = ""), t(0);
      })([
        function (e, t, n) {
          "use strict";
          function i(e) {
            return e && e.__esModule ? e : { default: e };
          }
          function o() {
            var e = g();
            return (
              (e.compile = function (t, n) {
                return u.compile(t, n, e);
              }),
              (e.precompile = function (t, n) {
                return u.precompile(t, n, e);
              }),
              (e.AST = l.default),
              (e.Compiler = u.Compiler),
              (e.JavaScriptCompiler = d.default),
              (e.Parser = c.parser),
              (e.parse = c.parse),
              e
            );
          }
          t.__esModule = !0;
          var r = n(1),
            s = i(r),
            a = n(19),
            l = i(a),
            c = n(20),
            u = n(25),
            p = n(26),
            d = i(p),
            f = n(23),
            h = i(f),
            m = n(18),
            v = i(m),
            g = s.default.create,
            y = o();
          (y.create = o), v.default(y), (y.Visitor = h.default), (y.default = y), (t.default = y), (e.exports = t.default);
        },
        function (e, t, n) {
          "use strict";
          function i(e) {
            return e && e.__esModule ? e : { default: e };
          }
          function o(e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            return (t.default = e), t;
          }
          function r() {
            var e = new a.HandlebarsEnvironment();
            return (
              f.extend(e, a),
              (e.SafeString = c.default),
              (e.Exception = p.default),
              (e.Utils = f),
              (e.escapeExpression = f.escapeExpression),
              (e.VM = m),
              (e.template = function (t) {
                return m.template(t, e);
              }),
              e
            );
          }
          t.__esModule = !0;
          var s = n(2),
            a = o(s),
            l = n(16),
            c = i(l),
            u = n(4),
            p = i(u),
            d = n(3),
            f = o(d),
            h = n(17),
            m = o(h),
            v = n(18),
            g = i(v),
            y = r();
          (y.create = r), g.default(y), (y.default = y), (t.default = y), (e.exports = t.default);
        },
        function (e, t, n) {
          "use strict";
          function i(e) {
            return e && e.__esModule ? e : { default: e };
          }
          function o(e, t, n) {
            (this.helpers = e || {}), (this.partials = t || {}), (this.decorators = n || {}), l.registerDefaultHelpers(this), c.registerDefaultDecorators(this);
          }
          (t.__esModule = !0), (t.HandlebarsEnvironment = o);
          var r = n(3),
            s = n(4),
            a = i(s),
            l = n(5),
            c = n(13),
            u = n(15),
            p = i(u),
            d = "4.0.5";
          t.VERSION = d;
          var f = 7;
          t.COMPILER_REVISION = f;
          var h = { 1: "<= 1.0.rc.2", 2: "== 1.0.0-rc.3", 3: "== 1.0.0-rc.4", 4: "== 1.x.x", 5: "== 2.0.0-alpha.x", 6: ">= 2.0.0-beta.1", 7: ">= 4.0.0" };
          t.REVISION_CHANGES = h;
          var m = "[object Object]";
          o.prototype = {
            constructor: o,
            logger: p.default,
            log: p.default.log,
            registerHelper: function (e, t) {
              if (r.toString.call(e) === m) {
                if (t) throw new a.default("Arg not supported with multiple helpers");
                r.extend(this.helpers, e);
              } else this.helpers[e] = t;
            },
            unregisterHelper: function (e) {
              delete this.helpers[e];
            },
            registerPartial: function (e, t) {
              if (r.toString.call(e) === m) r.extend(this.partials, e);
              else {
                if ("undefined" == typeof t) throw new a.default('Attempting to register a partial called "' + e + '" as undefined');
                this.partials[e] = t;
              }
            },
            unregisterPartial: function (e) {
              delete this.partials[e];
            },
            registerDecorator: function (e, t) {
              if (r.toString.call(e) === m) {
                if (t) throw new a.default("Arg not supported with multiple decorators");
                r.extend(this.decorators, e);
              } else this.decorators[e] = t;
            },
            unregisterDecorator: function (e) {
              delete this.decorators[e];
            },
          };
          var v = p.default.log;
          (t.log = v), (t.createFrame = r.createFrame), (t.logger = p.default);
        },
        function (e, t) {
          "use strict";
          function n(e) {
            return l[e];
          }
          function i(e) {
            for (var t = 1; t < arguments.length; t++) for (var n in arguments[t]) Object.prototype.hasOwnProperty.call(arguments[t], n) && (e[n] = arguments[t][n]);
            return e;
          }
          function o(e, t) {
            for (var n = 0, i = e.length; i > n; n++) if (e[n] === t) return n;
            return -1;
          }
          function r(e) {
            if ("string" != typeof e) {
              if (e && e.toHTML) return e.toHTML();
              if (null == e) return "";
              if (!e) return e + "";
              e = "" + e;
            }
            return u.test(e) ? e.replace(c, n) : e;
          }
          function s(e) {
            return (!e && 0 !== e) || !(!f(e) || 0 !== e.length);
          }
          function a(e) {
            var t = i({}, e);
            return (t._parent = e), t;
          }
          (t.__esModule = !0), (t.extend = i), (t.indexOf = o), (t.escapeExpression = r), (t.isEmpty = s), (t.createFrame = a);
          var l = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#x27;", "`": "&#x60;", "=": "&#x3D;" },
            c = /[&<>"'`=]/g,
            u = /[&<>"'`=]/,
            p = Object.prototype.toString;
          t.toString = p;
          var d = function (e) {
            return "function" == typeof e;
          };
          d(/x/) &&
            (t.isFunction = d = function (e) {
              return "function" == typeof e && "[object Function]" === p.call(e);
            }),
            (t.isFunction = d);
          var f =
            Array.isArray ||
            function (e) {
              return !(!e || "object" != typeof e) && "[object Array]" === p.call(e);
            };
          t.isArray = f;
        },
        function (e, t) {
          "use strict";
          function n(e, t) {
            var o = t && t.loc,
              r = void 0,
              s = void 0;
            o && ((r = o.start.line), (s = o.start.column), (e += " - " + r + ":" + s));
            for (var a = Error.prototype.constructor.call(this, e), l = 0; l < i.length; l++) this[i[l]] = a[i[l]];
            Error.captureStackTrace && Error.captureStackTrace(this, n);
            try {
              o && ((this.lineNumber = r), Object.defineProperty ? Object.defineProperty(this, "column", { value: s }) : (this.column = s));
            } catch (e) {}
          }
          t.__esModule = !0;
          var i = ["description", "fileName", "lineNumber", "message", "name", "number", "stack"];
          (n.prototype = new Error()), (t.default = n), (e.exports = t.default);
        },
        function (e, t, n) {
          "use strict";
          function i(e) {
            return e && e.__esModule ? e : { default: e };
          }
          function o(e) {
            s.default(e), l.default(e), u.default(e), d.default(e), h.default(e), v.default(e), y.default(e);
          }
          (t.__esModule = !0), (t.registerDefaultHelpers = o);
          var r = n(6),
            s = i(r),
            a = n(7),
            l = i(a),
            c = n(8),
            u = i(c),
            p = n(9),
            d = i(p),
            f = n(10),
            h = i(f),
            m = n(11),
            v = i(m),
            g = n(12),
            y = i(g);
        },
        function (e, t, n) {
          "use strict";
          t.__esModule = !0;
          var i = n(3);
          (t.default = function (e) {
            e.registerHelper("blockHelperMissing", function (t, n) {
              var o = n.inverse,
                r = n.fn;
              return t === !0 ? r(this) : t === !1 || null == t ? o(this) : i.isArray(t) ? (t.length > 0 ? e.helpers.each(t, n) : o(this)) : r(t, n);
            });
          }),
            (e.exports = t.default);
        },
        function (e, t, n) {
          "use strict";
          function i(e) {
            return e && e.__esModule ? e : { default: e };
          }
          t.__esModule = !0;
          var o = n(3),
            r = n(4),
            s = i(r);
          (t.default = function (e) {
            e.registerHelper("each", function (e, t) {
              function n(t, n, o) {
                c && ((c.key = t), (c.index = n), (c.first = 0 === n), (c.last = !!o)), (l += i(e[t], { data: c, blockParams: [e[t], t] }));
              }
              if (!t) throw new s.default("Must pass iterator to #each");
              var i = t.fn,
                r = t.inverse,
                a = 0,
                l = "",
                c = void 0;
              if ((o.isFunction(e) && (e = e.call(this)), t.data && (c = o.createFrame(t.data)), e && "object" == typeof e))
                if (o.isArray(e)) for (var u = e.length; u > a; a++) a in e && n(a, a, a === e.length - 1);
                else {
                  var p = void 0;
                  for (var d in e) e.hasOwnProperty(d) && (void 0 !== p && n(p, a - 1), (p = d), a++);
                  void 0 !== p && n(p, a - 1, !0);
                }
              return 0 === a && (l = r(this)), l;
            });
          }),
            (e.exports = t.default);
        },
        function (e, t, n) {
          "use strict";
          function i(e) {
            return e && e.__esModule ? e : { default: e };
          }
          t.__esModule = !0;
          var o = n(4),
            r = i(o);
          (t.default = function (e) {
            e.registerHelper("helperMissing", function () {
              if (1 !== arguments.length) throw new r.default('Missing helper: "' + arguments[arguments.length - 1].name + '"');
            });
          }),
            (e.exports = t.default);
        },
        function (e, t, n) {
          "use strict";
          t.__esModule = !0;
          var i = n(3);
          (t.default = function (e) {
            e.registerHelper("if", function (e, t) {
              return i.isFunction(e) && (e = e.call(this)), (!t.hash.includeZero && !e) || i.isEmpty(e) ? t.inverse(this) : t.fn(this);
            }),
              e.registerHelper("unless", function (t, n) {
                return e.helpers.if.call(this, t, { fn: n.inverse, inverse: n.fn, hash: n.hash });
              });
          }),
            (e.exports = t.default);
        },
        function (e, t) {
          "use strict";
          (t.__esModule = !0),
            (t.default = function (e) {
              e.registerHelper("log", function () {
                for (var t = [void 0], n = arguments[arguments.length - 1], i = 0; i < arguments.length - 1; i++) t.push(arguments[i]);
                var o = 1;
                null != n.hash.level ? (o = n.hash.level) : n.data && null != n.data.level && (o = n.data.level), (t[0] = o), e.log.apply(e, t);
              });
            }),
            (e.exports = t.default);
        },
        function (e, t) {
          "use strict";
          (t.__esModule = !0),
            (t.default = function (e) {
              e.registerHelper("lookup", function (e, t) {
                return e && e[t];
              });
            }),
            (e.exports = t.default);
        },
        function (e, t, n) {
          "use strict";
          t.__esModule = !0;
          var i = n(3);
          (t.default = function (e) {
            e.registerHelper("with", function (e, t) {
              i.isFunction(e) && (e = e.call(this));
              var n = t.fn;
              if (i.isEmpty(e)) return t.inverse(this);
              var o = t.data;
              return n(e, { data: o, blockParams: [e] });
            });
          }),
            (e.exports = t.default);
        },
        function (e, t, n) {
          "use strict";
          function i(e) {
            return e && e.__esModule ? e : { default: e };
          }
          function o(e) {
            s.default(e);
          }
          (t.__esModule = !0), (t.registerDefaultDecorators = o);
          var r = n(14),
            s = i(r);
        },
        function (e, t, n) {
          "use strict";
          t.__esModule = !0;
          var i = n(3);
          (t.default = function (e) {
            e.registerDecorator("inline", function (e, t, n, o) {
              var r = e;
              return (
                t.partials ||
                  ((t.partials = {}),
                  (r = function (o, r) {
                    var s = n.partials;
                    n.partials = i.extend({}, s, t.partials);
                    var a = e(o, r);
                    return (n.partials = s), a;
                  })),
                (t.partials[o.args[0]] = o.fn),
                r
              );
            });
          }),
            (e.exports = t.default);
        },
        function (e, t, n) {
          "use strict";
          t.__esModule = !0;
          var i = n(3),
            o = {
              methodMap: ["debug", "info", "warn", "error"],
              level: "info",
              lookupLevel: function (e) {
                if ("string" == typeof e) {
                  var t = i.indexOf(o.methodMap, e.toLowerCase());
                  e = t >= 0 ? t : parseInt(e, 10);
                }
                return e;
              },
              log: function (e) {
                if (((e = o.lookupLevel(e)), "undefined" != typeof console && o.lookupLevel(o.level) <= e)) {
                  var t = o.methodMap[e];
                  console[t] || (t = "log");
                  for (var n = arguments.length, i = Array(n > 1 ? n - 1 : 0), r = 1; n > r; r++) i[r - 1] = arguments[r];
                  console[t].apply(console, i);
                }
              },
            };
          (t.default = o), (e.exports = t.default);
        },
        function (e, t) {
          "use strict";
          function n(e) {
            this.string = e;
          }
          (t.__esModule = !0),
            (n.prototype.toString = n.prototype.toHTML = function () {
              return "" + this.string;
            }),
            (t.default = n),
            (e.exports = t.default);
        },
        function (e, t, n) {
          "use strict";
          function i(e) {
            return e && e.__esModule ? e : { default: e };
          }
          function o(e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            return (t.default = e), t;
          }
          function r(e) {
            var t = (e && e[0]) || 1,
              n = g.COMPILER_REVISION;
            if (t !== n) {
              if (n > t) {
                var i = g.REVISION_CHANGES[n],
                  o = g.REVISION_CHANGES[t];
                throw new v.default(
                  "Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" + i + ") or downgrade your runtime to an older version (" + o + ")."
                );
              }
              throw new v.default("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" + e[1] + ").");
            }
          }
          function s(e, t) {
            function n(n, i, o) {
              o.hash && (i = h.extend({}, i, o.hash)), (n = t.VM.resolvePartial.call(this, n, i, o));
              var r = t.VM.invokePartial.call(this, n, i, o);
              if ((null == r && t.compile && ((o.partials[o.name] = t.compile(n, e.compilerOptions, t)), (r = o.partials[o.name](i, o))), null != r)) {
                if (o.indent) {
                  for (var s = r.split("\n"), a = 0, l = s.length; l > a && (s[a] || a + 1 !== l); a++) s[a] = o.indent + s[a];
                  r = s.join("\n");
                }
                return r;
              }
              throw new v.default("The partial " + o.name + " could not be compiled when running in runtime-only mode");
            }
            function i(t) {
              function n(t) {
                return "" + e.main(r, t, r.helpers, r.partials, s, l, a);
              }
              var i = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1],
                s = i.data;
              o(i), !i.partial && e.useData && (s = p(t, s));
              var a = void 0,
                l = e.useBlockParams ? [] : void 0;
              return e.useDepths && (a = i.depths ? (t != i.depths[0] ? [t].concat(i.depths) : i.depths) : [t]), (n = d(e.main, n, r, i.depths || [], s, l))(t, i);
            }
            function o(n) {
              n.partial
                ? ((r.helpers = n.helpers), (r.partials = n.partials), (r.decorators = n.decorators))
                : ((r.helpers = r.merge(n.helpers, t.helpers)), e.usePartial && (r.partials = r.merge(n.partials, t.partials)), (e.usePartial || e.useDecorators) && (r.decorators = r.merge(n.decorators, t.decorators)));
            }
            if (!t) throw new v.default("No environment passed to template");
            if (!e || !e.main) throw new v.default("Unknown template object: " + typeof e);
            (e.main.decorator = e.main_d), t.VM.checkRevision(e.compiler);
            var r = {
              strict: function (e, t) {
                if (!(t in e)) throw new v.default('"' + t + '" not defined in ' + e);
                return e[t];
              },
              lookup: function (e, t) {
                for (var n = e.length, i = 0; n > i; i++) if (e[i] && null != e[i][t]) return e[i][t];
              },
              lambda: function (e, t) {
                return "function" == typeof e ? e.call(t) : e;
              },
              escapeExpression: h.escapeExpression,
              invokePartial: n,
              fn: function (t) {
                var n = e[t];
                return (n.decorator = e[t + "_d"]), n;
              },
              programs: [],
              program: function (e, t, n, i, o) {
                var r = this.programs[e],
                  s = this.fn(e);
                return t || o || i || n ? (r = a(this, e, s, t, n, i, o)) : r || (r = this.programs[e] = a(this, e, s)), r;
              },
              data: function (e, t) {
                for (; e && t--; ) e = e._parent;
                return e;
              },
              merge: function (e, t) {
                var n = e || t;
                return e && t && e !== t && (n = h.extend({}, t, e)), n;
              },
              noop: t.VM.noop,
              compilerInfo: e.compiler,
            };
            return (i.isTop = !0), i;
          }
          function a(e, t, n, i, o, r, s) {
            function a(t) {
              var o = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1],
                a = s;
              return s && t != s[0] && (a = [t].concat(s)), n(e, t, e.helpers, e.partials, o.data || i, r && [o.blockParams].concat(r), a);
            }
            return (a = d(n, a, e, s, i, r)), (a.program = t), (a.depth = s ? s.length : 0), (a.blockParams = o || 0), a;
          }
          function l(e, t, n) {
            if (e) e.call || n.name || ((n.name = e), (e = n.partials[e]));
            else if ("@partial-block" === n.name) {
              for (var i = n.data; i["partial-block"] === u; ) i = i._parent;
              (e = i["partial-block"]), (i["partial-block"] = u);
            } else e = n.partials[n.name];
            return e;
          }
          function c(e, t, n) {
            n.partial = !0;
            var i = void 0;
            if ((n.fn && n.fn !== u && ((n.data = g.createFrame(n.data)), (i = n.data["partial-block"] = n.fn), i.partials && (n.partials = h.extend({}, n.partials, i.partials))), void 0 === e && i && (e = i), void 0 === e))
              throw new v.default("The partial " + n.name + " could not be found");
            return e instanceof Function ? e(t, n) : void 0;
          }
          function u() {
            return "";
          }
          function p(e, t) {
            return (t && "root" in t) || ((t = t ? g.createFrame(t) : {}), (t.root = e)), t;
          }
          function d(e, t, n, i, o, r) {
            if (e.decorator) {
              var s = {};
              (t = e.decorator(t, s, n, i && i[0], o, r, i)), h.extend(t, s);
            }
            return t;
          }
          (t.__esModule = !0), (t.checkRevision = r), (t.template = s), (t.wrapProgram = a), (t.resolvePartial = l), (t.invokePartial = c), (t.noop = u);
          var f = n(3),
            h = o(f),
            m = n(4),
            v = i(m),
            g = n(2);
        },
        function (e, t) {
          (function (n) {
            "use strict";
            (t.__esModule = !0),
              (t.default = function (e) {
                var t = "undefined" != typeof n ? n : window,
                  i = t.Handlebars;
                e.noConflict = function () {
                  return t.Handlebars === e && (t.Handlebars = i), e;
                };
              }),
              (e.exports = t.default);
          }.call(
            t,
            (function () {
              return this;
            })()
          ));
        },
        function (e, t) {
          "use strict";
          t.__esModule = !0;
          var n = {
            helpers: {
              helperExpression: function (e) {
                return "SubExpression" === e.type || (("MustacheStatement" === e.type || "BlockStatement" === e.type) && !!((e.params && e.params.length) || e.hash));
              },
              scopedId: function (e) {
                return /^\.|this\b/.test(e.original);
              },
              simpleId: function (e) {
                return 1 === e.parts.length && !n.helpers.scopedId(e) && !e.depth;
              },
            },
          };
          (t.default = n), (e.exports = t.default);
        },
        function (e, t, n) {
          "use strict";
          function i(e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            return (t.default = e), t;
          }
          function o(e) {
            return e && e.__esModule ? e : { default: e };
          }
          function r(e, t) {
            if ("Program" === e.type) return e;
            (a.default.yy = f),
              (f.locInfo = function (e) {
                return new f.SourceLocation(t && t.srcName, e);
              });
            var n = new c.default(t);
            return n.accept(a.default.parse(e));
          }
          (t.__esModule = !0), (t.parse = r);
          var s = n(21),
            a = o(s),
            l = n(22),
            c = o(l),
            u = n(24),
            p = i(u),
            d = n(3);
          t.parser = a.default;
          var f = {};
          d.extend(f, p);
        },
        function (e, t) {
          "use strict";
          var n = (function () {
            function e() {
              this.yy = {};
            }
            var t = function (e, t, n, i) {
                for (n = n || {}, i = e.length; i--; n[e[i]] = t);
                return n;
              },
              n = [2, 46],
              i = [1, 20],
              o = [5, 14, 15, 19, 29, 34, 39, 44, 47, 48, 51, 55, 60],
              r = [1, 35],
              s = [1, 28],
              a = [1, 29],
              l = [1, 30],
              c = [1, 31],
              u = [1, 32],
              p = [1, 34],
              d = [14, 15, 19, 29, 34, 39, 44, 47, 48, 51, 55, 60],
              f = [14, 15, 19, 29, 34, 44, 47, 48, 51, 55, 60],
              h = [1, 44],
              m = [14, 15, 19, 29, 34, 47, 48, 51, 55, 60],
              v = [33, 65, 72, 80, 81, 82, 83, 84, 85],
              g = [23, 33, 54, 65, 68, 72, 75, 80, 81, 82, 83, 84, 85],
              y = [1, 51],
              b = [23, 33, 54, 65, 68, 72, 75, 80, 81, 82, 83, 84, 85, 87],
              w = [2, 45],
              x = [54, 65, 72, 80, 81, 82, 83, 84, 85],
              k = [1, 58],
              S = [1, 59],
              C = [15, 18],
              T = [1, 67],
              E = [33, 65, 72, 75, 80, 81, 82, 83, 84, 85],
              _ = [23, 65, 72, 80, 81, 82, 83, 84, 85],
              A = [1, 79],
              P = [65, 68, 72, 80, 81, 82, 83, 84, 85],
              O = [33, 75],
              N = [23, 33, 54, 68, 72, 75],
              I = [1, 109],
              $ = [1, 121],
              D = [72, 77],
              L = {
                trace: function () {},
                yy: {},
                symbols_: {
                  error: 2,
                  root: 3,
                  program: 4,
                  EOF: 5,
                  program_repetition0: 6,
                  statement: 7,
                  mustache: 8,
                  block: 9,
                  rawBlock: 10,
                  partial: 11,
                  partialBlock: 12,
                  content: 13,
                  COMMENT: 14,
                  CONTENT: 15,
                  openRawBlock: 16,
                  rawBlock_repetition_plus0: 17,
                  END_RAW_BLOCK: 18,
                  OPEN_RAW_BLOCK: 19,
                  helperName: 20,
                  openRawBlock_repetition0: 21,
                  openRawBlock_option0: 22,
                  CLOSE_RAW_BLOCK: 23,
                  openBlock: 24,
                  block_option0: 25,
                  closeBlock: 26,
                  openInverse: 27,
                  block_option1: 28,
                  OPEN_BLOCK: 29,
                  openBlock_repetition0: 30,
                  openBlock_option0: 31,
                  openBlock_option1: 32,
                  CLOSE: 33,
                  OPEN_INVERSE: 34,
                  openInverse_repetition0: 35,
                  openInverse_option0: 36,
                  openInverse_option1: 37,
                  openInverseChain: 38,
                  OPEN_INVERSE_CHAIN: 39,
                  openInverseChain_repetition0: 40,
                  openInverseChain_option0: 41,
                  openInverseChain_option1: 42,
                  inverseAndProgram: 43,
                  INVERSE: 44,
                  inverseChain: 45,
                  inverseChain_option0: 46,
                  OPEN_ENDBLOCK: 47,
                  OPEN: 48,
                  mustache_repetition0: 49,
                  mustache_option0: 50,
                  OPEN_UNESCAPED: 51,
                  mustache_repetition1: 52,
                  mustache_option1: 53,
                  CLOSE_UNESCAPED: 54,
                  OPEN_PARTIAL: 55,
                  partialName: 56,
                  partial_repetition0: 57,
                  partial_option0: 58,
                  openPartialBlock: 59,
                  OPEN_PARTIAL_BLOCK: 60,
                  openPartialBlock_repetition0: 61,
                  openPartialBlock_option0: 62,
                  param: 63,
                  sexpr: 64,
                  OPEN_SEXPR: 65,
                  sexpr_repetition0: 66,
                  sexpr_option0: 67,
                  CLOSE_SEXPR: 68,
                  hash: 69,
                  hash_repetition_plus0: 70,
                  hashSegment: 71,
                  ID: 72,
                  EQUALS: 73,
                  blockParams: 74,
                  OPEN_BLOCK_PARAMS: 75,
                  blockParams_repetition_plus0: 76,
                  CLOSE_BLOCK_PARAMS: 77,
                  path: 78,
                  dataName: 79,
                  STRING: 80,
                  NUMBER: 81,
                  BOOLEAN: 82,
                  UNDEFINED: 83,
                  NULL: 84,
                  DATA: 85,
                  pathSegments: 86,
                  SEP: 87,
                  $accept: 0,
                  $end: 1,
                },
                terminals_: {
                  2: "error",
                  5: "EOF",
                  14: "COMMENT",
                  15: "CONTENT",
                  18: "END_RAW_BLOCK",
                  19: "OPEN_RAW_BLOCK",
                  23: "CLOSE_RAW_BLOCK",
                  29: "OPEN_BLOCK",
                  33: "CLOSE",
                  34: "OPEN_INVERSE",
                  39: "OPEN_INVERSE_CHAIN",
                  44: "INVERSE",
                  47: "OPEN_ENDBLOCK",
                  48: "OPEN",
                  51: "OPEN_UNESCAPED",
                  54: "CLOSE_UNESCAPED",
                  55: "OPEN_PARTIAL",
                  60: "OPEN_PARTIAL_BLOCK",
                  65: "OPEN_SEXPR",
                  68: "CLOSE_SEXPR",
                  72: "ID",
                  73: "EQUALS",
                  75: "OPEN_BLOCK_PARAMS",
                  77: "CLOSE_BLOCK_PARAMS",
                  80: "STRING",
                  81: "NUMBER",
                  82: "BOOLEAN",
                  83: "UNDEFINED",
                  84: "NULL",
                  85: "DATA",
                  87: "SEP",
                },
                productions_: [
                  0,
                  [3, 2],
                  [4, 1],
                  [7, 1],
                  [7, 1],
                  [7, 1],
                  [7, 1],
                  [7, 1],
                  [7, 1],
                  [7, 1],
                  [13, 1],
                  [10, 3],
                  [16, 5],
                  [9, 4],
                  [9, 4],
                  [24, 6],
                  [27, 6],
                  [38, 6],
                  [43, 2],
                  [45, 3],
                  [45, 1],
                  [26, 3],
                  [8, 5],
                  [8, 5],
                  [11, 5],
                  [12, 3],
                  [59, 5],
                  [63, 1],
                  [63, 1],
                  [64, 5],
                  [69, 1],
                  [71, 3],
                  [74, 3],
                  [20, 1],
                  [20, 1],
                  [20, 1],
                  [20, 1],
                  [20, 1],
                  [20, 1],
                  [20, 1],
                  [56, 1],
                  [56, 1],
                  [79, 2],
                  [78, 1],
                  [86, 3],
                  [86, 1],
                  [6, 0],
                  [6, 2],
                  [17, 1],
                  [17, 2],
                  [21, 0],
                  [21, 2],
                  [22, 0],
                  [22, 1],
                  [25, 0],
                  [25, 1],
                  [28, 0],
                  [28, 1],
                  [30, 0],
                  [30, 2],
                  [31, 0],
                  [31, 1],
                  [32, 0],
                  [32, 1],
                  [35, 0],
                  [35, 2],
                  [36, 0],
                  [36, 1],
                  [37, 0],
                  [37, 1],
                  [40, 0],
                  [40, 2],
                  [41, 0],
                  [41, 1],
                  [42, 0],
                  [42, 1],
                  [46, 0],
                  [46, 1],
                  [49, 0],
                  [49, 2],
                  [50, 0],
                  [50, 1],
                  [52, 0],
                  [52, 2],
                  [53, 0],
                  [53, 1],
                  [57, 0],
                  [57, 2],
                  [58, 0],
                  [58, 1],
                  [61, 0],
                  [61, 2],
                  [62, 0],
                  [62, 1],
                  [66, 0],
                  [66, 2],
                  [67, 0],
                  [67, 1],
                  [70, 1],
                  [70, 2],
                  [76, 1],
                  [76, 2],
                ],
                performAction: function (e, t, n, i, o, r, s) {
                  var a = r.length - 1;
                  switch (o) {
                    case 1:
                      return r[a - 1];
                    case 2:
                      this.$ = i.prepareProgram(r[a]);
                      break;
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 20:
                    case 27:
                    case 28:
                    case 33:
                    case 34:
                    case 40:
                    case 41:
                      this.$ = r[a];
                      break;
                    case 9:
                      this.$ = { type: "CommentStatement", value: i.stripComment(r[a]), strip: i.stripFlags(r[a], r[a]), loc: i.locInfo(this._$) };
                      break;
                    case 10:
                      this.$ = { type: "ContentStatement", original: r[a], value: r[a], loc: i.locInfo(this._$) };
                      break;
                    case 11:
                      this.$ = i.prepareRawBlock(r[a - 2], r[a - 1], r[a], this._$);
                      break;
                    case 12:
                      this.$ = { path: r[a - 3], params: r[a - 2], hash: r[a - 1] };
                      break;
                    case 13:
                      this.$ = i.prepareBlock(r[a - 3], r[a - 2], r[a - 1], r[a], !1, this._$);
                      break;
                    case 14:
                      this.$ = i.prepareBlock(r[a - 3], r[a - 2], r[a - 1], r[a], !0, this._$);
                      break;
                    case 15:
                      this.$ = { open: r[a - 5], path: r[a - 4], params: r[a - 3], hash: r[a - 2], blockParams: r[a - 1], strip: i.stripFlags(r[a - 5], r[a]) };
                      break;
                    case 16:
                    case 17:
                      this.$ = { path: r[a - 4], params: r[a - 3], hash: r[a - 2], blockParams: r[a - 1], strip: i.stripFlags(r[a - 5], r[a]) };
                      break;
                    case 18:
                      this.$ = { strip: i.stripFlags(r[a - 1], r[a - 1]), program: r[a] };
                      break;
                    case 19:
                      var l = i.prepareBlock(r[a - 2], r[a - 1], r[a], r[a], !1, this._$),
                        c = i.prepareProgram([l], r[a - 1].loc);
                      (c.chained = !0), (this.$ = { strip: r[a - 2].strip, program: c, chain: !0 });
                      break;
                    case 21:
                      this.$ = { path: r[a - 1], strip: i.stripFlags(r[a - 2], r[a]) };
                      break;
                    case 22:
                    case 23:
                      this.$ = i.prepareMustache(r[a - 3], r[a - 2], r[a - 1], r[a - 4], i.stripFlags(r[a - 4], r[a]), this._$);
                      break;
                    case 24:
                      this.$ = { type: "PartialStatement", name: r[a - 3], params: r[a - 2], hash: r[a - 1], indent: "", strip: i.stripFlags(r[a - 4], r[a]), loc: i.locInfo(this._$) };
                      break;
                    case 25:
                      this.$ = i.preparePartialBlock(r[a - 2], r[a - 1], r[a], this._$);
                      break;
                    case 26:
                      this.$ = { path: r[a - 3], params: r[a - 2], hash: r[a - 1], strip: i.stripFlags(r[a - 4], r[a]) };
                      break;
                    case 29:
                      this.$ = { type: "SubExpression", path: r[a - 3], params: r[a - 2], hash: r[a - 1], loc: i.locInfo(this._$) };
                      break;
                    case 30:
                      this.$ = { type: "Hash", pairs: r[a], loc: i.locInfo(this._$) };
                      break;
                    case 31:
                      this.$ = { type: "HashPair", key: i.id(r[a - 2]), value: r[a], loc: i.locInfo(this._$) };
                      break;
                    case 32:
                      this.$ = i.id(r[a - 1]);
                      break;
                    case 35:
                      this.$ = { type: "StringLiteral", value: r[a], original: r[a], loc: i.locInfo(this._$) };
                      break;
                    case 36:
                      this.$ = { type: "NumberLiteral", value: Number(r[a]), original: Number(r[a]), loc: i.locInfo(this._$) };
                      break;
                    case 37:
                      this.$ = { type: "BooleanLiteral", value: "true" === r[a], original: "true" === r[a], loc: i.locInfo(this._$) };
                      break;
                    case 38:
                      this.$ = { type: "UndefinedLiteral", original: void 0, value: void 0, loc: i.locInfo(this._$) };
                      break;
                    case 39:
                      this.$ = { type: "NullLiteral", original: null, value: null, loc: i.locInfo(this._$) };
                      break;
                    case 42:
                      this.$ = i.preparePath(!0, r[a], this._$);
                      break;
                    case 43:
                      this.$ = i.preparePath(!1, r[a], this._$);
                      break;
                    case 44:
                      r[a - 2].push({ part: i.id(r[a]), original: r[a], separator: r[a - 1] }), (this.$ = r[a - 2]);
                      break;
                    case 45:
                      this.$ = [{ part: i.id(r[a]), original: r[a] }];
                      break;
                    case 46:
                    case 50:
                    case 58:
                    case 64:
                    case 70:
                    case 78:
                    case 82:
                    case 86:
                    case 90:
                    case 94:
                      this.$ = [];
                      break;
                    case 47:
                    case 49:
                    case 51:
                    case 59:
                    case 65:
                    case 71:
                    case 79:
                    case 83:
                    case 87:
                    case 91:
                    case 95:
                    case 99:
                    case 101:
                      r[a - 1].push(r[a]);
                      break;
                    case 48:
                    case 98:
                    case 100:
                      this.$ = [r[a]];
                  }
                },
                table: [
                  t([5, 14, 15, 19, 29, 34, 48, 51, 55, 60], n, { 3: 1, 4: 2, 6: 3 }),
                  { 1: [3] },
                  { 5: [1, 4] },
                  t([5, 39, 44, 47], [2, 2], { 7: 5, 8: 6, 9: 7, 10: 8, 11: 9, 12: 10, 13: 11, 24: 15, 27: 16, 16: 17, 59: 19, 14: [1, 12], 15: i, 19: [1, 23], 29: [1, 21], 34: [1, 22], 48: [1, 13], 51: [1, 14], 55: [1, 18], 60: [1, 24] }),
                  { 1: [2, 1] },
                  t(o, [2, 47]),
                  t(o, [2, 3]),
                  t(o, [2, 4]),
                  t(o, [2, 5]),
                  t(o, [2, 6]),
                  t(o, [2, 7]),
                  t(o, [2, 8]),
                  t(o, [2, 9]),
                  { 20: 25, 72: r, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: p, 86: 33 },
                  { 20: 36, 72: r, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: p, 86: 33 },
                  t(d, n, { 6: 3, 4: 37 }),
                  t(f, n, { 6: 3, 4: 38 }),
                  { 13: 40, 15: i, 17: 39 },
                  { 20: 42, 56: 41, 64: 43, 65: h, 72: r, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: p, 86: 33 },
                  t(m, n, { 6: 3, 4: 45 }),
                  t([5, 14, 15, 18, 19, 29, 34, 39, 44, 47, 48, 51, 55, 60], [2, 10]),
                  { 20: 46, 72: r, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: p, 86: 33 },
                  { 20: 47, 72: r, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: p, 86: 33 },
                  { 20: 48, 72: r, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: p, 86: 33 },
                  { 20: 42, 56: 49, 64: 43, 65: h, 72: r, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: p, 86: 33 },
                  t(v, [2, 78], { 49: 50 }),
                  t(g, [2, 33]),
                  t(g, [2, 34]),
                  t(g, [2, 35]),
                  t(g, [2, 36]),
                  t(g, [2, 37]),
                  t(g, [2, 38]),
                  t(g, [2, 39]),
                  t(g, [2, 43], { 87: y }),
                  { 72: r, 86: 52 },
                  t(b, w),
                  t(x, [2, 82], { 52: 53 }),
                  { 25: 54, 38: 56, 39: k, 43: 57, 44: S, 45: 55, 47: [2, 54] },
                  { 28: 60, 43: 61, 44: S, 47: [2, 56] },
                  { 13: 63, 15: i, 18: [1, 62] },
                  t(C, [2, 48]),
                  t(v, [2, 86], { 57: 64 }),
                  t(v, [2, 40]),
                  t(v, [2, 41]),
                  { 20: 65, 72: r, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: p, 86: 33 },
                  { 26: 66, 47: T },
                  t(E, [2, 58], { 30: 68 }),
                  t(E, [2, 64], { 35: 69 }),
                  t(_, [2, 50], { 21: 70 }),
                  t(v, [2, 90], { 61: 71 }),
                  { 20: 75, 33: [2, 80], 50: 72, 63: 73, 64: 76, 65: h, 69: 74, 70: 77, 71: 78, 72: A, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: p, 86: 33 },
                  { 72: [1, 80] },
                  t(g, [2, 42], { 87: y }),
                  { 20: 75, 53: 81, 54: [2, 84], 63: 82, 64: 76, 65: h, 69: 83, 70: 77, 71: 78, 72: A, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: p, 86: 33 },
                  { 26: 84, 47: T },
                  { 47: [2, 55] },
                  t(d, n, { 6: 3, 4: 85 }),
                  { 47: [2, 20] },
                  { 20: 86, 72: r, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: p, 86: 33 },
                  t(m, n, { 6: 3, 4: 87 }),
                  { 26: 88, 47: T },
                  { 47: [2, 57] },
                  t(o, [2, 11]),
                  t(C, [2, 49]),
                  { 20: 75, 33: [2, 88], 58: 89, 63: 90, 64: 76, 65: h, 69: 91, 70: 77, 71: 78, 72: A, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: p, 86: 33 },
                  t(P, [2, 94], { 66: 92 }),
                  t(o, [2, 25]),
                  { 20: 93, 72: r, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: p, 86: 33 },
                  t(O, [2, 60], { 78: 26, 79: 27, 86: 33, 20: 75, 64: 76, 70: 77, 71: 78, 31: 94, 63: 95, 69: 96, 65: h, 72: A, 80: s, 81: a, 82: l, 83: c, 84: u, 85: p }),
                  t(O, [2, 66], { 78: 26, 79: 27, 86: 33, 20: 75, 64: 76, 70: 77, 71: 78, 36: 97, 63: 98, 69: 99, 65: h, 72: A, 80: s, 81: a, 82: l, 83: c, 84: u, 85: p }),
                  { 20: 75, 22: 100, 23: [2, 52], 63: 101, 64: 76, 65: h, 69: 102, 70: 77, 71: 78, 72: A, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: p, 86: 33 },
                  { 20: 75, 33: [2, 92], 62: 103, 63: 104, 64: 76, 65: h, 69: 105, 70: 77, 71: 78, 72: A, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: p, 86: 33 },
                  { 33: [1, 106] },
                  t(v, [2, 79]),
                  { 33: [2, 81] },
                  t(g, [2, 27]),
                  t(g, [2, 28]),
                  t([23, 33, 54, 68, 75], [2, 30], { 71: 107, 72: [1, 108] }),
                  t(N, [2, 98]),
                  t(b, w, { 73: I }),
                  t(b, [2, 44]),
                  { 54: [1, 110] },
                  t(x, [2, 83]),
                  { 54: [2, 85] },
                  t(o, [2, 13]),
                  { 38: 56, 39: k, 43: 57, 44: S, 45: 112, 46: 111, 47: [2, 76] },
                  t(E, [2, 70], { 40: 113 }),
                  { 47: [2, 18] },
                  t(o, [2, 14]),
                  { 33: [1, 114] },
                  t(v, [2, 87]),
                  { 33: [2, 89] },
                  { 20: 75, 63: 116, 64: 76, 65: h, 67: 115, 68: [2, 96], 69: 117, 70: 77, 71: 78, 72: A, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: p, 86: 33 },
                  { 33: [1, 118] },
                  { 32: 119, 33: [2, 62], 74: 120, 75: $ },
                  t(E, [2, 59]),
                  t(O, [2, 61]),
                  { 33: [2, 68], 37: 122, 74: 123, 75: $ },
                  t(E, [2, 65]),
                  t(O, [2, 67]),
                  { 23: [1, 124] },
                  t(_, [2, 51]),
                  { 23: [2, 53] },
                  { 33: [1, 125] },
                  t(v, [2, 91]),
                  { 33: [2, 93] },
                  t(o, [2, 22]),
                  t(N, [2, 99]),
                  { 73: I },
                  { 20: 75, 63: 126, 64: 76, 65: h, 72: r, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: p, 86: 33 },
                  t(o, [2, 23]),
                  { 47: [2, 19] },
                  { 47: [2, 77] },
                  t(O, [2, 72], { 78: 26, 79: 27, 86: 33, 20: 75, 64: 76, 70: 77, 71: 78, 41: 127, 63: 128, 69: 129, 65: h, 72: A, 80: s, 81: a, 82: l, 83: c, 84: u, 85: p }),
                  t(o, [2, 24]),
                  { 68: [1, 130] },
                  t(P, [2, 95]),
                  { 68: [2, 97] },
                  t(o, [2, 21]),
                  { 33: [1, 131] },
                  { 33: [2, 63] },
                  { 72: [1, 133], 76: 132 },
                  { 33: [1, 134] },
                  { 33: [2, 69] },
                  { 15: [2, 12] },
                  t(m, [2, 26]),
                  t(N, [2, 31]),
                  { 33: [2, 74], 42: 135, 74: 136, 75: $ },
                  t(E, [2, 71]),
                  t(O, [2, 73]),
                  t(g, [2, 29]),
                  t(d, [2, 15]),
                  { 72: [1, 138], 77: [1, 137] },
                  t(D, [2, 100]),
                  t(f, [2, 16]),
                  { 33: [1, 139] },
                  { 33: [2, 75] },
                  { 33: [2, 32] },
                  t(D, [2, 101]),
                  t(d, [2, 17]),
                ],
                defaultActions: {
                  4: [2, 1],
                  55: [2, 55],
                  57: [2, 20],
                  61: [2, 57],
                  74: [2, 81],
                  83: [2, 85],
                  87: [2, 18],
                  91: [2, 89],
                  102: [2, 53],
                  105: [2, 93],
                  111: [2, 19],
                  112: [2, 77],
                  117: [2, 97],
                  120: [2, 63],
                  123: [2, 69],
                  124: [2, 12],
                  136: [2, 75],
                  137: [2, 32],
                },
                parseError: function (e, t) {
                  if (!t.recoverable) {
                    var n = function (e, t) {
                      (this.message = e), (this.hash = t);
                    };
                    throw ((n.prototype = new Error()), new n(e, t));
                  }
                  this.trace(e);
                },
                parse: function (e) {
                  var t = this,
                    n = [0],
                    i = [null],
                    o = [],
                    r = this.table,
                    s = "",
                    a = 0,
                    l = 0,
                    c = 0,
                    u = 2,
                    p = 1,
                    d = o.slice.call(arguments, 1),
                    f = Object.create(this.lexer),
                    h = { yy: {} };
                  for (var m in this.yy) Object.prototype.hasOwnProperty.call(this.yy, m) && (h.yy[m] = this.yy[m]);
                  f.setInput(e, h.yy), (h.yy.lexer = f), (h.yy.parser = this), "undefined" == typeof f.yylloc && (f.yylloc = {});
                  var v = f.yylloc;
                  o.push(v);
                  var g = f.options && f.options.ranges;
                  "function" == typeof h.yy.parseError ? (this.parseError = h.yy.parseError) : (this.parseError = Object.getPrototypeOf(this).parseError);
                  for (
                    var y,
                      b,
                      w,
                      x,
                      k,
                      S,
                      C,
                      T,
                      E,
                      _ = function () {
                        var e;
                        return (e = f.lex() || p), "number" != typeof e && (e = t.symbols_[e] || e), e;
                      },
                      A = {};
                    ;
  
                  ) {
                    if (((w = n[n.length - 1]), this.defaultActions[w] ? (x = this.defaultActions[w]) : ((null !== y && "undefined" != typeof y) || (y = _()), (x = r[w] && r[w][y])), "undefined" == typeof x || !x.length || !x[0])) {
                      var P = "";
                      E = [];
                      for (S in r[w]) this.terminals_[S] && S > u && E.push("'" + this.terminals_[S] + "'");
                      (P = f.showPosition
                        ? "Parse error on line " + (a + 1) + ":\n" + f.showPosition() + "\nExpecting " + E.join(", ") + ", got '" + (this.terminals_[y] || y) + "'"
                        : "Parse error on line " + (a + 1) + ": Unexpected " + (y == p ? "end of input" : "'" + (this.terminals_[y] || y) + "'")),
                        this.parseError(P, { text: f.match, token: this.terminals_[y] || y, line: f.yylineno, loc: v, expected: E });
                    }
                    if (x[0] instanceof Array && x.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + w + ", token: " + y);
                    switch (x[0]) {
                      case 1:
                        n.push(y), i.push(f.yytext), o.push(f.yylloc), n.push(x[1]), (y = null), b ? ((y = b), (b = null)) : ((l = f.yyleng), (s = f.yytext), (a = f.yylineno), (v = f.yylloc), c > 0 && c--);
                        break;
                      case 2:
                        if (
                          ((C = this.productions_[x[1]][1]),
                          (A.$ = i[i.length - C]),
                          (A._$ = { first_line: o[o.length - (C || 1)].first_line, last_line: o[o.length - 1].last_line, first_column: o[o.length - (C || 1)].first_column, last_column: o[o.length - 1].last_column }),
                          g && (A._$.range = [o[o.length - (C || 1)].range[0], o[o.length - 1].range[1]]),
                          (k = this.performAction.apply(A, [s, l, a, h.yy, x[1], i, o].concat(d))),
                          "undefined" != typeof k)
                        )
                          return k;
                        C && ((n = n.slice(0, -1 * C * 2)), (i = i.slice(0, -1 * C)), (o = o.slice(0, -1 * C))), n.push(this.productions_[x[1]][0]), i.push(A.$), o.push(A._$), (T = r[n[n.length - 2]][n[n.length - 1]]), n.push(T);
                        break;
                      case 3:
                        return !0;
                    }
                  }
                  return !0;
                },
              },
              z = (function () {
                var e = {
                  EOF: 1,
                  parseError: function (e, t) {
                    if (!this.yy.parser) throw new Error(e);
                    this.yy.parser.parseError(e, t);
                  },
                  setInput: function (e, t) {
                    return (
                      (this.yy = t || this.yy || {}),
                      (this._input = e),
                      (this._more = this._backtrack = this.done = !1),
                      (this.yylineno = this.yyleng = 0),
                      (this.yytext = this.matched = this.match = ""),
                      (this.conditionStack = ["INITIAL"]),
                      (this.yylloc = { first_line: 1, first_column: 0, last_line: 1, last_column: 0 }),
                      this.options.ranges && (this.yylloc.range = [0, 0]),
                      (this.offset = 0),
                      this
                    );
                  },
                  input: function () {
                    var e = this._input[0];
                    (this.yytext += e), this.yyleng++, this.offset++, (this.match += e), (this.matched += e);
                    var t = e.match(/(?:\r\n?|\n).*/g);
                    return t ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, (this._input = this._input.slice(1)), e;
                  },
                  unput: function (e) {
                    var t = e.length,
                      n = e.split(/(?:\r\n?|\n)/g);
                    (this._input = e + this._input), (this.yytext = this.yytext.substr(0, this.yytext.length - t)), (this.offset -= t);
                    var i = this.match.split(/(?:\r\n?|\n)/g);
                    (this.match = this.match.substr(0, this.match.length - 1)), (this.matched = this.matched.substr(0, this.matched.length - 1)), n.length - 1 && (this.yylineno -= n.length - 1);
                    var o = this.yylloc.range;
                    return (
                      (this.yylloc = {
                        first_line: this.yylloc.first_line,
                        last_line: this.yylineno + 1,
                        first_column: this.yylloc.first_column,
                        last_column: n ? (n.length === i.length ? this.yylloc.first_column : 0) + i[i.length - n.length].length - n[0].length : this.yylloc.first_column - t,
                      }),
                      this.options.ranges && (this.yylloc.range = [o[0], o[0] + this.yyleng - t]),
                      (this.yyleng = this.yytext.length),
                      this
                    );
                  },
                  more: function () {
                    return (this._more = !0), this;
                  },
                  reject: function () {
                    return this.options.backtrack_lexer
                      ? ((this._backtrack = !0), this)
                      : this.parseError(
                          "Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(),
                          { text: "", token: null, line: this.yylineno }
                        );
                  },
                  less: function (e) {
                    this.unput(this.match.slice(e));
                  },
                  pastInput: function () {
                    var e = this.matched.substr(0, this.matched.length - this.match.length);
                    return (e.length > 20 ? "..." : "") + e.substr(-20).replace(/\n/g, "");
                  },
                  upcomingInput: function () {
                    var e = this.match;
                    return e.length < 20 && (e += this._input.substr(0, 20 - e.length)), (e.substr(0, 20) + (e.length > 20 ? "..." : "")).replace(/\n/g, "");
                  },
                  showPosition: function () {
                    var e = this.pastInput(),
                      t = new Array(e.length + 1).join("-");
                    return e + this.upcomingInput() + "\n" + t + "^";
                  },
                  test_match: function (e, t) {
                    var n, i, o;
                    if (
                      (this.options.backtrack_lexer &&
                        ((o = {
                          yylineno: this.yylineno,
                          yylloc: { first_line: this.yylloc.first_line, last_line: this.last_line, first_column: this.yylloc.first_column, last_column: this.yylloc.last_column },
                          yytext: this.yytext,
                          match: this.match,
                          matches: this.matches,
                          matched: this.matched,
                          yyleng: this.yyleng,
                          offset: this.offset,
                          _more: this._more,
                          _input: this._input,
                          yy: this.yy,
                          conditionStack: this.conditionStack.slice(0),
                          done: this.done,
                        }),
                        this.options.ranges && (o.yylloc.range = this.yylloc.range.slice(0))),
                      (i = e[0].match(/(?:\r\n?|\n).*/g)),
                      i && (this.yylineno += i.length),
                      (this.yylloc = {
                        first_line: this.yylloc.last_line,
                        last_line: this.yylineno + 1,
                        first_column: this.yylloc.last_column,
                        last_column: i ? i[i.length - 1].length - i[i.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + e[0].length,
                      }),
                      (this.yytext += e[0]),
                      (this.match += e[0]),
                      (this.matches = e),
                      (this.yyleng = this.yytext.length),
                      this.options.ranges && (this.yylloc.range = [this.offset, (this.offset += this.yyleng)]),
                      (this._more = !1),
                      (this._backtrack = !1),
                      (this._input = this._input.slice(e[0].length)),
                      (this.matched += e[0]),
                      (n = this.performAction.call(this, this.yy, this, t, this.conditionStack[this.conditionStack.length - 1])),
                      this.done && this._input && (this.done = !1),
                      n)
                    )
                      return n;
                    if (this._backtrack) {
                      for (var r in o) this[r] = o[r];
                      return !1;
                    }
                    return !1;
                  },
                  next: function () {
                    if (this.done) return this.EOF;
                    this._input || (this.done = !0);
                    var e, t, n, i;
                    this._more || ((this.yytext = ""), (this.match = ""));
                    for (var o = this._currentRules(), r = 0; r < o.length; r++)
                      if (((n = this._input.match(this.rules[o[r]])), n && (!t || n[0].length > t[0].length))) {
                        if (((t = n), (i = r), this.options.backtrack_lexer)) {
                          if (((e = this.test_match(n, o[r])), e !== !1)) return e;
                          if (this._backtrack) {
                            t = !1;
                            continue;
                          }
                          return !1;
                        }
                        if (!this.options.flex) break;
                      }
                    return t
                      ? ((e = this.test_match(t, o[i])), e !== !1 && e)
                      : "" === this._input
                      ? this.EOF
                      : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), { text: "", token: null, line: this.yylineno });
                  },
                  lex: function () {
                    var e = this.next();
                    return e ? e : this.lex();
                  },
                  begin: function (e) {
                    this.conditionStack.push(e);
                  },
                  popState: function () {
                    var e = this.conditionStack.length - 1;
                    return e > 0 ? this.conditionStack.pop() : this.conditionStack[0];
                  },
                  _currentRules: function () {
                    return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
                  },
                  topState: function (e) {
                    return (e = this.conditionStack.length - 1 - Math.abs(e || 0)), e >= 0 ? this.conditionStack[e] : "INITIAL";
                  },
                  pushState: function (e) {
                    this.begin(e);
                  },
                  stateStackSize: function () {
                    return this.conditionStack.length;
                  },
                  options: {},
                  performAction: function (e, t, n, i) {
                    function o(e, n) {
                      return (t.yytext = t.yytext.substr(e, t.yyleng - n));
                    }
                    switch (n) {
                      case 0:
                        if (("\\\\" === t.yytext.slice(-2) ? (o(0, 1), this.begin("mu")) : "\\" === t.yytext.slice(-1) ? (o(0, 1), this.begin("emu")) : this.begin("mu"), t.yytext)) return 15;
                        break;
                      case 1:
                        return 15;
                      case 2:
                        return this.popState(), 15;
                      case 3:
                        return this.begin("raw"), 15;
                      case 4:
                        return this.popState(), "raw" === this.conditionStack[this.conditionStack.length - 1] ? 15 : ((t.yytext = t.yytext.substr(5, t.yyleng - 9)), 18);
                      case 5:
                        return 15;
                      case 6:
                        return this.popState(), 14;
                      case 7:
                        return 65;
                      case 8:
                        return 68;
                      case 9:
                        return 19;
                      case 10:
                        return this.popState(), this.begin("raw"), 23;
                      case 11:
                        return 55;
                      case 12:
                        return 60;
                      case 13:
                        return 29;
                      case 14:
                        return 47;
                      case 15:
                        return this.popState(), 44;
                      case 16:
                        return this.popState(), 44;
                      case 17:
                        return 34;
                      case 18:
                        return 39;
                      case 19:
                        return 51;
                      case 20:
                        return 48;
                      case 21:
                        this.unput(t.yytext), this.popState(), this.begin("com");
                        break;
                      case 22:
                        return this.popState(), 14;
                      case 23:
                        return 48;
                      case 24:
                        return 73;
                      case 25:
                        return 72;
                      case 26:
                        return 72;
                      case 27:
                        return 87;
                      case 28:
                        break;
                      case 29:
                        return this.popState(), 54;
                      case 30:
                        return this.popState(), 33;
                      case 31:
                        return (t.yytext = o(1, 2).replace(/\\"/g, '"')), 80;
                      case 32:
                        return (t.yytext = o(1, 2).replace(/\\'/g, "'")), 80;
                      case 33:
                        return 85;
                      case 34:
                        return 82;
                      case 35:
                        return 82;
                      case 36:
                        return 83;
                      case 37:
                        return 84;
                      case 38:
                        return 81;
                      case 39:
                        return 75;
                      case 40:
                        return 77;
                      case 41:
                        return 72;
                      case 42:
                        return (t.yytext = t.yytext.replace(/\\([\\\]])/g, "$1")), 72;
                      case 43:
                        return "INVALID";
                      case 44:
                        return 5;
                    }
                  },
                  rules: [
                    /^(?:[^\x00]*?(?=(\{\{)))/,
                    /^(?:[^\x00]+)/,
                    /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/,
                    /^(?:\{\{\{\{(?=[^\/]))/,
                    /^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/,
                    /^(?:[^\x00]*?(?=(\{\{\{\{)))/,
                    /^(?:[\s\S]*?--(~)?\}\})/,
                    /^(?:\()/,
                    /^(?:\))/,
                    /^(?:\{\{\{\{)/,
                    /^(?:\}\}\}\})/,
                    /^(?:\{\{(~)?>)/,
                    /^(?:\{\{(~)?#>)/,
                    /^(?:\{\{(~)?#\*?)/,
                    /^(?:\{\{(~)?\/)/,
                    /^(?:\{\{(~)?\^\s*(~)?\}\})/,
                    /^(?:\{\{(~)?\s*else\s*(~)?\}\})/,
                    /^(?:\{\{(~)?\^)/,
                    /^(?:\{\{(~)?\s*else\b)/,
                    /^(?:\{\{(~)?\{)/,
                    /^(?:\{\{(~)?&)/,
                    /^(?:\{\{(~)?!--)/,
                    /^(?:\{\{(~)?![\s\S]*?\}\})/,
                    /^(?:\{\{(~)?\*?)/,
                    /^(?:=)/,
                    /^(?:\.\.)/,
                    /^(?:\.(?=([=~}\s\/.)|])))/,
                    /^(?:[\/.])/,
                    /^(?:\s+)/,
                    /^(?:\}(~)?\}\})/,
                    /^(?:(~)?\}\})/,
                    /^(?:"(\\["]|[^"])*")/,
                    /^(?:'(\\[']|[^'])*')/,
                    /^(?:@)/,
                    /^(?:true(?=([~}\s)])))/,
                    /^(?:false(?=([~}\s)])))/,
                    /^(?:undefined(?=([~}\s)])))/,
                    /^(?:null(?=([~}\s)])))/,
                    /^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/,
                    /^(?:as\s+\|)/,
                    /^(?:\|)/,
                    /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/,
                    /^(?:\[(\\\]|[^\]])*\])/,
                    /^(?:.)/,
                    /^(?:$)/,
                  ],
                  conditions: {
                    mu: { rules: [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44], inclusive: !1 },
                    emu: { rules: [2], inclusive: !1 },
                    com: { rules: [6], inclusive: !1 },
                    raw: { rules: [3, 4, 5], inclusive: !1 },
                    INITIAL: { rules: [0, 1, 44], inclusive: !0 },
                  },
                };
                return e;
              })();
            return (L.lexer = z), (e.prototype = L), (L.Parser = e), new e();
          })();
          (t.__esModule = !0), (t.default = n);
        },
        function (e, t, n) {
          "use strict";
          function i(e) {
            return e && e.__esModule ? e : { default: e };
          }
          function o() {
            var e = arguments.length <= 0 || void 0 === arguments[0] ? {} : arguments[0];
            this.options = e;
          }
          function r(e, t, n) {
            void 0 === t && (t = e.length);
            var i = e[t - 1],
              o = e[t - 2];
            return i ? ("ContentStatement" === i.type ? (o || !n ? /\r?\n\s*?$/ : /(^|\r?\n)\s*?$/).test(i.original) : void 0) : n;
          }
          function s(e, t, n) {
            void 0 === t && (t = -1);
            var i = e[t + 1],
              o = e[t + 2];
            return i ? ("ContentStatement" === i.type ? (o || !n ? /^\s*?\r?\n/ : /^\s*?(\r?\n|$)/).test(i.original) : void 0) : n;
          }
          function a(e, t, n) {
            var i = e[null == t ? 0 : t + 1];
            if (i && "ContentStatement" === i.type && (n || !i.rightStripped)) {
              var o = i.value;
              (i.value = i.value.replace(n ? /^\s+/ : /^[ \t]*\r?\n?/, "")), (i.rightStripped = i.value !== o);
            }
          }
          function l(e, t, n) {
            var i = e[null == t ? e.length - 1 : t - 1];
            if (i && "ContentStatement" === i.type && (n || !i.leftStripped)) {
              var o = i.value;
              return (i.value = i.value.replace(n ? /\s+$/ : /[ \t]+$/, "")), (i.leftStripped = i.value !== o), i.leftStripped;
            }
          }
          t.__esModule = !0;
          var c = n(23),
            u = i(c);
          (o.prototype = new u.default()),
            (o.prototype.Program = function (e) {
              var t = !this.options.ignoreStandalone,
                n = !this.isRootSeen;
              this.isRootSeen = !0;
              for (var i = e.body, o = 0, c = i.length; c > o; o++) {
                var u = i[o],
                  p = this.accept(u);
                if (p) {
                  var d = r(i, o, n),
                    f = s(i, o, n),
                    h = p.openStandalone && d,
                    m = p.closeStandalone && f,
                    v = p.inlineStandalone && d && f;
                  p.close && a(i, o, !0),
                    p.open && l(i, o, !0),
                    t && v && (a(i, o), l(i, o) && "PartialStatement" === u.type && (u.indent = /([ \t]+$)/.exec(i[o - 1].original)[1])),
                    t && h && (a((u.program || u.inverse).body), l(i, o)),
                    t && m && (a(i, o), l((u.inverse || u.program).body));
                }
              }
              return e;
            }),
            (o.prototype.BlockStatement = o.prototype.DecoratorBlock = o.prototype.PartialBlockStatement = function (e) {
              this.accept(e.program), this.accept(e.inverse);
              var t = e.program || e.inverse,
                n = e.program && e.inverse,
                i = n,
                o = n;
              if (n && n.chained) for (i = n.body[0].program; o.chained; ) o = o.body[o.body.length - 1].program;
              var c = { open: e.openStrip.open, close: e.closeStrip.close, openStandalone: s(t.body), closeStandalone: r((i || t).body) };
              if ((e.openStrip.close && a(t.body, null, !0), n)) {
                var u = e.inverseStrip;
                u.open && l(t.body, null, !0), u.close && a(i.body, null, !0), e.closeStrip.open && l(o.body, null, !0), !this.options.ignoreStandalone && r(t.body) && s(i.body) && (l(t.body), a(i.body));
              } else e.closeStrip.open && l(t.body, null, !0);
              return c;
            }),
            (o.prototype.Decorator = o.prototype.MustacheStatement = function (e) {
              return e.strip;
            }),
            (o.prototype.PartialStatement = o.prototype.CommentStatement = function (e) {
              var t = e.strip || {};
              return { inlineStandalone: !0, open: t.open, close: t.close };
            }),
            (t.default = o),
            (e.exports = t.default);
        },
        function (e, t, n) {
          "use strict";
          function i(e) {
            return e && e.__esModule ? e : { default: e };
          }
          function o() {
            this.parents = [];
          }
          function r(e) {
            this.acceptRequired(e, "path"), this.acceptArray(e.params), this.acceptKey(e, "hash");
          }
          function s(e) {
            r.call(this, e), this.acceptKey(e, "program"), this.acceptKey(e, "inverse");
          }
          function a(e) {
            this.acceptRequired(e, "name"), this.acceptArray(e.params), this.acceptKey(e, "hash");
          }
          t.__esModule = !0;
          var l = n(4),
            c = i(l);
          (o.prototype = {
            constructor: o,
            mutating: !1,
            acceptKey: function (e, t) {
              var n = this.accept(e[t]);
              if (this.mutating) {
                if (n && !o.prototype[n.type]) throw new c.default('Unexpected node type "' + n.type + '" found when accepting ' + t + " on " + e.type);
                e[t] = n;
              }
            },
            acceptRequired: function (e, t) {
              if ((this.acceptKey(e, t), !e[t])) throw new c.default(e.type + " requires " + t);
            },
            acceptArray: function (e) {
              for (var t = 0, n = e.length; n > t; t++) this.acceptKey(e, t), e[t] || (e.splice(t, 1), t--, n--);
            },
            accept: function (e) {
              if (e) {
                if (!this[e.type]) throw new c.default("Unknown type: " + e.type, e);
                this.current && this.parents.unshift(this.current), (this.current = e);
                var t = this[e.type](e);
                return (this.current = this.parents.shift()), !this.mutating || t ? t : t !== !1 ? e : void 0;
              }
            },
            Program: function (e) {
              this.acceptArray(e.body);
            },
            MustacheStatement: r,
            Decorator: r,
            BlockStatement: s,
            DecoratorBlock: s,
            PartialStatement: a,
            PartialBlockStatement: function (e) {
              a.call(this, e), this.acceptKey(e, "program");
            },
            ContentStatement: function () {},
            CommentStatement: function () {},
            SubExpression: r,
            PathExpression: function () {},
            StringLiteral: function () {},
            NumberLiteral: function () {},
            BooleanLiteral: function () {},
            UndefinedLiteral: function () {},
            NullLiteral: function () {},
            Hash: function (e) {
              this.acceptArray(e.pairs);
            },
            HashPair: function (e) {
              this.acceptRequired(e, "value");
            },
          }),
            (t.default = o),
            (e.exports = t.default);
        },
        function (e, t, n) {
          "use strict";
          function i(e) {
            return e && e.__esModule ? e : { default: e };
          }
          function o(e, t) {
            if (((t = t.path ? t.path.original : t), e.path.original !== t)) {
              var n = { loc: e.path.loc };
              throw new v.default(e.path.original + " doesn't match " + t, n);
            }
          }
          function r(e, t) {
            (this.source = e), (this.start = { line: t.first_line, column: t.first_column }), (this.end = { line: t.last_line, column: t.last_column });
          }
          function s(e) {
            return /^\[.*\]$/.test(e) ? e.substr(1, e.length - 2) : e;
          }
          function a(e, t) {
            return { open: "~" === e.charAt(2), close: "~" === t.charAt(t.length - 3) };
          }
          function l(e) {
            return e.replace(/^\{\{~?\!-?-?/, "").replace(/-?-?~?\}\}$/, "");
          }
          function c(e, t, n) {
            n = this.locInfo(n);
            for (var i = e ? "@" : "", o = [], r = 0, s = 0, a = t.length; a > s; s++) {
              var l = t[s].part,
                c = t[s].original !== l;
              if (((i += (t[s].separator || "") + l), c || (".." !== l && "." !== l && "this" !== l))) o.push(l);
              else {
                if (o.length > 0) throw new v.default("Invalid path: " + i, { loc: n });
                ".." === l && r++;
              }
            }
            return { type: "PathExpression", data: e, depth: r, parts: o, original: i, loc: n };
          }
          function u(e, t, n, i, o, r) {
            var s = i.charAt(3) || i.charAt(2),
              a = "{" !== s && "&" !== s,
              l = /\*/.test(i);
            return { type: l ? "Decorator" : "MustacheStatement", path: e, params: t, hash: n, escaped: a, strip: o, loc: this.locInfo(r) };
          }
          function p(e, t, n, i) {
            o(e, n), (i = this.locInfo(i));
            var r = { type: "Program", body: t, strip: {}, loc: i };
            return { type: "BlockStatement", path: e.path, params: e.params, hash: e.hash, program: r, openStrip: {}, inverseStrip: {}, closeStrip: {}, loc: i };
          }
          function d(e, t, n, i, r, s) {
            i && i.path && o(e, i);
            var a = /\*/.test(e.open);
            t.blockParams = e.blockParams;
            var l = void 0,
              c = void 0;
            if (n) {
              if (a) throw new v.default("Unexpected inverse block on decorator", n);
              n.chain && (n.program.body[0].closeStrip = i.strip), (c = n.strip), (l = n.program);
            }
            return (
              r && ((r = l), (l = t), (t = r)),
              { type: a ? "DecoratorBlock" : "BlockStatement", path: e.path, params: e.params, hash: e.hash, program: t, inverse: l, openStrip: e.strip, inverseStrip: c, closeStrip: i && i.strip, loc: this.locInfo(s) }
            );
          }
          function f(e, t) {
            if (!t && e.length) {
              var n = e[0].loc,
                i = e[e.length - 1].loc;
              n && i && (t = { source: n.source, start: { line: n.start.line, column: n.start.column }, end: { line: i.end.line, column: i.end.column } });
            }
            return { type: "Program", body: e, strip: {}, loc: t };
          }
          function h(e, t, n, i) {
            return o(e, n), { type: "PartialBlockStatement", name: e.path, params: e.params, hash: e.hash, program: t, openStrip: e.strip, closeStrip: n && n.strip, loc: this.locInfo(i) };
          }
          (t.__esModule = !0),
            (t.SourceLocation = r),
            (t.id = s),
            (t.stripFlags = a),
            (t.stripComment = l),
            (t.preparePath = c),
            (t.prepareMustache = u),
            (t.prepareRawBlock = p),
            (t.prepareBlock = d),
            (t.prepareProgram = f),
            (t.preparePartialBlock = h);
          var m = n(4),
            v = i(m);
        },
        function (e, t, n) {
          "use strict";
          function i(e) {
            return e && e.__esModule ? e : { default: e };
          }
          function o() {}
          function r(e, t, n) {
            void 0 === t && (t = {}), a(e, t);
            var i = l(e, t, n);
            return new n.JavaScriptCompiler().compile(i, t);
          }
          function s(e, t, n) {
            function i() {
              var i = l(e, t, n),
                o = new n.JavaScriptCompiler().compile(i, t, void 0, !0);
              return n.template(o);
            }
            void 0 === t && (t = {}), a(e, t);
            var o = void 0;
            return function (e, t) {
              return o || (o = i()), o.call(this, e, t);
            };
          }
          function a(e, t) {
            if (null == e || ("string" != typeof e && "Program" !== e.type)) throw new d.default("You must pass a string or Handlebars AST to Handlebars.compile. You passed " + e);
            if (t.trackIds || t.stringParams) throw new d.default("TrackIds and stringParams are no longer supported. See Github #1145");
            "data" in t || (t.data = !0), t.compat && (t.useDepths = !0);
          }
          function l(e, t, n) {
            var i = n.parse(e, t);
            return new n.Compiler().compile(i, t);
          }
          function c(e, t) {
            if (e === t) return !0;
            if (f.isArray(e) && f.isArray(t) && e.length === t.length) {
              for (var n = 0; n < e.length; n++) if (!c(e[n], t[n])) return !1;
              return !0;
            }
          }
          function u(e) {
            if (!e.path.parts) {
              var t = e.path;
              e.path = { type: "PathExpression", data: !1, depth: 0, parts: [t.original + ""], original: t.original + "", loc: t.loc };
            }
          }
          (t.__esModule = !0), (t.Compiler = o), (t.precompile = r), (t.compile = s);
          var p = n(4),
            d = i(p),
            f = n(3),
            h = n(19),
            m = i(h),
            v = [].slice;
          o.prototype = {
            compiler: o,
            equals: function (e) {
              var t = this.opcodes.length;
              if (e.opcodes.length !== t) return !1;
              for (var n = 0; t > n; n++) {
                var i = this.opcodes[n],
                  o = e.opcodes[n];
                if (i.opcode !== o.opcode || !c(i.args, o.args)) return !1;
              }
              t = this.children.length;
              for (var n = 0; t > n; n++) if (!this.children[n].equals(e.children[n])) return !1;
              return !0;
            },
            guid: 0,
            compile: function (e, t) {
              (this.sourceNode = []), (this.opcodes = []), (this.children = []), (this.options = t), (t.blockParams = t.blockParams || []);
              var n = t.knownHelpers;
              if (((t.knownHelpers = { helperMissing: !0, blockHelperMissing: !0, each: !0, if: !0, unless: !0, with: !0, log: !0, lookup: !0 }), n)) for (var i in n) i in n && (t.knownHelpers[i] = n[i]);
              return this.accept(e);
            },
            compileProgram: function (e) {
              var t = new this.compiler(),
                n = t.compile(e, this.options),
                i = this.guid++;
              return (this.usePartial = this.usePartial || n.usePartial), (this.children[i] = n), (this.useDepths = this.useDepths || n.useDepths), i;
            },
            accept: function (e) {
              if (!this[e.type]) throw new d.default("Unknown type: " + e.type, e);
              this.sourceNode.unshift(e);
              var t = this[e.type](e);
              return this.sourceNode.shift(), t;
            },
            Program: function (e) {
              this.options.blockParams.unshift(e.blockParams);
              for (var t = e.body, n = t.length, i = 0; n > i; i++) this.accept(t[i]);
              return this.options.blockParams.shift(), (this.isSimple = 1 === n), (this.blockParams = e.blockParams ? e.blockParams.length : 0), this;
            },
            BlockStatement: function (e) {
              u(e);
              var t = e.program,
                n = e.inverse;
              (t = t && this.compileProgram(t)), (n = n && this.compileProgram(n));
              var i = this.classifySexpr(e);
              "helper" === i
                ? this.helperSexpr(e, t, n)
                : "simple" === i
                ? (this.simpleSexpr(e), this.opcode("pushProgram", t), this.opcode("pushProgram", n), this.opcode("emptyHash"), this.opcode("blockValue", e.path.original))
                : (this.ambiguousSexpr(e, t, n), this.opcode("pushProgram", t), this.opcode("pushProgram", n), this.opcode("emptyHash"), this.opcode("ambiguousBlockValue")),
                this.opcode("append");
            },
            DecoratorBlock: function (e) {
              var t = e.program && this.compileProgram(e.program),
                n = this.setupFullMustacheParams(e, t, void 0),
                i = e.path;
              (this.useDecorators = !0), this.opcode("registerDecorator", n.length, i.original);
            },
            PartialStatement: function (e) {
              this.usePartial = !0;
              var t = e.program;
              t && (t = this.compileProgram(e.program));
              var n = e.params;
              if (n.length > 1) throw new d.default("Unsupported number of partial arguments: " + n.length, e);
              n.length || (this.options.explicitPartialContext ? this.opcode("pushLiteral", "undefined") : n.push({ type: "PathExpression", parts: [], depth: 0 }));
              var i = e.name.original,
                o = "SubExpression" === e.name.type;
              o && this.accept(e.name), this.setupFullMustacheParams(e, t, void 0, !0);
              var r = e.indent || "";
              this.options.preventIndent && r && (this.opcode("appendContent", r), (r = "")), this.opcode("invokePartial", o, i, r), this.opcode("append");
            },
            PartialBlockStatement: function (e) {
              this.PartialStatement(e);
            },
            MustacheStatement: function (e) {
              this.SubExpression(e), e.escaped && !this.options.noEscape ? this.opcode("appendEscaped") : this.opcode("append");
            },
            Decorator: function (e) {
              this.DecoratorBlock(e);
            },
            ContentStatement: function (e) {
              e.value && this.opcode("appendContent", e.value);
            },
            CommentStatement: function () {},
            SubExpression: function (e) {
              u(e);
              var t = this.classifySexpr(e);
              "simple" === t ? this.simpleSexpr(e) : "helper" === t ? this.helperSexpr(e) : this.ambiguousSexpr(e);
            },
            ambiguousSexpr: function (e, t, n) {
              var i = e.path,
                o = i.parts[0],
                r = null != t || null != n;
              this.opcode("getContext", i.depth), this.opcode("pushProgram", t), this.opcode("pushProgram", n), (i.strict = !0), this.accept(i), this.opcode("invokeAmbiguous", o, r);
            },
            simpleSexpr: function (e) {
              var t = e.path;
              (t.strict = !0), this.accept(t), this.opcode("resolvePossibleLambda");
            },
            helperSexpr: function (e, t, n) {
              var i = this.setupFullMustacheParams(e, t, n),
                o = e.path,
                r = o.parts[0];
              if (this.options.knownHelpers[r]) this.opcode("invokeKnownHelper", i.length, r);
              else {
                if (this.options.knownHelpersOnly) throw new d.default("You specified knownHelpersOnly, but used the unknown helper " + r, e);
                (o.strict = !0), (o.falsy = !0), this.accept(o), this.opcode("invokeHelper", i.length, o.original, m.default.helpers.simpleId(o));
              }
            },
            PathExpression: function (e) {
              this.addDepth(e.depth), this.opcode("getContext", e.depth);
              var t = e.parts[0],
                n = m.default.helpers.scopedId(e),
                i = !e.depth && !n && this.blockParamIndex(t);
              i
                ? this.opcode("lookupBlockParam", i, e.parts)
                : t
                ? e.data
                  ? ((this.options.data = !0), this.opcode("lookupData", e.depth, e.parts, e.strict))
                  : this.opcode("lookupOnContext", e.parts, e.falsy, e.strict, n)
                : this.opcode("pushContext");
            },
            StringLiteral: function (e) {
              this.opcode("pushString", e.value);
            },
            NumberLiteral: function (e) {
              this.opcode("pushLiteral", e.value);
            },
            BooleanLiteral: function (e) {
              this.opcode("pushLiteral", e.value);
            },
            UndefinedLiteral: function () {
              this.opcode("pushLiteral", "undefined");
            },
            NullLiteral: function () {
              this.opcode("pushLiteral", "null");
            },
            Hash: function (e) {
              var t = e.pairs,
                n = 0,
                i = t.length;
              for (this.opcode("pushHash"); i > n; n++) this.pushParam(t[n].value);
              for (; n--; ) this.opcode("assignToHash", t[n].key);
              this.opcode("popHash");
            },
            opcode: function (e) {
              this.opcodes.push({ opcode: e, args: v.call(arguments, 1), loc: this.sourceNode[0].loc });
            },
            addDepth: function (e) {
              e && (this.useDepths = !0);
            },
            classifySexpr: function (e) {
              var t = m.default.helpers.simpleId(e.path),
                n = t && !!this.blockParamIndex(e.path.parts[0]),
                i = !n && m.default.helpers.helperExpression(e),
                o = !n && (i || t);
              if (o && !i) {
                var r = e.path.parts[0],
                  s = this.options;
                s.knownHelpers[r] ? (i = !0) : s.knownHelpersOnly && (o = !1);
              }
              return i ? "helper" : o ? "ambiguous" : "simple";
            },
            pushParams: function (e) {
              for (var t = 0, n = e.length; n > t; t++) this.pushParam(e[t]);
            },
            pushParam: function (e) {
              this.accept(e);
            },
            setupFullMustacheParams: function (e, t, n, i) {
              var o = e.params;
              return this.pushParams(o), this.opcode("pushProgram", t), this.opcode("pushProgram", n), e.hash ? this.accept(e.hash) : this.opcode("emptyHash", i), o;
            },
            blockParamIndex: function (e) {
              for (var t = 0, n = this.options.blockParams.length; n > t; t++) {
                var i = this.options.blockParams[t],
                  o = i && f.indexOf(i, e);
                if (i && o >= 0) return [t, o];
              }
            },
          };
        },
        function (e, t, n) {
          "use strict";
          function i(e) {
            return e && e.__esModule ? e : { default: e };
          }
          function o(e) {
            this.value = e;
          }
          function r() {}
          function s(e, t, n, i) {
            var o = t.popStack(),
              r = 0,
              s = n.length;
            for (e && s--; s > r; r++) o = t.nameLookup(o, n[r], i);
            return e ? [t.aliasable("container.strict"), "(", o, ", ", t.quotedString(n[r]), ")"] : o;
          }
          t.__esModule = !0;
          var a = n(2),
            l = n(4),
            c = i(l),
            u = n(3),
            p = n(27),
            d = i(p);
          (r.prototype = {
            nameLookup: function (e, t) {
              return r.isValidJavaScriptVariableName(t) ? [e, ".", t] : [e, "[", JSON.stringify(t), "]"];
            },
            depthedLookup: function (e) {
              return [this.aliasable("container.lookup"), '(depths, "', e, '")'];
            },
            compilerInfo: function () {
              var e = a.COMPILER_REVISION,
                t = a.REVISION_CHANGES[e];
              return [e, t];
            },
            appendToBuffer: function (e, t, n) {
              return u.isArray(e) || (e = [e]), (e = this.source.wrap(e, t)), this.environment.isSimple ? ["return ", e, ";"] : n ? ["buffer += ", e, ";"] : ((e.appendToBuffer = !0), e);
            },
            initializeBuffer: function () {
              return this.quotedString("");
            },
            compile: function (e, t, n, i) {
              (this.environment = e),
                (this.options = t),
                (this.precompile = !i),
                (this.name = this.environment.name),
                (this.isChild = !!n),
                (this.context = n || { decorators: [], programs: [], environments: [] }),
                this.preamble(),
                (this.stackSlot = 0),
                (this.stackVars = []),
                (this.aliases = {}),
                (this.registers = { list: [] }),
                (this.hashes = []),
                (this.compileStack = []),
                (this.inlineStack = []),
                (this.blockParams = []),
                this.compileChildren(e, t),
                (this.useDepths = this.useDepths || e.useDepths || e.useDecorators || this.options.compat),
                (this.useBlockParams = this.useBlockParams || e.useBlockParams);
              var o = e.opcodes,
                r = void 0,
                s = void 0,
                a = void 0,
                l = void 0;
              for (a = 0, l = o.length; l > a; a++) (r = o[a]), (this.source.currentLocation = r.loc), (s = s || r.loc), this[r.opcode].apply(this, r.args);
              if (((this.source.currentLocation = s), this.pushSource(""), this.stackSlot || this.inlineStack.length || this.compileStack.length)) throw new c.default("Compile completed with content left on stack");
              this.decorators.isEmpty()
                ? (this.decorators = void 0)
                : ((this.useDecorators = !0),
                  this.decorators.prepend("var decorators = container.decorators;\n"),
                  this.decorators.push("return fn;"),
                  i
                    ? (this.decorators = Function.apply(this, ["fn", "props", "container", "depth0", "data", "blockParams", "depths", this.decorators.merge()]))
                    : (this.decorators.prepend("function(fn, props, container, depth0, data, blockParams, depths) {\n"), this.decorators.push("}\n"), (this.decorators = this.decorators.merge())));
              var u = this.createFunctionContext(i);
              if (this.isChild) return u;
              var p = { compiler: this.compilerInfo(), main: u };
              this.decorators && ((p.main_d = this.decorators), (p.useDecorators = !0));
              var d = this.context,
                f = d.programs,
                h = d.decorators;
              for (a = 0, l = f.length; l > a; a++) f[a] && ((p[a] = f[a]), h[a] && ((p[a + "_d"] = h[a]), (p.useDecorators = !0)));
              return (
                this.environment.usePartial && (p.usePartial = !0),
                this.options.data && (p.useData = !0),
                this.useDepths && (p.useDepths = !0),
                this.useBlockParams && (p.useBlockParams = !0),
                this.options.compat && (p.compat = !0),
                i
                  ? (p.compilerOptions = this.options)
                  : ((p.compiler = JSON.stringify(p.compiler)),
                    (this.source.currentLocation = { start: { line: 1, column: 0 } }),
                    (p = this.objectLiteral(p)),
                    t.srcName ? ((p = p.toStringWithSourceMap({ file: t.destName })), (p.map = p.map && p.map.toString())) : (p = p.toString())),
                p
              );
            },
            preamble: function () {
              (this.lastContext = 0), (this.source = new d.default(this.options.srcName)), (this.decorators = new d.default(this.options.srcName));
            },
            createFunctionContext: function (e) {
              var t = "",
                n = this.stackVars.concat(this.registers.list);
              n.length > 0 && (t += ", " + n.join(", "));
              var i = 0;
              for (var o in this.aliases) {
                var r = this.aliases[o];
                this.aliases.hasOwnProperty(o) && r.children && r.referenceCount > 1 && ((t += ", alias" + ++i + "=" + o), (r.children[0] = "alias" + i));
              }
              var s = ["container", "depth0", "helpers", "partials", "data"];
              (this.useBlockParams || this.useDepths) && s.push("blockParams"), this.useDepths && s.push("depths");
              var a = this.mergeSource(t);
              return e ? (s.push(a), Function.apply(this, s)) : this.source.wrap(["function(", s.join(","), ") {\n  ", a, "}"]);
            },
            mergeSource: function (e) {
              var t = this.environment.isSimple,
                n = !this.forceBuffer,
                i = void 0,
                o = void 0,
                r = void 0,
                s = void 0;
              return (
                this.source.each(function (e) {
                  e.appendToBuffer ? (r ? e.prepend("  + ") : (r = e), (s = e)) : (r && (o ? r.prepend("buffer += ") : (i = !0), s.add(";"), (r = s = void 0)), (o = !0), t || (n = !1));
                }),
                n
                  ? r
                    ? (r.prepend("return "), s.add(";"))
                    : o || this.source.push('return "";')
                  : ((e += ", buffer = " + (i ? "" : this.initializeBuffer())), r ? (r.prepend("return buffer + "), s.add(";")) : this.source.push("return buffer;")),
                e && this.source.prepend("var " + e.substring(2) + (i ? "" : ";\n")),
                this.source.merge()
              );
            },
            blockValue: function (e) {
              var t = this.aliasable("helpers.blockHelperMissing"),
                n = [this.contextName(0)];
              this.setupHelperArgs(e, 0, n);
              var i = this.popStack();
              n.splice(1, 0, i), this.push(this.source.functionCall(t, "call", n));
            },
            ambiguousBlockValue: function () {
              var e = this.aliasable("helpers.blockHelperMissing"),
                t = [this.contextName(0)];
              this.setupHelperArgs("", 0, t, !0), this.flushInline();
              var n = this.topStack();
              t.splice(1, 0, n), this.pushSource(["if (!", this.lastHelper, ") { ", n, " = ", this.source.functionCall(e, "call", t), "}"]);
            },
            appendContent: function (e) {
              this.pendingContent ? (e = this.pendingContent + e) : (this.pendingLocation = this.source.currentLocation), (this.pendingContent = e);
            },
            append: function () {
              if (this.isInline())
                this.replaceStack(function (e) {
                  return [" != null ? ", e, ' : ""'];
                }),
                  this.pushSource(this.appendToBuffer(this.popStack()));
              else {
                var e = this.popStack();
                this.pushSource(["if (", e, " != null) { ", this.appendToBuffer(e, void 0, !0), " }"]), this.environment.isSimple && this.pushSource(["else { ", this.appendToBuffer("''", void 0, !0), " }"]);
              }
            },
            appendEscaped: function () {
              this.pushSource(this.appendToBuffer([this.aliasable("container.escapeExpression"), "(", this.popStack(), ")"]));
            },
            getContext: function (e) {
              this.lastContext = e;
            },
            pushContext: function () {
              this.pushStackLiteral(this.contextName(this.lastContext));
            },
            lookupOnContext: function (e, t, n, i) {
              var o = 0;
              i || !this.options.compat || this.lastContext ? this.pushContext() : this.push(this.depthedLookup(e[o++])), this.resolvePath("context", e, o, t, n);
            },
            lookupBlockParam: function (e, t) {
              (this.useBlockParams = !0), this.push(["blockParams[", e[0], "][", e[1], "]"]), this.resolvePath("context", t, 1);
            },
            lookupData: function (e, t, n) {
              e ? this.pushStackLiteral("container.data(data, " + e + ")") : this.pushStackLiteral("data"), this.resolvePath("data", t, 0, !0, n);
            },
            resolvePath: function (e, t, n, i, o) {
              var r = this;
              if (this.options.strict || this.options.assumeObjects) return void this.push(s(this.options.strict && o, this, t, e));
              for (var a = t.length; a > n; n++)
                this.replaceStack(function (o) {
                  var s = r.nameLookup(o, t[n], e);
                  return i ? [" && ", s] : [" != null ? ", s, " : ", o];
                });
            },
            resolvePossibleLambda: function () {
              this.push([this.aliasable("container.lambda"), "(", this.popStack(), ", ", this.contextName(0), ")"]);
            },
            emptyHash: function (e) {
              this.pushStackLiteral(e ? "undefined" : "{}");
            },
            pushHash: function () {
              this.hash && this.hashes.push(this.hash), (this.hash = { values: {} });
            },
            popHash: function () {
              var e = this.hash;
              (this.hash = this.hashes.pop()), this.push(this.objectLiteral(e.values));
            },
            pushString: function (e) {
              this.pushStackLiteral(this.quotedString(e));
            },
            pushLiteral: function (e) {
              this.pushStackLiteral(e);
            },
            pushProgram: function (e) {
              null != e ? this.pushStackLiteral(this.programExpression(e)) : this.pushStackLiteral(null);
            },
            registerDecorator: function (e, t) {
              var n = this.nameLookup("decorators", t, "decorator"),
                i = this.setupHelperArgs(t, e);
              this.decorators.push(["fn = ", this.decorators.functionCall(n, "", ["fn", "props", "container", i]), " || fn;"]);
            },
            invokeHelper: function (e, t, n) {
              var i = this.popStack(),
                o = this.setupHelper(e, t),
                r = n ? [o.name, " || "] : "",
                s = ["("].concat(r, i);
              this.options.strict || s.push(" || ", this.aliasable("helpers.helperMissing")), s.push(")"), this.push(this.source.functionCall(s, "call", o.callParams));
            },
            invokeKnownHelper: function (e, t) {
              var n = this.setupHelper(e, t);
              this.push(this.source.functionCall(n.name, "call", n.callParams));
            },
            invokeAmbiguous: function (e, t) {
              this.useRegister("helper");
              var n = this.popStack();
              this.emptyHash();
              var i = this.setupHelper(0, e, t),
                o = (this.lastHelper = this.nameLookup("helpers", e, "helper")),
                r = ["(", "(helper = ", o, " || ", n, ")"];
              this.options.strict || ((r[0] = "(helper = "), r.push(" != null ? helper : ", this.aliasable("helpers.helperMissing"))),
                this.push(["(", r, i.paramsInit ? ["),(", i.paramsInit] : [], "),", "(typeof helper === ", this.aliasable('"function"'), " ? ", this.source.functionCall("helper", "call", i.callParams), " : helper))"]);
            },
            invokePartial: function (e, t, n) {
              var i = [],
                o = this.setupParams(t, 1, i);
              e && ((t = this.popStack()), delete o.name),
                n && (o.indent = JSON.stringify(n)),
                (o.helpers = "helpers"),
                (o.partials = "partials"),
                (o.decorators = "container.decorators"),
                e ? i.unshift(t) : i.unshift(this.nameLookup("partials", t, "partial")),
                this.options.compat && (o.depths = "depths"),
                (o = this.objectLiteral(o)),
                i.push(o),
                this.push(this.source.functionCall("container.invokePartial", "", i));
            },
            assignToHash: function (e) {
              this.hash.values[e] = this.popStack();
            },
            compiler: r,
            compileChildren: function (e, t) {
              for (var n = e.children, i = void 0, o = void 0, r = 0, s = n.length; s > r; r++) {
                (i = n[r]), (o = new this.compiler());
                var a = this.matchExistingProgram(i);
                if (null == a) {
                  this.context.programs.push("");
                  var l = this.context.programs.length;
                  (i.index = l),
                    (i.name = "program" + l),
                    (this.context.programs[l] = o.compile(i, t, this.context, !this.precompile)),
                    (this.context.decorators[l] = o.decorators),
                    (this.context.environments[l] = i),
                    (this.useDepths = this.useDepths || o.useDepths),
                    (this.useBlockParams = this.useBlockParams || o.useBlockParams),
                    (i.useDepths = this.useDepths),
                    (i.useBlockParams = this.useBlockParams);
                } else (i.index = a.index), (i.name = "program" + a.index), (this.useDepths = this.useDepths || a.useDepths), (this.useBlockParams = this.useBlockParams || a.useBlockParams);
              }
            },
            matchExistingProgram: function (e) {
              for (var t = 0, n = this.context.environments.length; n > t; t++) {
                var i = this.context.environments[t];
                if (i && i.equals(e)) return i;
              }
            },
            programExpression: function (e) {
              var t = this.environment.children[e],
                n = [t.index, "data", t.blockParams];
              return (this.useBlockParams || this.useDepths) && n.push("blockParams"), this.useDepths && n.push("depths"), "container.program(" + n.join(", ") + ")";
            },
            useRegister: function (e) {
              this.registers[e] || ((this.registers[e] = !0), this.registers.list.push(e));
            },
            push: function (e) {
              return e instanceof o || (e = this.source.wrap(e)), this.inlineStack.push(e), e;
            },
            pushStackLiteral: function (e) {
              this.push(new o(e));
            },
            pushSource: function (e) {
              this.pendingContent && (this.source.push(this.appendToBuffer(this.source.quotedString(this.pendingContent), this.pendingLocation)), (this.pendingContent = void 0)), e && this.source.push(e);
            },
            replaceStack: function (e) {
              var t = ["("],
                n = void 0,
                i = void 0,
                r = void 0;
              if (!this.isInline()) throw new c.default("replaceStack on non-inline");
              var s = this.popStack(!0);
              if (s instanceof o) (n = [s.value]), (t = ["(", n]), (r = !0);
              else {
                i = !0;
                var a = this.incrStack();
                (t = ["((", this.push(a), " = ", s, ")"]), (n = this.topStack());
              }
              var l = e.call(this, n);
              r || this.popStack(), i && this.stackSlot--, this.push(t.concat(l, ")"));
            },
            incrStack: function () {
              return this.stackSlot++, this.stackSlot > this.stackVars.length && this.stackVars.push("stack" + this.stackSlot), this.topStackName();
            },
            topStackName: function () {
              return "stack" + this.stackSlot;
            },
            flushInline: function () {
              var e = this.inlineStack;
              this.inlineStack = [];
              for (var t = 0, n = e.length; n > t; t++) {
                var i = e[t];
                if (i instanceof o) this.compileStack.push(i);
                else {
                  var r = this.incrStack();
                  this.pushSource([r, " = ", i, ";"]), this.compileStack.push(r);
                }
              }
            },
            isInline: function () {
              return this.inlineStack.length;
            },
            popStack: function (e) {
              var t = this.isInline(),
                n = (t ? this.inlineStack : this.compileStack).pop();
              if (!e && n instanceof o) return n.value;
              if (!t) {
                if (!this.stackSlot) throw new c.default("Invalid stack pop");
                this.stackSlot--;
              }
              return n;
            },
            topStack: function () {
              var e = this.isInline() ? this.inlineStack : this.compileStack,
                t = e[e.length - 1];
              return t instanceof o ? t.value : t;
            },
            contextName: function (e) {
              return this.useDepths && e ? "depths[" + e + "]" : "depth" + e;
            },
            quotedString: function (e) {
              return this.source.quotedString(e);
            },
            objectLiteral: function (e) {
              return this.source.objectLiteral(e);
            },
            aliasable: function (e) {
              var t = this.aliases[e];
              return t ? (t.referenceCount++, t) : ((t = this.aliases[e] = this.source.wrap(e)), (t.aliasable = !0), (t.referenceCount = 1), t);
            },
            setupHelper: function (e, t, n) {
              var i = [],
                o = this.setupHelperArgs(t, e, i, n),
                r = this.nameLookup("helpers", t, "helper"),
                s = this.aliasable(this.contextName(0) + " != null ? " + this.contextName(0) + " : {}");
              return { params: i, paramsInit: o, name: r, callParams: [s].concat(i) };
            },
            setupParams: function (e, t, n) {
              var i = {},
                o = !n,
                r = void 0;
              o && (n = []), (i.name = this.quotedString(e)), (i.hash = this.popStack());
              var s = this.popStack(),
                a = this.popStack();
              (a || s) && ((i.fn = a || "container.noop"), (i.inverse = s || "container.noop"));
              for (var l = t; l--; ) (r = this.popStack()), (n[l] = r);
              return o && (i.args = this.source.generateArray(n)), this.options.data && (i.data = "data"), this.useBlockParams && (i.blockParams = "blockParams"), i;
            },
            setupHelperArgs: function (e, t, n, i) {
              var o = this.setupParams(e, t, n);
              return (o = this.objectLiteral(o)), i ? (this.useRegister("options"), n.push("options"), ["options=", o]) : n ? (n.push(o), "") : o;
            },
          }),
            (function () {
              for (
                var e = "break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield await null true false".split(
                    " "
                  ),
                  t = (r.RESERVED_WORDS = {}),
                  n = 0,
                  i = e.length;
                i > n;
                n++
              )
                t[e[n]] = !0;
            })(),
            (r.isValidJavaScriptVariableName = function (e) {
              return !r.RESERVED_WORDS[e] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(e);
            }),
            (t.default = r),
            (e.exports = t.default);
        },
        function (e, t, n) {
          "use strict";
          function i(e, t, n) {
            if (r.isArray(e)) {
              for (var i = [], o = 0, s = e.length; s > o; o++) i.push(t.wrap(e[o], n));
              return i;
            }
            return "boolean" == typeof e || "number" == typeof e ? e + "" : e;
          }
          function o(e) {
            (this.srcFile = e), (this.source = []);
          }
          t.__esModule = !0;
          var r = n(3),
            s = void 0;
          try {
          } catch (e) {}
          s ||
            ((s = function (e, t, n, i) {
              (this.src = ""), i && this.add(i);
            }),
            (s.prototype = {
              add: function (e) {
                r.isArray(e) && (e = e.join("")), (this.src += e);
              },
              prepend: function (e) {
                r.isArray(e) && (e = e.join("")), (this.src = e + this.src);
              },
              toStringWithSourceMap: function () {
                return { code: this.toString() };
              },
              toString: function () {
                return this.src;
              },
            })),
            (o.prototype = {
              isEmpty: function () {
                return !this.source.length;
              },
              prepend: function (e, t) {
                this.source.unshift(this.wrap(e, t));
              },
              push: function (e, t) {
                this.source.push(this.wrap(e, t));
              },
              merge: function () {
                var e = this.empty();
                return (
                  this.each(function (t) {
                    e.add(["  ", t, "\n"]);
                  }),
                  e
                );
              },
              each: function (e) {
                for (var t = 0, n = this.source.length; n > t; t++) e(this.source[t]);
              },
              empty: function () {
                var e = this.currentLocation || { start: {} };
                return new s(e.start.line, e.start.column, this.srcFile);
              },
              wrap: function (e) {
                var t = arguments.length <= 1 || void 0 === arguments[1] ? this.currentLocation || { start: {} } : arguments[1];
                return e instanceof s ? e : ((e = i(e, this, t)), new s(t.start.line, t.start.column, this.srcFile, e));
              },
              functionCall: function (e, t, n) {
                return (n = this.generateList(n)), this.wrap([e, t ? "." + t + "(" : "(", n, ")"]);
              },
              quotedString: function (e) {
                return (
                  '"' +
                  (e + "")
                    .replace(/\\/g, "\\\\")
                    .replace(/"/g, '\\"')
                    .replace(/\n/g, "\\n")
                    .replace(/\r/g, "\\r")
                    .replace(/\u2028/g, "\\u2028")
                    .replace(/\u2029/g, "\\u2029") +
                  '"'
                );
              },
              objectLiteral: function (e) {
                var t = [];
                for (var n in e)
                  if (e.hasOwnProperty(n)) {
                    var o = i(e[n], this);
                    "undefined" !== o && t.push([this.quotedString(n), ":", o]);
                  }
                var r = this.generateList(t);
                return r.prepend("{"), r.add("}"), r;
              },
              generateList: function (e) {
                for (var t = this.empty(), n = 0, o = e.length; o > n; n++) n && t.add(","), t.add(i(e[n], this));
                return t;
              },
              generateArray: function (e) {
                var t = this.generateList(e);
                return t.prepend("["), t.add("]"), t;
              },
            }),
            (t.default = o),
            (e.exports = t.default);
        },
      ]);
    }),
    !(function (e) {
      e.fn.prepareTransition = function () {
        return this.each(function () {
          var t = e(this);
          t.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", function () {
            t.removeClass("is-transitioning");
          });
          var n = ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"],
            i = 0;
          e.each(n, function (e, n) {
            i = parseFloat(t.css(n)) || i;
          }),
            0 != i && (t.addClass("is-transitioning"), t[0].offsetWidth);
        });
      };
    })(jQuery)
    /*
     * jQuery throttle / debounce - v1.1 - 3/7/2010
     * http://benalman.com/projects/jquery-throttle-debounce-plugin/
     *
     * Copyright (c) 2010 "Cowboy" Ben Alman
     * Dual licensed under the MIT and GPL licenses.
     * http://benalman.com/about/license/
     */,
    (function (e, t) {
      var n,
        i = e.jQuery || e.Cowboy || (e.Cowboy = {});
      (i.throttle = n = function (e, n, o, r) {
        function s() {
          function i() {
            (l = +new Date()), o.apply(c, p);
          }
          function s() {
            a = t;
          }
          var c = this,
            u = +new Date() - l,
            p = arguments;
          r && !a && i(), a && clearTimeout(a), r === t && u > e ? i() : n !== !0 && (a = setTimeout(r ? s : i, r === t ? e - u : e));
        }
        var a,
          l = 0;
        return "boolean" != typeof n && ((r = o), (o = n), (n = t)), i.guid && (s.guid = o.guid = o.guid || i.guid++), s;
      }),
        (i.debounce = function (e, i, o) {
          return o === t ? n(e, i, !1) : n(e, o, i !== !1);
        });
    })(this),
    !(function (e, t) {
      "object" == typeof exports && "object" == typeof module ? (module.exports = t()) : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? (exports.AOS = t()) : (e.AOS = t());
    })(this, function () {
      return (function (e) {
        function t(i) {
          if (n[i]) return n[i].exports;
          var o = (n[i] = { exports: {}, id: i, loaded: !1 });
          return e[i].call(o.exports, o, o.exports, t), (o.loaded = !0), o.exports;
        }
        var n = {};
        return (t.m = e), (t.c = n), (t.p = "dist/"), t(0);
      })([
        function (e, t, n) {
          "use strict";
          function i(e) {
            return e && e.__esModule ? e : { default: e };
          }
          var o =
              Object.assign ||
              function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
                }
                return e;
              },
            r = n(1),
            s = (i(r), n(6)),
            a = i(s),
            l = n(7),
            c = i(l),
            u = n(8),
            p = i(u),
            d = n(9),
            f = i(d),
            h = n(10),
            m = i(h),
            v = n(11),
            g = i(v),
            y = n(14),
            b = i(y),
            w = [],
            x = !1,
            k = document.all && !window.atob,
            S = { offset: 120, delay: 0, easing: "ease", duration: 400, disable: !1, once: !1, startEvent: "DOMContentLoaded", disableMutationObserver: !1 },
            C = function () {
              var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
              if ((e && (x = !0), x)) return (w = (0, g.default)(w, S)), (0, m.default)(w, S.once), w;
            },
            T = function () {
              (w = (0, b.default)()), C();
            },
            E = function () {
              w.forEach(function (e, t) {
                e.node.removeAttribute("data-aos"), e.node.removeAttribute("data-aos-easing"), e.node.removeAttribute("data-aos-duration"), e.node.removeAttribute("data-aos-delay");
              });
            },
            _ = function (e) {
              return e === !0 || ("mobile" === e && f.default.mobile()) || ("phone" === e && f.default.phone()) || ("tablet" === e && f.default.tablet()) || ("function" == typeof e && e() === !0);
            },
            A = function (e) {
              return (
                (S = o(S, e)),
                (w = (0, b.default)()),
                _(S.disable) || k
                  ? E()
                  : (document.querySelector("body").setAttribute("data-aos-easing", S.easing),
                    document.querySelector("body").setAttribute("data-aos-duration", S.duration),
                    document.querySelector("body").setAttribute("data-aos-delay", S.delay),
                    "DOMContentLoaded" === S.startEvent && ["complete", "interactive"].indexOf(document.readyState) > -1
                      ? C(!0)
                      : "load" === S.startEvent
                      ? window.addEventListener(S.startEvent, function () {
                          C(!0);
                        })
                      : document.addEventListener(S.startEvent, function () {
                          C(!0);
                        }),
                    window.addEventListener("resize", (0, c.default)(C, 50, !0)),
                    window.addEventListener("orientationchange", (0, c.default)(C, 50, !0)),
                    window.addEventListener(
                      "scroll",
                      (0, a.default)(function () {
                        (0, m.default)(w, S.once);
                      }, 99)
                    ),
                    S.disableMutationObserver || (0, p.default)("[data-aos]", T),
                    w)
              );
            };
          e.exports = { init: A, refresh: C, refreshHard: T };
        },
        function (e, t) {},
        ,
        ,
        ,
        ,
        function (e, t) {
          (function (t) {
            "use strict";
            function n(e, t, n) {
              function i(t) {
                var n = m,
                  i = v;
                return (m = v = void 0), (x = t), (y = e.apply(i, n));
              }
              function r(e) {
                return (x = e), (b = setTimeout(u, t)), T ? i(e) : y;
              }
              function s(e) {
                var n = e - w,
                  i = e - x,
                  o = t - n;
                return E ? S(o, g - i) : o;
              }
              function l(e) {
                var n = e - w,
                  i = e - x;
                return void 0 === w || n >= t || n < 0 || (E && i >= g);
              }
              function u() {
                var e = C();
                return l(e) ? p(e) : void (b = setTimeout(u, s(e)));
              }
              function p(e) {
                return (b = void 0), _ && m ? i(e) : ((m = v = void 0), y);
              }
              function d() {
                void 0 !== b && clearTimeout(b), (x = 0), (m = w = v = b = void 0);
              }
              function f() {
                return void 0 === b ? y : p(C());
              }
              function h() {
                var e = C(),
                  n = l(e);
                if (((m = arguments), (v = this), (w = e), n)) {
                  if (void 0 === b) return r(w);
                  if (E) return (b = setTimeout(u, t)), i(w);
                }
                return void 0 === b && (b = setTimeout(u, t)), y;
              }
              var m,
                v,
                g,
                y,
                b,
                w,
                x = 0,
                T = !1,
                E = !1,
                _ = !0;
              if ("function" != typeof e) throw new TypeError(c);
              return (t = a(t) || 0), o(n) && ((T = !!n.leading), (E = "maxWait" in n), (g = E ? k(a(n.maxWait) || 0, t) : g), (_ = "trailing" in n ? !!n.trailing : _)), (h.cancel = d), (h.flush = f), h;
            }
            function i(e, t, i) {
              var r = !0,
                s = !0;
              if ("function" != typeof e) throw new TypeError(c);
              return o(i) && ((r = "leading" in i ? !!i.leading : r), (s = "trailing" in i ? !!i.trailing : s)), n(e, t, { leading: r, maxWait: t, trailing: s });
            }
            function o(e) {
              var t = "undefined" == typeof e ? "undefined" : l(e);
              return !!e && ("object" == t || "function" == t);
            }
            function r(e) {
              return !!e && "object" == ("undefined" == typeof e ? "undefined" : l(e));
            }
            function s(e) {
              return "symbol" == ("undefined" == typeof e ? "undefined" : l(e)) || (r(e) && x.call(e) == p);
            }
            function a(e) {
              if ("number" == typeof e) return e;
              if (s(e)) return u;
              if (o(e)) {
                var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                e = o(t) ? t + "" : t;
              }
              if ("string" != typeof e) return 0 === e ? e : +e;
              e = e.replace(d, "");
              var n = h.test(e);
              return n || m.test(e) ? v(e.slice(2), n ? 2 : 8) : f.test(e) ? u : +e;
            }
            var l =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                  ? function (e) {
                      return typeof e;
                    }
                  : function (e) {
                      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    },
              c = "Expected a function",
              u = NaN,
              p = "[object Symbol]",
              d = /^\s+|\s+$/g,
              f = /^[-+]0x[0-9a-f]+$/i,
              h = /^0b[01]+$/i,
              m = /^0o[0-7]+$/i,
              v = parseInt,
              g = "object" == ("undefined" == typeof t ? "undefined" : l(t)) && t && t.Object === Object && t,
              y = "object" == ("undefined" == typeof self ? "undefined" : l(self)) && self && self.Object === Object && self,
              b = g || y || Function("return this")(),
              w = Object.prototype,
              x = w.toString,
              k = Math.max,
              S = Math.min,
              C = function () {
                return b.Date.now();
              };
            e.exports = i;
          }.call(
            t,
            (function () {
              return this;
            })()
          ));
        },
        function (e, t) {
          (function (t) {
            "use strict";
            function n(e, t, n) {
              function o(t) {
                var n = m,
                  i = v;
                return (m = v = void 0), (C = t), (y = e.apply(i, n));
              }
              function r(e) {
                return (C = e), (b = setTimeout(u, t)), T ? o(e) : y;
              }
              function a(e) {
                var n = e - w,
                  i = e - C,
                  o = t - n;
                return E ? k(o, g - i) : o;
              }
              function c(e) {
                var n = e - w,
                  i = e - C;
                return void 0 === w || n >= t || n < 0 || (E && i >= g);
              }
              function u() {
                var e = S();
                return c(e) ? p(e) : void (b = setTimeout(u, a(e)));
              }
              function p(e) {
                return (b = void 0), _ && m ? o(e) : ((m = v = void 0), y);
              }
              function d() {
                void 0 !== b && clearTimeout(b), (C = 0), (m = w = v = b = void 0);
              }
              function f() {
                return void 0 === b ? y : p(S());
              }
              function h() {
                var e = S(),
                  n = c(e);
                if (((m = arguments), (v = this), (w = e), n)) {
                  if (void 0 === b) return r(w);
                  if (E) return (b = setTimeout(u, t)), o(w);
                }
                return void 0 === b && (b = setTimeout(u, t)), y;
              }
              var m,
                v,
                g,
                y,
                b,
                w,
                C = 0,
                T = !1,
                E = !1,
                _ = !0;
              if ("function" != typeof e) throw new TypeError(l);
              return (t = s(t) || 0), i(n) && ((T = !!n.leading), (E = "maxWait" in n), (g = E ? x(s(n.maxWait) || 0, t) : g), (_ = "trailing" in n ? !!n.trailing : _)), (h.cancel = d), (h.flush = f), h;
            }
            function i(e) {
              var t = "undefined" == typeof e ? "undefined" : a(e);
              return !!e && ("object" == t || "function" == t);
            }
            function o(e) {
              return !!e && "object" == ("undefined" == typeof e ? "undefined" : a(e));
            }
            function r(e) {
              return "symbol" == ("undefined" == typeof e ? "undefined" : a(e)) || (o(e) && w.call(e) == u);
            }
            function s(e) {
              if ("number" == typeof e) return e;
              if (r(e)) return c;
              if (i(e)) {
                var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                e = i(t) ? t + "" : t;
              }
              if ("string" != typeof e) return 0 === e ? e : +e;
              e = e.replace(p, "");
              var n = f.test(e);
              return n || h.test(e) ? m(e.slice(2), n ? 2 : 8) : d.test(e) ? c : +e;
            }
            var a =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                  ? function (e) {
                      return typeof e;
                    }
                  : function (e) {
                      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    },
              l = "Expected a function",
              c = NaN,
              u = "[object Symbol]",
              p = /^\s+|\s+$/g,
              d = /^[-+]0x[0-9a-f]+$/i,
              f = /^0b[01]+$/i,
              h = /^0o[0-7]+$/i,
              m = parseInt,
              v = "object" == ("undefined" == typeof t ? "undefined" : a(t)) && t && t.Object === Object && t,
              g = "object" == ("undefined" == typeof self ? "undefined" : a(self)) && self && self.Object === Object && self,
              y = v || g || Function("return this")(),
              b = Object.prototype,
              w = b.toString,
              x = Math.max,
              k = Math.min,
              S = function () {
                return y.Date.now();
              };
            e.exports = n;
          }.call(
            t,
            (function () {
              return this;
            })()
          ));
        },
        function (e, t) {
          "use strict";
          function n(e, t) {
            var n = new r(i);
            (s = t), n.observe(o.documentElement, { childList: !0, subtree: !0, removedNodes: !0 });
          }
          function i(e) {
            e &&
              e.forEach(function (e) {
                var t = Array.prototype.slice.call(e.addedNodes),
                  n = Array.prototype.slice.call(e.removedNodes),
                  i = t.concat(n).filter(function (e) {
                    return e.hasAttribute && e.hasAttribute("data-aos");
                  }).length;
                i && s();
              });
          }
          Object.defineProperty(t, "__esModule", { value: !0 });
          var o = window.document,
            r = window.MutationObserver || window.WebKitMutationObserver,
            s = function () {};
          t.default = n;
        },
        function (e, t) {
          "use strict";
          function n(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }
          function i() {
            return navigator.userAgent || navigator.vendor || window.opera || "";
          }
          Object.defineProperty(t, "__esModule", { value: !0 });
          var o = (function () {
              function e(e, t) {
                for (var n = 0; n < t.length; n++) {
                  var i = t[n];
                  (i.enumerable = i.enumerable || !1), (i.configurable = !0), "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
                }
              }
              return function (t, n, i) {
                return n && e(t.prototype, n), i && e(t, i), t;
              };
            })(),
            r = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
            s = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
            a = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,
            l = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
            c = (function () {
              function e() {
                n(this, e);
              }
              return (
                o(e, [
                  {
                    key: "phone",
                    value: function () {
                      var e = i();
                      return !(!r.test(e) && !s.test(e.substr(0, 4)));
                    },
                  },
                  {
                    key: "mobile",
                    value: function () {
                      var e = i();
                      return !(!a.test(e) && !l.test(e.substr(0, 4)));
                    },
                  },
                  {
                    key: "tablet",
                    value: function () {
                      return this.mobile() && !this.phone();
                    },
                  },
                ]),
                e
              );
            })();
          t.default = new c();
        },
        function (e, t) {
          "use strict";
          Object.defineProperty(t, "__esModule", { value: !0 });
          var n = function (e, t, n) {
              var i = e.node.getAttribute("data-aos-once");
              t > e.position ? e.node.classList.add("aos-animate") : "undefined" != typeof i && ("false" === i || (!n && "true" !== i)) && e.node.classList.remove("aos-animate");
            },
            i = function (e, t) {
              var i = window.pageYOffset,
                o = window.innerHeight;
              e.forEach(function (e, r) {
                n(e, o + i, t);
              });
            };
          t.default = i;
        },
        function (e, t, n) {
          "use strict";
          function i(e) {
            return e && e.__esModule ? e : { default: e };
          }
          Object.defineProperty(t, "__esModule", { value: !0 });
          var o = n(12),
            r = i(o),
            s = function (e, t) {
              return (
                e.forEach(function (e, n) {
                  e.node.classList.add("aos-init"), (e.position = (0, r.default)(e.node, t.offset));
                }),
                e
              );
            };
          t.default = s;
        },
        function (e, t, n) {
          "use strict";
          function i(e) {
            return e && e.__esModule ? e : { default: e };
          }
          Object.defineProperty(t, "__esModule", { value: !0 });
          var o = n(13),
            r = i(o),
            s = function (e, t) {
              var n = 0,
                i = 0,
                o = window.innerHeight,
                s = { offset: e.getAttribute("data-aos-offset"), anchor: e.getAttribute("data-aos-anchor"), anchorPlacement: e.getAttribute("data-aos-anchor-placement") };
              switch ((s.offset && !isNaN(s.offset) && (i = parseInt(s.offset)), s.anchor && document.querySelectorAll(s.anchor) && (e = document.querySelectorAll(s.anchor)[0]), (n = (0, r.default)(e).top), s.anchorPlacement)) {
                case "top-bottom":
                  break;
                case "center-bottom":
                  n += e.offsetHeight / 2;
                  break;
                case "bottom-bottom":
                  n += e.offsetHeight;
                  break;
                case "top-center":
                  n += o / 2;
                  break;
                case "bottom-center":
                  n += o / 2 + e.offsetHeight;
                  break;
                case "center-center":
                  n += o / 2 + e.offsetHeight / 2;
                  break;
                case "top-top":
                  n += o;
                  break;
                case "bottom-top":
                  n += e.offsetHeight + o;
                  break;
                case "center-top":
                  n += e.offsetHeight / 2 + o;
              }
              return s.anchorPlacement || s.offset || isNaN(t) || (i = t), n + i;
            };
          t.default = s;
        },
        function (e, t) {
          "use strict";
          Object.defineProperty(t, "__esModule", { value: !0 });
          var n = function (e) {
            for (var t = 0, n = 0; e && !isNaN(e.offsetLeft) && !isNaN(e.offsetTop); ) (t += e.offsetLeft - ("BODY" != e.tagName ? e.scrollLeft : 0)), (n += e.offsetTop - ("BODY" != e.tagName ? e.scrollTop : 0)), (e = e.offsetParent);
            return { top: n, left: t };
          };
          t.default = n;
        },
        function (e, t) {
          "use strict";
          Object.defineProperty(t, "__esModule", { value: !0 });
          var n = function (e) {
            e = e || document.querySelectorAll("[data-aos]");
            var t = [];
            return (
              [].forEach.call(e, function (e, n) {
                t.push({ node: e });
              }),
              t
            );
          };
          t.default = n;
        },
      ]);
    }),
    function () {
      var e;
      (e = (function () {
        function e(e, t) {
          var n, i;
          if (((this.options = { target: "instafeed", get: "popular", resolution: "thumbnail", sortBy: "none", links: !0, mock: !1, useHttp: !1 }), "object" == typeof e)) for (n in e) (i = e[n]), (this.options[n] = i);
          (this.context = null != t ? t : this), (this.unique = this._genKey());
        }
        return (
          (e.prototype.hasNext = function () {
            return "string" == typeof this.context.nextUrl && this.context.nextUrl.length > 0;
          }),
          (e.prototype.next = function () {
            return !!this.hasNext() && this.run(this.context.nextUrl);
          }),
          (e.prototype.run = function (t) {
            var n, i, o;
            if ("string" != typeof this.options.clientId && "string" != typeof this.options.accessToken) throw new Error("Missing clientId or accessToken.");
            if ("string" != typeof this.options.accessToken && "string" != typeof this.options.clientId) throw new Error("Missing clientId or accessToken.");
            return (
              null != this.options.before && "function" == typeof this.options.before && this.options.before.call(this),
              "undefined" != typeof document &&
                null !== document &&
                ((o = document.createElement("script")),
                (o.id = "instafeed-fetcher"),
                (o.src = t || this._buildUrl()),
                (n = document.getElementsByTagName("head")),
                n[0].appendChild(o),
                (i = "instafeedCache" + this.unique),
                (window[i] = new e(this.options, this)),
                (window[i].unique = this.unique)),
              !0
            );
          }),
          (e.prototype.parse = function (e) {
            var t, n, i, o, r, s, a, l, c, u, p, d, f, h, m, v, g, y, b, w, x, k, S, C, T, E, _, A, P, O, N, I, $;
            if ("object" != typeof e) {
              if (null != this.options.error && "function" == typeof this.options.error) return this.options.error.call(this, "Invalid JSON data"), !1;
              throw new Error("Invalid JSON response");
            }
            if (200 !== e.meta.code) {
              if (null != this.options.error && "function" == typeof this.options.error) return this.options.error.call(this, e.meta.error_message), !1;
              throw new Error("Error from Instagram: " + e.meta.error_message);
            }
            if (0 === e.data.length) {
              if (null != this.options.error && "function" == typeof this.options.error) return this.options.error.call(this, "No images were returned from Instagram"), !1;
              throw new Error("No images were returned from Instagram");
            }
            if (
              (null != this.options.success && "function" == typeof this.options.success && this.options.success.call(this, e),
              (this.context.nextUrl = ""),
              null != e.pagination && (this.context.nextUrl = e.pagination.next_url),
              "none" !== this.options.sortBy)
            )
              switch (((N = "random" === this.options.sortBy ? ["", "random"] : this.options.sortBy.split("-")), (O = "least" === N[0]), N[1])) {
                case "random":
                  e.data.sort(function () {
                    return 0.5 - Math.random();
                  });
                  break;
                case "recent":
                  e.data = this._sortBy(e.data, "created_time", O);
                  break;
                case "liked":
                  e.data = this._sortBy(e.data, "likes.count", O);
                  break;
                case "commented":
                  e.data = this._sortBy(e.data, "comments.count", O);
                  break;
                default:
                  throw new Error("Invalid option for sortBy: '" + this.options.sortBy + "'.");
              }
            if ("undefined" != typeof document && null !== document && this.options.mock === !1) {
              if (
                ((v = e.data),
                (P = parseInt(this.options.limit, 10)),
                null != this.options.limit && v.length > P && (v = v.slice(0, P)),
                (a = document.createDocumentFragment()),
                null != this.options.filter && "function" == typeof this.options.filter && (v = this._filter(v, this.options.filter)),
                null != this.options.template && "string" == typeof this.options.template)
              ) {
                for (c = "", h = "", w = "", $ = document.createElement("div"), p = 0, T = v.length; p < T; p++) {
                  if (((d = v[p]), (f = d.images[this.options.resolution]), "object" != typeof f)) throw ((s = "No image found for resolution: " + this.options.resolution + "."), new Error(s));
                  (x = f.width),
                    (y = f.height),
                    (b = "square"),
                    x > y && (b = "landscape"),
                    x < y && (b = "portrait"),
                    (m = f.url),
                    (u = window.location.protocol.indexOf("http") >= 0),
                    u && !this.options.useHttp && (m = m.replace(/https?:\/\//, "//")),
                    (h = this._makeTemplate(this.options.template, {
                      model: d,
                      id: d.id,
                      link: d.link,
                      type: d.type,
                      image: m,
                      width: x,
                      height: y,
                      orientation: b,
                      caption: this._getObjectProperty(d, "caption.text"),
                      likes: d.likes.count,
                      comments: d.comments.count,
                      location: this._getObjectProperty(d, "location.name"),
                    })),
                    (c += h);
                }
                for ($.innerHTML = c, o = [], i = 0, n = $.childNodes.length; i < n; ) o.push($.childNodes[i]), (i += 1);
                for (S = 0, E = o.length; S < E; S++) (A = o[S]), a.appendChild(A);
              } else
                for (C = 0, _ = v.length; C < _; C++) {
                  if (((d = v[C]), (g = document.createElement("img")), (f = d.images[this.options.resolution]), "object" != typeof f)) throw ((s = "No image found for resolution: " + this.options.resolution + "."), new Error(s));
                  (m = f.url),
                    (u = window.location.protocol.indexOf("http") >= 0),
                    u && !this.options.useHttp && (m = m.replace(/https?:\/\//, "//")),
                    (g.src = m),
                    this.options.links === !0 ? ((t = document.createElement("a")), (t.href = d.link), t.appendChild(g), a.appendChild(t)) : a.appendChild(g);
                }
              if (((I = this.options.target), "string" == typeof I && (I = document.getElementById(I)), null == I)) throw ((s = 'No element with id="' + this.options.target + '" on page.'), new Error(s));
              I.appendChild(a), (l = document.getElementsByTagName("head")[0]), l.removeChild(document.getElementById("instafeed-fetcher")), (k = "instafeedCache" + this.unique), (window[k] = void 0);
              try {
                delete window[k];
              } catch (e) {
                r = e;
              }
            }
            return null != this.options.after && "function" == typeof this.options.after && this.options.after.call(this), !0;
          }),
          (e.prototype._buildUrl = function () {
            var e, t, n;
            switch (((e = "https://api.instagram.com/v1"), this.options.get)) {
              case "popular":
                t = "media/popular";
                break;
              case "tagged":
                if (!this.options.tagName) throw new Error("No tag name specified. Use the 'tagName' option.");
                t = "tags/" + this.options.tagName + "/media/recent";
                break;
              case "location":
                if (!this.options.locationId) throw new Error("No location specified. Use the 'locationId' option.");
                t = "locations/" + this.options.locationId + "/media/recent";
                break;
              case "user":
                if (!this.options.userId) throw new Error("No user specified. Use the 'userId' option.");
                t = "users/" + this.options.userId + "/media/recent";
                break;
              default:
                throw new Error("Invalid option for get: '" + this.options.get + "'.");
            }
            return (
              (n = e + "/" + t),
              (n += null != this.options.accessToken ? "?access_token=" + this.options.accessToken : "?client_id=" + this.options.clientId),
              null != this.options.limit && (n += "&count=" + this.options.limit),
              (n += "&callback=instafeedCache" + this.unique + ".parse")
            );
          }),
          (e.prototype._genKey = function () {
            var e;
            return (
              (e = function () {
                return ((65536 * (1 + Math.random())) | 0).toString(16).substring(1);
              }),
              "" + e() + e() + e() + e()
            );
          }),
          (e.prototype._makeTemplate = function (e, t) {
            var n, i, o, r, s;
            for (i = /(?:\{{2})([\w\[\]\.]+)(?:\}{2})/, n = e; i.test(n); )
              (r = n.match(i)[1]),
                (s = null != (o = this._getObjectProperty(t, r)) ? o : ""),
                (n = n.replace(i, function () {
                  return "" + s;
                }));
            return n;
          }),
          (e.prototype._getObjectProperty = function (e, t) {
            var n, i;
            for (t = t.replace(/\[(\w+)\]/g, ".$1"), i = t.split("."); i.length; ) {
              if (((n = i.shift()), !(null != e && n in e))) return null;
              e = e[n];
            }
            return e;
          }),
          (e.prototype._sortBy = function (e, t, n) {
            var i;
            return (
              (i = function (e, i) {
                var o, r;
                return (o = this._getObjectProperty(e, t)), (r = this._getObjectProperty(i, t)), n ? (o > r ? 1 : -1) : o < r ? 1 : -1;
              }),
              e.sort(i.bind(this)),
              e
            );
          }),
          (e.prototype._filter = function (e, t) {
            var n, i, o, r, s;
            for (
              n = [],
                i = function (e) {
                  if (t(e)) return n.push(e);
                },
                o = 0,
                s = e.length;
              o < s;
              o++
            )
              (r = e[o]), i(r);
            return n;
          }),
          e
        );
      })()),
        (function (e, t) {
          return "function" == typeof define && define.amd ? define([], t) : "object" == typeof module && module.exports ? (module.exports = t()) : (e.Instafeed = t());
        })(this, function () {
          return e;
        });
    }.call(this),
    (function (e) {
      var t = !1;
      if (("function" == typeof define && define.amd && (define(e), (t = !0)), "object" == typeof exports && ((module.exports = e()), (t = !0)), !t)) {
        var n = window.Cookies,
          i = (window.Cookies = e());
        i.noConflict = function () {
          return (window.Cookies = n), i;
        };
      }
    })(function () {
      function e() {
        for (var e = 0, t = {}; e < arguments.length; e++) {
          var n = arguments[e];
          for (var i in n) t[i] = n[i];
        }
        return t;
      }
      function t(n) {
        function i(t, o, r) {
          var s;
          if ("undefined" != typeof document) {
            if (arguments.length > 1) {
              if (((r = e({ path: "/" }, i.defaults, r)), "number" == typeof r.expires)) {
                var a = new Date();
                a.setMilliseconds(a.getMilliseconds() + 864e5 * r.expires), (r.expires = a);
              }
              r.expires = r.expires ? r.expires.toUTCString() : "";
              try {
                (s = JSON.stringify(o)), /^[\{\[]/.test(s) && (o = s);
              } catch (e) {}
              (o = n.write ? n.write(o, t) : encodeURIComponent(String(o)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent)),
                (t = encodeURIComponent(String(t))),
                (t = t.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)),
                (t = t.replace(/[\(\)]/g, escape));
              var l = "";
              for (var c in r) r[c] && ((l += "; " + c), r[c] !== !0 && (l += "=" + r[c]));
              return (document.cookie = t + "=" + o + l);
            }
            t || (s = {});
            for (var u = document.cookie ? document.cookie.split("; ") : [], p = /(%[0-9A-Z]{2})+/g, d = 0; d < u.length; d++) {
              var f = u[d].split("="),
                h = f.slice(1).join("=");
              this.json || '"' !== h.charAt(0) || (h = h.slice(1, -1));
              try {
                var m = f[0].replace(p, decodeURIComponent);
                if (((h = n.read ? n.read(h, m) : n(h, m) || h.replace(p, decodeURIComponent)), this.json))
                  try {
                    h = JSON.parse(h);
                  } catch (e) {}
                if (t === m) {
                  s = h;
                  break;
                }
                t || (s[m] = h);
              } catch (e) {}
            }
            return s;
          }
        }
        return (
          (i.set = i),
          (i.get = function (e) {
            return i.call(i, e);
          }),
          (i.getJSON = function () {
            return i.apply({ json: !0 }, [].slice.call(arguments));
          }),
          (i.defaults = {}),
          (i.remove = function (t, n) {
            i(t, "", e(n, { expires: -1 }));
          }),
          (i.withConverter = t),
          i
        );
      }
      return t(function () {});
    })
    /*! PhotoSwipe - v4.1.3 - 2019-01-08
     * http://photoswipe.com
     * Copyright (c) 2019 Dmitry Semenov; */,
    (function (e, t) {
      "function" == typeof define && define.amd ? define(t) : "object" == typeof exports ? (module.exports = t()) : (e.PhotoSwipe = t());
    })(this, function () {
      "use strict";
      var e = function (e, t, n, i) {
        var o = {
          features: null,
          bind: function (e, t, n, i) {
            var o = (i ? "remove" : "add") + "EventListener";
            t = t.split(" ");
            for (var r = 0; r < t.length; r++) t[r] && e[o](t[r], n, !1);
          },
          isArray: function (e) {
            return e instanceof Array;
          },
          createEl: function (e, t) {
            var n = document.createElement(t || "div");
            return e && (n.className = e), n;
          },
          getScrollY: function () {
            var e = window.pageYOffset;
            return void 0 !== e ? e : document.documentElement.scrollTop;
          },
          unbind: function (e, t, n) {
            o.bind(e, t, n, !0);
          },
          removeClass: function (e, t) {
            var n = new RegExp("(\\s|^)" + t + "(\\s|$)");
            e.className = e.className
              .replace(n, " ")
              .replace(/^\s\s*/, "")
              .replace(/\s\s*$/, "");
          },
          addClass: function (e, t) {
            o.hasClass(e, t) || (e.className += (e.className ? " " : "") + t);
          },
          hasClass: function (e, t) {
            return e.className && new RegExp("(^|\\s)" + t + "(\\s|$)").test(e.className);
          },
          getChildByClass: function (e, t) {
            for (var n = e.firstChild; n; ) {
              if (o.hasClass(n, t)) return n;
              n = n.nextSibling;
            }
          },
          arraySearch: function (e, t, n) {
            for (var i = e.length; i--; ) if (e[i][n] === t) return i;
            return -1;
          },
          extend: function (e, t, n) {
            for (var i in t)
              if (t.hasOwnProperty(i)) {
                if (n && e.hasOwnProperty(i)) continue;
                e[i] = t[i];
              }
          },
          easing: {
            sine: {
              out: function (e) {
                return Math.sin(e * (Math.PI / 2));
              },
              inOut: function (e) {
                return -(Math.cos(Math.PI * e) - 1) / 2;
              },
            },
            cubic: {
              out: function (e) {
                return --e * e * e + 1;
              },
            },
          },
          detectFeatures: function () {
            if (o.features) return o.features;
            var e = o.createEl(),
              t = e.style,
              n = "",
              i = {};
            if (
              ((i.oldIE = document.all && !document.addEventListener),
              (i.touch = "ontouchstart" in window),
              window.requestAnimationFrame && ((i.raf = window.requestAnimationFrame), (i.caf = window.cancelAnimationFrame)),
              (i.pointerEvent = !!window.PointerEvent || navigator.msPointerEnabled),
              !i.pointerEvent)
            ) {
              var r = navigator.userAgent;
              if (/iP(hone|od)/.test(navigator.platform)) {
                var s = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                s && s.length > 0 && ((s = parseInt(s[1], 10)), s >= 1 && s < 8 && (i.isOldIOSPhone = !0));
              }
              var a = r.match(/Android\s([0-9\.]*)/),
                l = a ? a[1] : 0;
              (l = parseFloat(l)), l >= 1 && (l < 4.4 && (i.isOldAndroid = !0), (i.androidVersion = l)), (i.isMobileOpera = /opera mini|opera mobi/i.test(r));
            }
            for (var c, u, p = ["transform", "perspective", "animationName"], d = ["", "webkit", "Moz", "ms", "O"], f = 0; f < 4; f++) {
              n = d[f];
              for (var h = 0; h < 3; h++) (c = p[h]), (u = n + (n ? c.charAt(0).toUpperCase() + c.slice(1) : c)), !i[c] && u in t && (i[c] = u);
              n && !i.raf && ((n = n.toLowerCase()), (i.raf = window[n + "RequestAnimationFrame"]), i.raf && (i.caf = window[n + "CancelAnimationFrame"] || window[n + "CancelRequestAnimationFrame"]));
            }
            if (!i.raf) {
              var m = 0;
              (i.raf = function (e) {
                var t = new Date().getTime(),
                  n = Math.max(0, 16 - (t - m)),
                  i = window.setTimeout(function () {
                    e(t + n);
                  }, n);
                return (m = t + n), i;
              }),
                (i.caf = function (e) {
                  clearTimeout(e);
                });
            }
            return (i.svg = !!document.createElementNS && !!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect), (o.features = i), i;
          },
        };
        o.detectFeatures(),
          o.features.oldIE &&
            (o.bind = function (e, t, n, i) {
              t = t.split(" ");
              for (
                var o,
                  r = (i ? "detach" : "attach") + "Event",
                  s = function () {
                    n.handleEvent.call(n);
                  },
                  a = 0;
                a < t.length;
                a++
              )
                if ((o = t[a]))
                  if ("object" == typeof n && n.handleEvent) {
                    if (i) {
                      if (!n["oldIE" + o]) return !1;
                    } else n["oldIE" + o] = s;
                    e[r]("on" + o, n["oldIE" + o]);
                  } else e[r]("on" + o, n);
            });
        var r = this,
          s = 25,
          a = 3,
          l = {
            allowPanToNext: !0,
            spacing: 0.12,
            bgOpacity: 1,
            mouseUsed: !1,
            loop: !0,
            pinchToClose: !0,
            closeOnScroll: !0,
            closeOnVerticalDrag: !0,
            verticalDragRange: 0.75,
            hideAnimationDuration: 333,
            showAnimationDuration: 333,
            showHideOpacity: !1,
            focus: !0,
            escKey: !0,
            arrowKeys: !0,
            mainScrollEndFriction: 0.35,
            panEndFriction: 0.35,
            isClickableElement: function (e) {
              return "A" === e.tagName;
            },
            getDoubleTapZoom: function (e, t) {
              return e ? 1 : t.initialZoomLevel < 0.7 ? 1 : 1.33;
            },
            maxSpreadZoom: 1.33,
            modal: !0,
            scaleMode: "fit",
          };
        o.extend(l, i);
        var c,
          u,
          p,
          d,
          f,
          h,
          m,
          v,
          g,
          y,
          b,
          w,
          x,
          k,
          S,
          C,
          T,
          E,
          _,
          A,
          P,
          O,
          N,
          I,
          $,
          D,
          L,
          z,
          M,
          j,
          H,
          F,
          R,
          q,
          B,
          W,
          U,
          Z,
          K,
          V,
          X,
          Y,
          G,
          J,
          Q,
          ee,
          te,
          ne,
          ie,
          oe,
          re,
          se,
          ae,
          le,
          ce,
          ue,
          pe,
          de = function () {
            return { x: 0, y: 0 };
          },
          fe = de(),
          he = de(),
          me = de(),
          ve = {},
          ge = 0,
          ye = {},
          be = de(),
          we = 0,
          xe = !0,
          ke = [],
          Se = {},
          Ce = !1,
          Te = function (e, t) {
            o.extend(r, t.publicMethods), ke.push(e);
          },
          Ee = function (e) {
            var t = en();
            return e > t - 1 ? e - t : e < 0 ? t + e : e;
          },
          _e = {},
          Ae = function (e, t) {
            return _e[e] || (_e[e] = []), _e[e].push(t);
          },
          Pe = function (e) {
            var t = _e[e];
            if (t) {
              var n = Array.prototype.slice.call(arguments);
              n.shift();
              for (var i = 0; i < t.length; i++) t[i].apply(r, n);
            }
          },
          Oe = function () {
            return new Date().getTime();
          },
          Ne = function (e) {
            (ce = e), (r.bg.style.opacity = e * l.bgOpacity);
          },
          Ie = function (e, t, n, i, o) {
            (!Ce || (o && o !== r.currItem)) && (i /= o ? o.fitRatio : r.currItem.fitRatio), (e[O] = w + t + "px, " + n + "px" + x + " scale(" + i + ")");
          },
          $e = function (e) {
            oe && (e && (y > r.currItem.fitRatio ? Ce || (fn(r.currItem, !1, !0), (Ce = !0)) : Ce && (fn(r.currItem), (Ce = !1))), Ie(oe, me.x, me.y, y));
          },
          De = function (e) {
            e.container && Ie(e.container.style, e.initialPosition.x, e.initialPosition.y, e.initialZoomLevel, e);
          },
          Le = function (e, t) {
            t[O] = w + e + "px, 0px" + x;
          },
          ze = function (e, t) {
            if (!l.loop && t) {
              var n = d + (be.x * ge - e) / be.x,
                i = Math.round(e - bt.x);
              ((n < 0 && i > 0) || (n >= en() - 1 && i < 0)) && (e = bt.x + i * l.mainScrollEndFriction);
            }
            (bt.x = e), Le(e, f);
          },
          Me = function (e, t) {
            var n = wt[e] - ye[e];
            return he[e] + fe[e] + n - n * (t / b);
          },
          je = function (e, t) {
            (e.x = t.x), (e.y = t.y), t.id && (e.id = t.id);
          },
          He = function (e) {
            (e.x = Math.round(e.x)), (e.y = Math.round(e.y));
          },
          Fe = null,
          Re = function () {
            Fe && (o.unbind(document, "mousemove", Re), o.addClass(e, "pswp--has_mouse"), (l.mouseUsed = !0), Pe("mouseUsed")),
              (Fe = setTimeout(function () {
                Fe = null;
              }, 100));
          },
          qe = function () {
            o.bind(document, "keydown", r), H.transform && o.bind(r.scrollWrap, "click", r), l.mouseUsed || o.bind(document, "mousemove", Re), o.bind(window, "resize scroll orientationchange", r), Pe("bindEvents");
          },
          Be = function () {
            o.unbind(window, "resize scroll orientationchange", r),
              o.unbind(window, "scroll", g.scroll),
              o.unbind(document, "keydown", r),
              o.unbind(document, "mousemove", Re),
              H.transform && o.unbind(r.scrollWrap, "click", r),
              K && o.unbind(window, m, r),
              clearTimeout(F),
              Pe("unbindEvents");
          },
          We = function (e, t) {
            var n = cn(r.currItem, ve, e);
            return t && (ie = n), n;
          },
          Ue = function (e) {
            return e || (e = r.currItem), e.initialZoomLevel;
          },
          Ze = function (e) {
            return e || (e = r.currItem), e.w > 0 ? l.maxSpreadZoom : 1;
          },
          Ke = function (e, t, n, i) {
            return i === r.currItem.initialZoomLevel ? ((n[e] = r.currItem.initialPosition[e]), !0) : ((n[e] = Me(e, i)), n[e] > t.min[e] ? ((n[e] = t.min[e]), !0) : n[e] < t.max[e] && ((n[e] = t.max[e]), !0));
          },
          Ve = function () {
            if (O) {
              var t = H.perspective && !I;
              return (w = "translate" + (t ? "3d(" : "(")), void (x = H.perspective ? ", 0px)" : ")");
            }
            (O = "left"),
              o.addClass(e, "pswp--ie"),
              (Le = function (e, t) {
                t.left = e + "px";
              }),
              (De = function (e) {
                var t = e.fitRatio > 1 ? 1 : e.fitRatio,
                  n = e.container.style,
                  i = t * e.w,
                  o = t * e.h;
                (n.width = i + "px"), (n.height = o + "px"), (n.left = e.initialPosition.x + "px"), (n.top = e.initialPosition.y + "px");
              }),
              ($e = function () {
                if (oe) {
                  var e = oe,
                    t = r.currItem,
                    n = t.fitRatio > 1 ? 1 : t.fitRatio,
                    i = n * t.w,
                    o = n * t.h;
                  (e.width = i + "px"), (e.height = o + "px"), (e.left = me.x + "px"), (e.top = me.y + "px");
                }
              });
          },
          Xe = function (e) {
            var t = "";
            l.escKey && 27 === e.keyCode ? (t = "close") : l.arrowKeys && (37 === e.keyCode ? (t = "prev") : 39 === e.keyCode && (t = "next")),
              t && (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey || (e.preventDefault ? e.preventDefault() : (e.returnValue = !1), r[t]()));
          },
          Ye = function (e) {
            e && (Y || X || re || U) && (e.preventDefault(), e.stopPropagation());
          },
          Ge = function () {
            r.setScrollOffset(0, o.getScrollY());
          },
          Je = {},
          Qe = 0,
          et = function (e) {
            Je[e] && (Je[e].raf && D(Je[e].raf), Qe--, delete Je[e]);
          },
          tt = function (e) {
            Je[e] && et(e), Je[e] || (Qe++, (Je[e] = {}));
          },
          nt = function () {
            for (var e in Je) Je.hasOwnProperty(e) && et(e);
          },
          it = function (e, t, n, i, o, r, s) {
            var a,
              l = Oe();
            tt(e);
            var c = function () {
              if (Je[e]) {
                if (((a = Oe() - l), a >= i)) return et(e), r(n), void (s && s());
                r((n - t) * o(a / i) + t), (Je[e].raf = $(c));
              }
            };
            c();
          },
          ot = {
            shout: Pe,
            listen: Ae,
            viewportSize: ve,
            options: l,
            isMainScrollAnimating: function () {
              return re;
            },
            getZoomLevel: function () {
              return y;
            },
            getCurrentIndex: function () {
              return d;
            },
            isDragging: function () {
              return K;
            },
            isZooming: function () {
              return ee;
            },
            setScrollOffset: function (e, t) {
              (ye.x = e), (j = ye.y = t), Pe("updateScrollOffset", ye);
            },
            applyZoomPan: function (e, t, n, i) {
              (me.x = t), (me.y = n), (y = e), $e(i);
            },
            init: function () {
              if (!c && !u) {
                var n;
                (r.framework = o),
                  (r.template = e),
                  (r.bg = o.getChildByClass(e, "pswp__bg")),
                  (L = e.className),
                  (c = !0),
                  (H = o.detectFeatures()),
                  ($ = H.raf),
                  (D = H.caf),
                  (O = H.transform),
                  (M = H.oldIE),
                  (r.scrollWrap = o.getChildByClass(e, "pswp__scroll-wrap")),
                  (r.container = o.getChildByClass(r.scrollWrap, "pswp__container")),
                  (f = r.container.style),
                  (r.itemHolders = C = [
                    { el: r.container.children[0], wrap: 0, index: -1 },
                    { el: r.container.children[1], wrap: 0, index: -1 },
                    { el: r.container.children[2], wrap: 0, index: -1 },
                  ]),
                  (C[0].el.style.display = C[2].el.style.display = "none"),
                  Ve(),
                  (g = {
                    resize: r.updateSize,
                    orientationchange: function () {
                      clearTimeout(F),
                        (F = setTimeout(function () {
                          ve.x !== r.scrollWrap.clientWidth && r.updateSize();
                        }, 500));
                    },
                    scroll: Ge,
                    keydown: Xe,
                    click: Ye,
                  });
                var i = H.isOldIOSPhone || H.isOldAndroid || H.isMobileOpera;
                for ((H.animationName && H.transform && !i) || (l.showAnimationDuration = l.hideAnimationDuration = 0), n = 0; n < ke.length; n++) r["init" + ke[n]]();
                if (t) {
                  var s = (r.ui = new t(r, o));
                  s.init();
                }
                Pe("firstUpdate"),
                  (d = d || l.index || 0),
                  (isNaN(d) || d < 0 || d >= en()) && (d = 0),
                  (r.currItem = Qt(d)),
                  (H.isOldIOSPhone || H.isOldAndroid) && (xe = !1),
                  e.setAttribute("aria-hidden", "false"),
                  l.modal && (xe ? (e.style.position = "fixed") : ((e.style.position = "absolute"), (e.style.top = o.getScrollY() + "px"))),
                  void 0 === j && (Pe("initialLayout"), (j = z = o.getScrollY()));
                var p = "pswp--open ";
                for (
                  l.mainClass && (p += l.mainClass + " "),
                    l.showHideOpacity && (p += "pswp--animate_opacity "),
                    p += I ? "pswp--touch" : "pswp--notouch",
                    p += H.animationName ? " pswp--css_animation" : "",
                    p += H.svg ? " pswp--svg" : "",
                    o.addClass(e, p),
                    r.updateSize(),
                    h = -1,
                    we = null,
                    n = 0;
                  n < a;
                  n++
                )
                  Le((n + h) * be.x, C[n].el.style);
                M || o.bind(r.scrollWrap, v, r),
                  Ae("initialZoomInEnd", function () {
                    r.setContent(C[0], d - 1), r.setContent(C[2], d + 1), (C[0].el.style.display = C[2].el.style.display = "block"), l.focus && e.focus(), qe();
                  }),
                  r.setContent(C[1], d),
                  r.updateCurrItem(),
                  Pe("afterInit"),
                  xe ||
                    (k = setInterval(function () {
                      Qe || K || ee || y !== r.currItem.initialZoomLevel || r.updateSize();
                    }, 1e3)),
                  o.addClass(e, "pswp--visible");
              }
            },
            close: function () {
              c && ((c = !1), (u = !0), Pe("close"), Be(), nn(r.currItem, null, !0, r.destroy));
            },
            destroy: function () {
              Pe("destroy"), Xt && clearTimeout(Xt), e.setAttribute("aria-hidden", "true"), (e.className = L), k && clearInterval(k), o.unbind(r.scrollWrap, v, r), o.unbind(window, "scroll", r), Tt(), nt(), (_e = null);
            },
            panTo: function (e, t, n) {
              n || (e > ie.min.x ? (e = ie.min.x) : e < ie.max.x && (e = ie.max.x), t > ie.min.y ? (t = ie.min.y) : t < ie.max.y && (t = ie.max.y)), (me.x = e), (me.y = t), $e();
            },
            handleEvent: function (e) {
              (e = e || window.event), g[e.type] && g[e.type](e);
            },
            goTo: function (e) {
              e = Ee(e);
              var t = e - d;
              (we = t), (d = e), (r.currItem = Qt(d)), (ge -= t), ze(be.x * ge), nt(), (re = !1), r.updateCurrItem();
            },
            next: function () {
              r.goTo(d + 1);
            },
            prev: function () {
              r.goTo(d - 1);
            },
            updateCurrZoomItem: function (e) {
              if ((e && Pe("beforeChange", 0), C[1].el.children.length)) {
                var t = C[1].el.children[0];
                oe = o.hasClass(t, "pswp__zoom-wrap") ? t.style : null;
              } else oe = null;
              (ie = r.currItem.bounds), (b = y = r.currItem.initialZoomLevel), (me.x = ie.center.x), (me.y = ie.center.y), e && Pe("afterChange");
            },
            invalidateCurrItems: function () {
              S = !0;
              for (var e = 0; e < a; e++) C[e].item && (C[e].item.needsUpdate = !0);
            },
            updateCurrItem: function (e) {
              if (0 !== we) {
                var t,
                  n = Math.abs(we);
                if (!(e && n < 2)) {
                  (r.currItem = Qt(d)), (Ce = !1), Pe("beforeChange", we), n >= a && ((h += we + (we > 0 ? -a : a)), (n = a));
                  for (var i = 0; i < n; i++)
                    we > 0 ? ((t = C.shift()), (C[a - 1] = t), h++, Le((h + 2) * be.x, t.el.style), r.setContent(t, d - n + i + 1 + 1)) : ((t = C.pop()), C.unshift(t), h--, Le(h * be.x, t.el.style), r.setContent(t, d + n - i - 1 - 1));
                  if (oe && 1 === Math.abs(we)) {
                    var o = Qt(T);
                    o.initialZoomLevel !== y && (cn(o, ve), fn(o), De(o));
                  }
                  (we = 0), r.updateCurrZoomItem(), (T = d), Pe("afterChange");
                }
              }
            },
            updateSize: function (t) {
              if (!xe && l.modal) {
                var n = o.getScrollY();
                if ((j !== n && ((e.style.top = n + "px"), (j = n)), !t && Se.x === window.innerWidth && Se.y === window.innerHeight)) return;
                (Se.x = window.innerWidth), (Se.y = window.innerHeight), (e.style.height = Se.y + "px");
              }
              if (((ve.x = r.scrollWrap.clientWidth), (ve.y = r.scrollWrap.clientHeight), Ge(), (be.x = ve.x + Math.round(ve.x * l.spacing)), (be.y = ve.y), ze(be.x * ge), Pe("beforeResize"), void 0 !== h)) {
                for (var i, s, c, u = 0; u < a; u++)
                  (i = C[u]),
                    Le((u + h) * be.x, i.el.style),
                    (c = d + u - 1),
                    l.loop && en() > 2 && (c = Ee(c)),
                    (s = Qt(c)),
                    s && (S || s.needsUpdate || !s.bounds) ? (r.cleanSlide(s), r.setContent(i, c), 1 === u && ((r.currItem = s), r.updateCurrZoomItem(!0)), (s.needsUpdate = !1)) : i.index === -1 && c >= 0 && r.setContent(i, c),
                    s && s.container && (cn(s, ve), fn(s), De(s));
                S = !1;
              }
              (b = y = r.currItem.initialZoomLevel), (ie = r.currItem.bounds), ie && ((me.x = ie.center.x), (me.y = ie.center.y), $e(!0)), Pe("resize");
            },
            zoomTo: function (e, t, n, i, r) {
              t && ((b = y), (wt.x = Math.abs(t.x) - me.x), (wt.y = Math.abs(t.y) - me.y), je(he, me));
              var s = We(e, !1),
                a = {};
              Ke("x", s, a, e), Ke("y", s, a, e);
              var l = y,
                c = { x: me.x, y: me.y };
              He(a);
              var u = function (t) {
                1 === t ? ((y = e), (me.x = a.x), (me.y = a.y)) : ((y = (e - l) * t + l), (me.x = (a.x - c.x) * t + c.x), (me.y = (a.y - c.y) * t + c.y)), r && r(t), $e(1 === t);
              };
              n ? it("customZoomTo", 0, 1, n, i || o.easing.sine.inOut, u) : u(1);
            },
          },
          rt = 30,
          st = 10,
          at = {},
          lt = {},
          ct = {},
          ut = {},
          pt = {},
          dt = [],
          ft = {},
          ht = [],
          mt = {},
          vt = 0,
          gt = de(),
          yt = 0,
          bt = de(),
          wt = de(),
          xt = de(),
          kt = function (e, t) {
            return e.x === t.x && e.y === t.y;
          },
          St = function (e, t) {
            return Math.abs(e.x - t.x) < s && Math.abs(e.y - t.y) < s;
          },
          Ct = function (e, t) {
            return (mt.x = Math.abs(e.x - t.x)), (mt.y = Math.abs(e.y - t.y)), Math.sqrt(mt.x * mt.x + mt.y * mt.y);
          },
          Tt = function () {
            G && (D(G), (G = null));
          },
          Et = function () {
            K && ((G = $(Et)), qt());
          },
          _t = function () {
            return !("fit" === l.scaleMode && y === r.currItem.initialZoomLevel);
          },
          At = function (e, t) {
            return !(!e || e === document) && !(e.getAttribute("class") && e.getAttribute("class").indexOf("pswp__scroll-wrap") > -1) && (t(e) ? e : At(e.parentNode, t));
          },
          Pt = {},
          Ot = function (e, t) {
            return (Pt.prevent = !At(e.target, l.isClickableElement)), Pe("preventDragEvent", e, t, Pt), Pt.prevent;
          },
          Nt = function (e, t) {
            return (t.x = e.pageX), (t.y = e.pageY), (t.id = e.identifier), t;
          },
          It = function (e, t, n) {
            (n.x = 0.5 * (e.x + t.x)), (n.y = 0.5 * (e.y + t.y));
          },
          $t = function (e, t, n) {
            if (e - q > 50) {
              var i = ht.length > 2 ? ht.shift() : {};
              (i.x = t), (i.y = n), ht.push(i), (q = e);
            }
          },
          Dt = function () {
            var e = me.y - r.currItem.initialPosition.y;
            return 1 - Math.abs(e / (ve.y / 2));
          },
          Lt = {},
          zt = {},
          Mt = [],
          jt = function (e) {
            for (; Mt.length > 0; ) Mt.pop();
            return (
              N
                ? ((pe = 0),
                  dt.forEach(function (e) {
                    0 === pe ? (Mt[0] = e) : 1 === pe && (Mt[1] = e), pe++;
                  }))
                : e.type.indexOf("touch") > -1
                ? e.touches && e.touches.length > 0 && ((Mt[0] = Nt(e.touches[0], Lt)), e.touches.length > 1 && (Mt[1] = Nt(e.touches[1], zt)))
                : ((Lt.x = e.pageX), (Lt.y = e.pageY), (Lt.id = ""), (Mt[0] = Lt)),
              Mt
            );
          },
          Ht = function (e, t) {
            var n,
              i,
              o,
              s,
              a = 0,
              c = me[e] + t[e],
              u = t[e] > 0,
              p = bt.x + t.x,
              d = bt.x - ft.x;
            return (
              (n = c > ie.min[e] || c < ie.max[e] ? l.panEndFriction : 1),
              (c = me[e] + t[e] * n),
              (!l.allowPanToNext && y !== r.currItem.initialZoomLevel) ||
              (oe
                ? "h" !== se ||
                  "x" !== e ||
                  X ||
                  (u
                    ? (c > ie.min[e] && ((n = l.panEndFriction), (a = ie.min[e] - c), (i = ie.min[e] - he[e])), (i <= 0 || d < 0) && en() > 1 ? ((s = p), d < 0 && p > ft.x && (s = ft.x)) : ie.min.x !== ie.max.x && (o = c))
                    : (c < ie.max[e] && ((n = l.panEndFriction), (a = c - ie.max[e]), (i = he[e] - ie.max[e])), (i <= 0 || d > 0) && en() > 1 ? ((s = p), d > 0 && p < ft.x && (s = ft.x)) : ie.min.x !== ie.max.x && (o = c)))
                : (s = p),
              "x" !== e)
                ? void (re || J || (y > r.currItem.fitRatio && (me[e] += t[e] * n)))
                : (void 0 !== s && (ze(s, !0), (J = s !== ft.x)), ie.min.x !== ie.max.x && (void 0 !== o ? (me.x = o) : J || (me.x += t.x * n)), void 0 !== s)
            );
          },
          Ft = function (e) {
            if (!("mousedown" === e.type && e.button > 0)) {
              if (Jt) return void e.preventDefault();
              if (!Z || "mousedown" !== e.type) {
                if ((Ot(e, !0) && e.preventDefault(), Pe("pointerDown"), N)) {
                  var t = o.arraySearch(dt, e.pointerId, "id");
                  t < 0 && (t = dt.length), (dt[t] = { x: e.pageX, y: e.pageY, id: e.pointerId });
                }
                var n = jt(e),
                  i = n.length;
                (Q = null),
                  nt(),
                  (K && 1 !== i) ||
                    ((K = ae = !0),
                    o.bind(window, m, r),
                    (W = ue = le = U = J = Y = V = X = !1),
                    (se = null),
                    Pe("firstTouchStart", n),
                    je(he, me),
                    (fe.x = fe.y = 0),
                    je(ut, n[0]),
                    je(pt, ut),
                    (ft.x = be.x * ge),
                    (ht = [{ x: ut.x, y: ut.y }]),
                    (q = R = Oe()),
                    We(y, !0),
                    Tt(),
                    Et()),
                  !ee &&
                    i > 1 &&
                    !re &&
                    !J &&
                    ((b = y), (X = !1), (ee = V = !0), (fe.y = fe.x = 0), je(he, me), je(at, n[0]), je(lt, n[1]), It(at, lt, xt), (wt.x = Math.abs(xt.x) - me.x), (wt.y = Math.abs(xt.y) - me.y), (te = ne = Ct(at, lt)));
              }
            }
          },
          Rt = function (e) {
            if ((e.preventDefault(), N)) {
              var t = o.arraySearch(dt, e.pointerId, "id");
              if (t > -1) {
                var n = dt[t];
                (n.x = e.pageX), (n.y = e.pageY);
              }
            }
            if (K) {
              var i = jt(e);
              if (se || Y || ee) Q = i;
              else if (bt.x !== be.x * ge) se = "h";
              else {
                var r = Math.abs(i[0].x - ut.x) - Math.abs(i[0].y - ut.y);
                Math.abs(r) >= st && ((se = r > 0 ? "h" : "v"), (Q = i));
              }
            }
          },
          qt = function () {
            if (Q) {
              var e = Q.length;
              if (0 !== e)
                if ((je(at, Q[0]), (ct.x = at.x - ut.x), (ct.y = at.y - ut.y), ee && e > 1)) {
                  if (((ut.x = at.x), (ut.y = at.y), !ct.x && !ct.y && kt(Q[1], lt))) return;
                  je(lt, Q[1]), X || ((X = !0), Pe("zoomGestureStarted"));
                  var t = Ct(at, lt),
                    n = Kt(t);
                  n > r.currItem.initialZoomLevel + r.currItem.initialZoomLevel / 15 && (ue = !0);
                  var i = 1,
                    o = Ue(),
                    s = Ze();
                  if (n < o)
                    if (l.pinchToClose && !ue && b <= r.currItem.initialZoomLevel) {
                      var a = o - n,
                        c = 1 - a / (o / 1.2);
                      Ne(c), Pe("onPinchClose", c), (le = !0);
                    } else (i = (o - n) / o), i > 1 && (i = 1), (n = o - i * (o / 3));
                  else n > s && ((i = (n - s) / (6 * o)), i > 1 && (i = 1), (n = s + i * o));
                  i < 0 && (i = 0), (te = t), It(at, lt, gt), (fe.x += gt.x - xt.x), (fe.y += gt.y - xt.y), je(xt, gt), (me.x = Me("x", n)), (me.y = Me("y", n)), (W = n > y), (y = n), $e();
                } else {
                  if (!se) return;
                  if ((ae && ((ae = !1), Math.abs(ct.x) >= st && (ct.x -= Q[0].x - pt.x), Math.abs(ct.y) >= st && (ct.y -= Q[0].y - pt.y)), (ut.x = at.x), (ut.y = at.y), 0 === ct.x && 0 === ct.y)) return;
                  if ("v" === se && l.closeOnVerticalDrag && !_t()) {
                    (fe.y += ct.y), (me.y += ct.y);
                    var u = Dt();
                    return (U = !0), Pe("onVerticalDrag", u), Ne(u), void $e();
                  }
                  $t(Oe(), at.x, at.y), (Y = !0), (ie = r.currItem.bounds);
                  var p = Ht("x", ct);
                  p || (Ht("y", ct), He(me), $e());
                }
            }
          },
          Bt = function (e) {
            if (H.isOldAndroid) {
              if (Z && "mouseup" === e.type) return;
              e.type.indexOf("touch") > -1 &&
                (clearTimeout(Z),
                (Z = setTimeout(function () {
                  Z = 0;
                }, 600)));
            }
            Pe("pointerUp"), Ot(e, !1) && e.preventDefault();
            var t;
            if (N) {
              var n = o.arraySearch(dt, e.pointerId, "id");
              if (n > -1)
                if (((t = dt.splice(n, 1)[0]), navigator.msPointerEnabled)) {
                  var i = { 4: "mouse", 2: "touch", 3: "pen" };
                  (t.type = i[e.pointerType]), t.type || (t.type = e.pointerType || "mouse");
                } else t.type = e.pointerType || "mouse";
            }
            var s,
              a = jt(e),
              c = a.length;
            if (("mouseup" === e.type && (c = 0), 2 === c)) return (Q = null), !0;
            1 === c && je(pt, a[0]),
              0 !== c ||
                se ||
                re ||
                (t || ("mouseup" === e.type ? (t = { x: e.pageX, y: e.pageY, type: "mouse" }) : e.changedTouches && e.changedTouches[0] && (t = { x: e.changedTouches[0].pageX, y: e.changedTouches[0].pageY, type: "touch" })),
                Pe("touchRelease", e, t));
            var u = -1;
            if (
              (0 === c && ((K = !1), o.unbind(window, m, r), Tt(), ee ? (u = 0) : yt !== -1 && (u = Oe() - yt)),
              (yt = 1 === c ? Oe() : -1),
              (s = u !== -1 && u < 150 ? "zoom" : "swipe"),
              ee && c < 2 && ((ee = !1), 1 === c && (s = "zoomPointerUp"), Pe("zoomGestureEnded")),
              (Q = null),
              Y || X || re || U)
            )
              if ((nt(), B || (B = Wt()), B.calculateSwipeSpeed("x"), U)) {
                var p = Dt();
                if (p < l.verticalDragRange) r.close();
                else {
                  var d = me.y,
                    f = ce;
                  it("verticalDrag", 0, 1, 300, o.easing.cubic.out, function (e) {
                    (me.y = (r.currItem.initialPosition.y - d) * e + d), Ne((1 - f) * e + f), $e();
                  }),
                    Pe("onVerticalDrag", 1);
                }
              } else {
                if ((J || re) && 0 === c) {
                  var h = Zt(s, B);
                  if (h) return;
                  s = "zoomPointerUp";
                }
                if (!re) return "swipe" !== s ? void Vt() : void (!J && y > r.currItem.fitRatio && Ut(B));
              }
          },
          Wt = function () {
            var e,
              t,
              n = {
                lastFlickOffset: {},
                lastFlickDist: {},
                lastFlickSpeed: {},
                slowDownRatio: {},
                slowDownRatioReverse: {},
                speedDecelerationRatio: {},
                speedDecelerationRatioAbs: {},
                distanceOffset: {},
                backAnimDestination: {},
                backAnimStarted: {},
                calculateSwipeSpeed: function (i) {
                  ht.length > 1 ? ((e = Oe() - q + 50), (t = ht[ht.length - 2][i])) : ((e = Oe() - R), (t = pt[i])),
                    (n.lastFlickOffset[i] = ut[i] - t),
                    (n.lastFlickDist[i] = Math.abs(n.lastFlickOffset[i])),
                    n.lastFlickDist[i] > 20 ? (n.lastFlickSpeed[i] = n.lastFlickOffset[i] / e) : (n.lastFlickSpeed[i] = 0),
                    Math.abs(n.lastFlickSpeed[i]) < 0.1 && (n.lastFlickSpeed[i] = 0),
                    (n.slowDownRatio[i] = 0.95),
                    (n.slowDownRatioReverse[i] = 1 - n.slowDownRatio[i]),
                    (n.speedDecelerationRatio[i] = 1);
                },
                calculateOverBoundsAnimOffset: function (e, t) {
                  n.backAnimStarted[e] ||
                    (me[e] > ie.min[e] ? (n.backAnimDestination[e] = ie.min[e]) : me[e] < ie.max[e] && (n.backAnimDestination[e] = ie.max[e]),
                    void 0 !== n.backAnimDestination[e] &&
                      ((n.slowDownRatio[e] = 0.7),
                      (n.slowDownRatioReverse[e] = 1 - n.slowDownRatio[e]),
                      n.speedDecelerationRatioAbs[e] < 0.05 &&
                        ((n.lastFlickSpeed[e] = 0),
                        (n.backAnimStarted[e] = !0),
                        it("bounceZoomPan" + e, me[e], n.backAnimDestination[e], t || 300, o.easing.sine.out, function (t) {
                          (me[e] = t), $e();
                        }))));
                },
                calculateAnimOffset: function (e) {
                  n.backAnimStarted[e] ||
                    ((n.speedDecelerationRatio[e] = n.speedDecelerationRatio[e] * (n.slowDownRatio[e] + n.slowDownRatioReverse[e] - (n.slowDownRatioReverse[e] * n.timeDiff) / 10)),
                    (n.speedDecelerationRatioAbs[e] = Math.abs(n.lastFlickSpeed[e] * n.speedDecelerationRatio[e])),
                    (n.distanceOffset[e] = n.lastFlickSpeed[e] * n.speedDecelerationRatio[e] * n.timeDiff),
                    (me[e] += n.distanceOffset[e]));
                },
                panAnimLoop: function () {
                  if (
                    Je.zoomPan &&
                    ((Je.zoomPan.raf = $(n.panAnimLoop)),
                    (n.now = Oe()),
                    (n.timeDiff = n.now - n.lastNow),
                    (n.lastNow = n.now),
                    n.calculateAnimOffset("x"),
                    n.calculateAnimOffset("y"),
                    $e(),
                    n.calculateOverBoundsAnimOffset("x"),
                    n.calculateOverBoundsAnimOffset("y"),
                    n.speedDecelerationRatioAbs.x < 0.05 && n.speedDecelerationRatioAbs.y < 0.05)
                  )
                    return (me.x = Math.round(me.x)), (me.y = Math.round(me.y)), $e(), void et("zoomPan");
                },
              };
            return n;
          },
          Ut = function (e) {
            return (
              e.calculateSwipeSpeed("y"),
              (ie = r.currItem.bounds),
              (e.backAnimDestination = {}),
              (e.backAnimStarted = {}),
              Math.abs(e.lastFlickSpeed.x) <= 0.05 && Math.abs(e.lastFlickSpeed.y) <= 0.05
                ? ((e.speedDecelerationRatioAbs.x = e.speedDecelerationRatioAbs.y = 0), e.calculateOverBoundsAnimOffset("x"), e.calculateOverBoundsAnimOffset("y"), !0)
                : (tt("zoomPan"), (e.lastNow = Oe()), void e.panAnimLoop())
            );
          },
          Zt = function (e, t) {
            var n;
            re || (vt = d);
            var i;
            if ("swipe" === e) {
              var s = ut.x - pt.x,
                a = t.lastFlickDist.x < 10;
              s > rt && (a || t.lastFlickOffset.x > 20) ? (i = -1) : s < -rt && (a || t.lastFlickOffset.x < -20) && (i = 1);
            }
            var c;
            i && ((d += i), d < 0 ? ((d = l.loop ? en() - 1 : 0), (c = !0)) : d >= en() && ((d = l.loop ? 0 : en() - 1), (c = !0)), (c && !l.loop) || ((we += i), (ge -= i), (n = !0)));
            var u,
              p = be.x * ge,
              f = Math.abs(p - bt.x);
            return (
              n || p > bt.x == t.lastFlickSpeed.x > 0 ? ((u = Math.abs(t.lastFlickSpeed.x) > 0 ? f / Math.abs(t.lastFlickSpeed.x) : 333), (u = Math.min(u, 400)), (u = Math.max(u, 250))) : (u = 333),
              vt === d && (n = !1),
              (re = !0),
              Pe("mainScrollAnimStart"),
              it("mainScroll", bt.x, p, u, o.easing.cubic.out, ze, function () {
                nt(), (re = !1), (vt = -1), (n || vt !== d) && r.updateCurrItem(), Pe("mainScrollAnimComplete");
              }),
              n && r.updateCurrItem(!0),
              n
            );
          },
          Kt = function (e) {
            return (1 / ne) * e * b;
          },
          Vt = function () {
            var e = y,
              t = Ue(),
              n = Ze();
            y < t ? (e = t) : y > n && (e = n);
            var i,
              s = 1,
              a = ce;
            return le && !W && !ue && y < t
              ? (r.close(), !0)
              : (le &&
                  (i = function (e) {
                    Ne((s - a) * e + a);
                  }),
                r.zoomTo(e, 0, 200, o.easing.cubic.out, i),
                !0);
          };
        Te("Gestures", {
          publicMethods: {
            initGestures: function () {
              var e = function (e, t, n, i, o) {
                (E = e + t), (_ = e + n), (A = e + i), (P = o ? e + o : "");
              };
              (N = H.pointerEvent),
                N && H.touch && (H.touch = !1),
                N
                  ? navigator.msPointerEnabled
                    ? e("MSPointer", "Down", "Move", "Up", "Cancel")
                    : e("pointer", "down", "move", "up", "cancel")
                  : H.touch
                  ? (e("touch", "start", "move", "end", "cancel"), (I = !0))
                  : e("mouse", "down", "move", "up"),
                (m = _ + " " + A + " " + P),
                (v = E),
                N && !I && (I = navigator.maxTouchPoints > 1 || navigator.msMaxTouchPoints > 1),
                (r.likelyTouchDevice = I),
                (g[E] = Ft),
                (g[_] = Rt),
                (g[A] = Bt),
                P && (g[P] = g[A]),
                H.touch && ((v += " mousedown"), (m += " mousemove mouseup"), (g.mousedown = g[E]), (g.mousemove = g[_]), (g.mouseup = g[A])),
                I || (l.allowPanToNext = !1);
            },
          },
        });
        var Xt,
          Yt,
          Gt,
          Jt,
          Qt,
          en,
          tn,
          nn = function (t, n, i, s) {
            Xt && clearTimeout(Xt), (Jt = !0), (Gt = !0);
            var a;
            t.initialLayout ? ((a = t.initialLayout), (t.initialLayout = null)) : (a = l.getThumbBoundsFn && l.getThumbBoundsFn(d));
            var c = i ? l.hideAnimationDuration : l.showAnimationDuration,
              u = function () {
                et("initialZoom"),
                  i ? (r.template.removeAttribute("style"), r.bg.removeAttribute("style")) : (Ne(1), n && (n.style.display = "block"), o.addClass(e, "pswp--animated-in"), Pe("initialZoom" + (i ? "OutEnd" : "InEnd"))),
                  s && s(),
                  (Jt = !1);
              };
            if (!c || !a || void 0 === a.x)
              return (
                Pe("initialZoom" + (i ? "Out" : "In")),
                (y = t.initialZoomLevel),
                je(me, t.initialPosition),
                $e(),
                (e.style.opacity = i ? 0 : 1),
                Ne(1),
                void (c
                  ? setTimeout(function () {
                      u();
                    }, c)
                  : u())
              );
            var f = function () {
              var n = p,
                s = !r.currItem.src || r.currItem.loadError || l.showHideOpacity;
              t.miniImg && (t.miniImg.style.webkitBackfaceVisibility = "hidden"),
                i || ((y = a.w / t.w), (me.x = a.x), (me.y = a.y - z), (r[s ? "template" : "bg"].style.opacity = 0.001), $e()),
                tt("initialZoom"),
                i && !n && o.removeClass(e, "pswp--animated-in"),
                s &&
                  (i
                    ? o[(n ? "remove" : "add") + "Class"](e, "pswp--animate_opacity")
                    : setTimeout(function () {
                        o.addClass(e, "pswp--animate_opacity");
                      }, 30)),
                (Xt = setTimeout(
                  function () {
                    if ((Pe("initialZoom" + (i ? "Out" : "In")), i)) {
                      var r = a.w / t.w,
                        l = { x: me.x, y: me.y },
                        p = y,
                        d = ce,
                        f = function (t) {
                          1 === t ? ((y = r), (me.x = a.x), (me.y = a.y - j)) : ((y = (r - p) * t + p), (me.x = (a.x - l.x) * t + l.x), (me.y = (a.y - j - l.y) * t + l.y)), $e(), s ? (e.style.opacity = 1 - t) : Ne(d - t * d);
                        };
                      n ? it("initialZoom", 0, 1, c, o.easing.cubic.out, f, u) : (f(1), (Xt = setTimeout(u, c + 20)));
                    } else (y = t.initialZoomLevel), je(me, t.initialPosition), $e(), Ne(1), s ? (e.style.opacity = 1) : Ne(1), (Xt = setTimeout(u, c + 20));
                  },
                  i ? 25 : 90
                ));
            };
            f();
          },
          on = {},
          rn = [],
          sn = {
            index: 0,
            errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
            forceProgressiveLoading: !1,
            preload: [1, 1],
            getNumItemsFn: function () {
              return Yt.length;
            },
          },
          an = function () {
            return { center: { x: 0, y: 0 }, max: { x: 0, y: 0 }, min: { x: 0, y: 0 } };
          },
          ln = function (e, t, n) {
            var i = e.bounds;
            (i.center.x = Math.round((on.x - t) / 2)),
              (i.center.y = Math.round((on.y - n) / 2) + e.vGap.top),
              (i.max.x = t > on.x ? Math.round(on.x - t) : i.center.x),
              (i.max.y = n > on.y ? Math.round(on.y - n) + e.vGap.top : i.center.y),
              (i.min.x = t > on.x ? 0 : i.center.x),
              (i.min.y = n > on.y ? e.vGap.top : i.center.y);
          },
          cn = function (e, t, n) {
            if (e.src && !e.loadError) {
              var i = !n;
              if ((i && (e.vGap || (e.vGap = { top: 0, bottom: 0 }), Pe("parseVerticalMargin", e)), (on.x = t.x), (on.y = t.y - e.vGap.top - e.vGap.bottom), i)) {
                var o = on.x / e.w,
                  r = on.y / e.h;
                e.fitRatio = o < r ? o : r;
                var s = l.scaleMode;
                "orig" === s ? (n = 1) : "fit" === s ? (n = e.fitRatio) : "zoom" === s && (n = Math.max(e.initialZoomLevel || 1, e.fitRatio)), n > 1 && (n = 1), (e.initialZoomLevel = n), e.bounds || (e.bounds = an());
              }
              if (!n) return;
              return ln(e, e.w * n, e.h * n), i && n === e.initialZoomLevel && (e.initialPosition = e.bounds.center), e.bounds;
            }
            return (e.w = e.h = 0), (e.initialZoomLevel = e.fitRatio = 1), (e.bounds = an()), (e.initialPosition = e.bounds.center), e.bounds;
          },
          un = function (e, t, n, i, o, s) {
            t.loadError ||
              (i &&
                ((t.imageAppended = !0),
                fn(t, i, t === r.currItem && Ce),
                n.appendChild(i),
                s &&
                  setTimeout(function () {
                    t && t.loaded && t.placeholder && ((t.placeholder.style.display = "none"), (t.placeholder = null));
                  }, 500)));
          },
          pn = function (e) {
            (e.loading = !0), (e.loaded = !1);
            var t = (e.img = o.createEl("pswp__img", "img")),
              n = function () {
                (e.loading = !1), (e.loaded = !0), e.loadComplete ? e.loadComplete(e) : (e.img = null), (t.onload = t.onerror = null), (t = null);
              };
            return (
              (t.onload = n),
              (t.onerror = function () {
                (e.loadError = !0), n();
              }),
              (t.src = e.src),
              t
            );
          },
          dn = function (e, t) {
            if (e.src && e.loadError && e.container) return t && (e.container.innerHTML = ""), (e.container.innerHTML = l.errorMsg.replace("%url%", e.src)), !0;
          },
          fn = function (e, t, n) {
            if (e.src) {
              t || (t = e.container.lastChild);
              var i = n ? e.w : Math.round(e.w * e.fitRatio),
                o = n ? e.h : Math.round(e.h * e.fitRatio);
              e.placeholder && !e.loaded && ((e.placeholder.style.width = i + "px"), (e.placeholder.style.height = o + "px")), (t.style.width = i + "px"), (t.style.height = o + "px");
            }
          },
          hn = function () {
            if (rn.length) {
              for (var e, t = 0; t < rn.length; t++) (e = rn[t]), e.holder.index === e.index && un(e.index, e.item, e.baseDiv, e.img, !1, e.clearPlaceholder);
              rn = [];
            }
          };
        Te("Controller", {
          publicMethods: {
            lazyLoadItem: function (e) {
              e = Ee(e);
              var t = Qt(e);
              t && ((!t.loaded && !t.loading) || S) && (Pe("gettingData", e, t), t.src && pn(t));
            },
            initController: function () {
              o.extend(l, sn, !0),
                (r.items = Yt = n),
                (Qt = r.getItemAt),
                (en = l.getNumItemsFn),
                (tn = l.loop),
                en() < 3 && (l.loop = !1),
                Ae("beforeChange", function (e) {
                  var t,
                    n = l.preload,
                    i = null === e || e >= 0,
                    o = Math.min(n[0], en()),
                    s = Math.min(n[1], en());
                  for (t = 1; t <= (i ? s : o); t++) r.lazyLoadItem(d + t);
                  for (t = 1; t <= (i ? o : s); t++) r.lazyLoadItem(d - t);
                }),
                Ae("initialLayout", function () {
                  r.currItem.initialLayout = l.getThumbBoundsFn && l.getThumbBoundsFn(d);
                }),
                Ae("mainScrollAnimComplete", hn),
                Ae("initialZoomInEnd", hn),
                Ae("destroy", function () {
                  for (var e, t = 0; t < Yt.length; t++)
                    (e = Yt[t]), e.container && (e.container = null), e.placeholder && (e.placeholder = null), e.img && (e.img = null), e.preloader && (e.preloader = null), e.loadError && (e.loaded = e.loadError = !1);
                  rn = null;
                });
            },
            getItemAt: function (e) {
              return e >= 0 && void 0 !== Yt[e] && Yt[e];
            },
            allowProgressiveImg: function () {
              return l.forceProgressiveLoading || !I || l.mouseUsed || screen.width > 1200;
            },
            setContent: function (e, t) {
              l.loop && (t = Ee(t));
              var n = r.getItemAt(e.index);
              n && (n.container = null);
              var i,
                s = r.getItemAt(t);
              if (!s) return void (e.el.innerHTML = "");
              Pe("gettingData", t, s), (e.index = t), (e.item = s);
              var a = (s.container = o.createEl("pswp__zoom-wrap"));
              if ((!s.src && s.html && (s.html.tagName ? a.appendChild(s.html) : (a.innerHTML = s.html)), dn(s), cn(s, ve), !s.src || s.loadError || s.loaded))
                s.src && !s.loadError && ((i = o.createEl("pswp__img", "img")), (i.style.opacity = 1), (i.src = s.src), fn(s, i), un(t, s, a, i, !0));
              else {
                if (
                  ((s.loadComplete = function (n) {
                    if (c) {
                      if (e && e.index === t) {
                        if (dn(n, !0)) return (n.loadComplete = n.img = null), cn(n, ve), De(n), void (e.index === d && r.updateCurrZoomItem());
                        n.imageAppended
                          ? !Jt && n.placeholder && ((n.placeholder.style.display = "none"), (n.placeholder = null))
                          : H.transform && (re || Jt)
                          ? rn.push({ item: n, baseDiv: a, img: n.img, index: t, holder: e, clearPlaceholder: !0 })
                          : un(t, n, a, n.img, re || Jt, !0);
                      }
                      (n.loadComplete = null), (n.img = null), Pe("imageLoadComplete", t, n);
                    }
                  }),
                  o.features.transform)
                ) {
                  var u = "pswp__img pswp__img--placeholder";
                  u += s.msrc ? "" : " pswp__img--placeholder--blank";
                  var p = o.createEl(u, s.msrc ? "img" : "");
                  s.msrc && (p.src = s.msrc), fn(s, p), a.appendChild(p), (s.placeholder = p);
                }
                s.loading || pn(s), r.allowProgressiveImg() && (!Gt && H.transform ? rn.push({ item: s, baseDiv: a, img: s.img, index: t, holder: e }) : un(t, s, a, s.img, !0, !0));
              }
              Gt || t !== d ? De(s) : ((oe = a.style), nn(s, i || s.img)), (e.el.innerHTML = ""), e.el.appendChild(a);
            },
            cleanSlide: function (e) {
              e.img && (e.img.onload = e.img.onerror = null), (e.loaded = e.loading = e.img = e.imageAppended = !1);
            },
          },
        });
        var mn,
          vn = {},
          gn = function (e, t, n) {
            var i = document.createEvent("CustomEvent"),
              o = { origEvent: e, target: e.target, releasePoint: t, pointerType: n || "touch" };
            i.initCustomEvent("pswpTap", !0, !0, o), e.target.dispatchEvent(i);
          };
        Te("Tap", {
          publicMethods: {
            initTap: function () {
              Ae("firstTouchStart", r.onTapStart),
                Ae("touchRelease", r.onTapRelease),
                Ae("destroy", function () {
                  (vn = {}), (mn = null);
                });
            },
            onTapStart: function (e) {
              e.length > 1 && (clearTimeout(mn), (mn = null));
            },
            onTapRelease: function (e, t) {
              if (t && !Y && !V && !Qe) {
                var n = t;
                if (mn && (clearTimeout(mn), (mn = null), St(n, vn))) return void Pe("doubleTap", n);
                if ("mouse" === t.type) return void gn(e, t, "mouse");
                var i = e.target.tagName.toUpperCase();
                if ("BUTTON" === i || o.hasClass(e.target, "pswp__single-tap")) return void gn(e, t);
                je(vn, n),
                  (mn = setTimeout(function () {
                    gn(e, t), (mn = null);
                  }, 300));
              }
            },
          },
        });
        var yn;
        Te("DesktopZoom", {
          publicMethods: {
            initDesktopZoom: function () {
              M ||
                (I
                  ? Ae("mouseUsed", function () {
                      r.setupDesktopZoom();
                    })
                  : r.setupDesktopZoom(!0));
            },
            setupDesktopZoom: function (t) {
              yn = {};
              var n = "wheel mousewheel DOMMouseScroll";
              Ae("bindEvents", function () {
                o.bind(e, n, r.handleMouseWheel);
              }),
                Ae("unbindEvents", function () {
                  yn && o.unbind(e, n, r.handleMouseWheel);
                }),
                (r.mouseZoomedIn = !1);
              var i,
                s = function () {
                  r.mouseZoomedIn && (o.removeClass(e, "pswp--zoomed-in"), (r.mouseZoomedIn = !1)), y < 1 ? o.addClass(e, "pswp--zoom-allowed") : o.removeClass(e, "pswp--zoom-allowed"), a();
                },
                a = function () {
                  i && (o.removeClass(e, "pswp--dragging"), (i = !1));
                };
              Ae("resize", s),
                Ae("afterChange", s),
                Ae("pointerDown", function () {
                  r.mouseZoomedIn && ((i = !0), o.addClass(e, "pswp--dragging"));
                }),
                Ae("pointerUp", a),
                t || s();
            },
            handleMouseWheel: function (e) {
              if (y <= r.currItem.fitRatio) return l.modal && (!l.closeOnScroll || Qe || K ? e.preventDefault() : O && Math.abs(e.deltaY) > 2 && ((p = !0), r.close())), !0;
              if ((e.stopPropagation(), (yn.x = 0), "deltaX" in e)) 1 === e.deltaMode ? ((yn.x = 18 * e.deltaX), (yn.y = 18 * e.deltaY)) : ((yn.x = e.deltaX), (yn.y = e.deltaY));
              else if ("wheelDelta" in e) e.wheelDeltaX && (yn.x = -0.16 * e.wheelDeltaX), e.wheelDeltaY ? (yn.y = -0.16 * e.wheelDeltaY) : (yn.y = -0.16 * e.wheelDelta);
              else {
                if (!("detail" in e)) return;
                yn.y = e.detail;
              }
              We(y, !0);
              var t = me.x - yn.x,
                n = me.y - yn.y;
              (l.modal || (t <= ie.min.x && t >= ie.max.x && n <= ie.min.y && n >= ie.max.y)) && e.preventDefault(), r.panTo(t, n);
            },
            toggleDesktopZoom: function (t) {
              t = t || { x: ve.x / 2 + ye.x, y: ve.y / 2 + ye.y };
              var n = l.getDoubleTapZoom(!0, r.currItem),
                i = y === n;
              (r.mouseZoomedIn = !i), r.zoomTo(i ? r.currItem.initialZoomLevel : n, t, 333), o[(i ? "remove" : "add") + "Class"](e, "pswp--zoomed-in");
            },
          },
        }),
          o.extend(r, ot);
      };
      return e;
    })
    /*! PhotoSwipe Default UI - 4.1.2 - 2017-04-05
     * http://photoswipe.com
     * Copyright (c) 2017 Dmitry Semenov; */,
    !(function (e, t) {
      "function" == typeof define && define.amd ? define(t) : "object" == typeof exports ? (module.exports = t()) : (e.PhotoSwipeUI_Default = t());
    })(this, function () {
      "use strict";
      var e = function (e, t) {
        var n,
          i,
          o,
          r,
          s,
          a,
          l,
          c,
          u,
          p,
          d,
          f,
          h,
          m,
          v,
          g,
          y,
          b,
          w,
          x = this,
          k = !1,
          S = !0,
          C = !0,
          T = {
            barsSize: { top: 44, bottom: "auto" },
            closeElClasses: ["item", "caption", "zoom-wrap", "ui", "top-bar"],
            timeToIdle: 4e3,
            timeToIdleOutside: 1e3,
            loadingIndicatorDelay: 1e3,
            addCaptionHTMLFn: function (e, t) {
              return e.title ? ((t.children[0].innerHTML = e.title), !0) : ((t.children[0].innerHTML = ""), !1);
            },
            closeEl: !0,
            captionEl: !0,
            fullscreenEl: !0,
            zoomEl: !0,
            shareEl: !0,
            counterEl: !0,
            arrowEl: !0,
            preloaderEl: !0,
            tapToClose: !1,
            tapToToggleControls: !0,
            clickToCloseNonZoomable: !0,
            shareButtons: [
              { id: "facebook", label: "Share on Facebook", url: "https://www.facebook.com/sharer/sharer.php?u={{url}}" },
              { id: "twitter", label: "Tweet", url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}" },
              { id: "pinterest", label: "Pin it", url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}" },
              { id: "download", label: "Download image", url: "{{raw_image_url}}", download: !0 },
            ],
            getImageURLForShare: function () {
              return e.currItem.src || "";
            },
            getPageURLForShare: function () {
              return window.location.href;
            },
            getTextForShare: function () {
              return e.currItem.title || "";
            },
            indexIndicatorSep: " / ",
            fitControlsWidth: 1200,
          },
          E = function (e) {
            if (g) return !0;
            (e = e || window.event), v.timeToIdle && v.mouseUsed && !u && z();
            for (var n, i, o = e.target || e.srcElement, r = o.getAttribute("class") || "", s = 0; s < W.length; s++) (n = W[s]), n.onTap && r.indexOf("pswp__" + n.name) > -1 && (n.onTap(), (i = !0));
            if (i) {
              e.stopPropagation && e.stopPropagation(), (g = !0);
              var a = t.features.isOldAndroid ? 600 : 30;
              y = setTimeout(function () {
                g = !1;
              }, a);
            }
          },
          _ = function () {
            return !e.likelyTouchDevice || v.mouseUsed || screen.width > v.fitControlsWidth;
          },
          A = function (e, n, i) {
            t[(i ? "add" : "remove") + "Class"](e, "pswp__" + n);
          },
          P = function () {
            var e = 1 === v.getNumItemsFn();
            e !== m && (A(i, "ui--one-slide", e), (m = e));
          },
          O = function () {
            A(l, "share-modal--hidden", C);
          },
          N = function () {
            return (
              (C = !C),
              C
                ? (t.removeClass(l, "pswp__share-modal--fade-in"),
                  setTimeout(function () {
                    C && O();
                  }, 300))
                : (O(),
                  setTimeout(function () {
                    C || t.addClass(l, "pswp__share-modal--fade-in");
                  }, 30)),
              C || $(),
              !1
            );
          },
          I = function (t) {
            t = t || window.event;
            var n = t.target || t.srcElement;
            return (
              e.shout("shareLinkClick", t, n),
              !(
                !n.href ||
                (!n.hasAttribute("download") &&
                  (window.open(n.href, "pswp_share", "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" + (window.screen ? Math.round(screen.width / 2 - 275) : 100)), C || N(), 1))
              )
            );
          },
          $ = function () {
            for (var e, t, n, i, o, r = "", s = 0; s < v.shareButtons.length; s++)
              (e = v.shareButtons[s]),
                (n = v.getImageURLForShare(e)),
                (i = v.getPageURLForShare(e)),
                (o = v.getTextForShare(e)),
                (t = e.url.replace("{{url}}", encodeURIComponent(i)).replace("{{image_url}}", encodeURIComponent(n)).replace("{{raw_image_url}}", n).replace("{{text}}", encodeURIComponent(o))),
                (r += '<a href="' + t + '" target="_blank" class="pswp__share--' + e.id + '"' + (e.download ? "download" : "") + ">" + e.label + "</a>"),
                v.parseShareButtonOut && (r = v.parseShareButtonOut(e, r));
            (l.children[0].innerHTML = r), (l.children[0].onclick = I);
          },
          D = function (e) {
            for (var n = 0; n < v.closeElClasses.length; n++) if (t.hasClass(e, "pswp__" + v.closeElClasses[n])) return !0;
          },
          L = 0,
          z = function () {
            clearTimeout(w), (L = 0), u && x.setIdle(!1);
          },
          M = function (e) {
            e = e ? e : window.event;
            var t = e.relatedTarget || e.toElement;
            (t && "HTML" !== t.nodeName) ||
              (clearTimeout(w),
              (w = setTimeout(function () {
                x.setIdle(!0);
              }, v.timeToIdleOutside)));
          },
          j = function () {
            v.fullscreenEl &&
              !t.features.isOldAndroid &&
              (n || (n = x.getFullscreenAPI()), n ? (t.bind(document, n.eventK, x.updateFullscreen), x.updateFullscreen(), t.addClass(e.template, "pswp--supports-fs")) : t.removeClass(e.template, "pswp--supports-fs"));
          },
          H = function () {
            v.preloaderEl &&
              (F(!0),
              p("beforeChange", function () {
                clearTimeout(h),
                  (h = setTimeout(function () {
                    e.currItem && e.currItem.loading ? (!e.allowProgressiveImg() || (e.currItem.img && !e.currItem.img.naturalWidth)) && F(!1) : F(!0);
                  }, v.loadingIndicatorDelay));
              }),
              p("imageLoadComplete", function (t, n) {
                e.currItem === n && F(!0);
              }));
          },
          F = function (e) {
            f !== e && (A(d, "preloader--active", !e), (f = e));
          },
          R = function (e) {
            var n = e.vGap;
            if (_()) {
              var s = v.barsSize;
              if (v.captionEl && "auto" === s.bottom)
                if ((r || ((r = t.createEl("pswp__caption pswp__caption--fake")), r.appendChild(t.createEl("pswp__caption__center")), i.insertBefore(r, o), t.addClass(i, "pswp__ui--fit")), v.addCaptionHTMLFn(e, r, !0))) {
                  var a = r.clientHeight;
                  n.bottom = parseInt(a, 10) || 44;
                } else n.bottom = s.top;
              else n.bottom = "auto" === s.bottom ? 0 : s.bottom;
              n.top = s.top;
            } else n.top = n.bottom = 0;
          },
          q = function () {
            v.timeToIdle &&
              p("mouseUsed", function () {
                t.bind(document, "mousemove", z),
                  t.bind(document, "mouseout", M),
                  (b = setInterval(function () {
                    L++, 2 === L && x.setIdle(!0);
                  }, v.timeToIdle / 2));
              });
          },
          B = function () {
            p("onVerticalDrag", function (e) {
              S && e < 0.95 ? x.hideControls() : !S && e >= 0.95 && x.showControls();
            });
            var e;
            p("onPinchClose", function (t) {
              S && t < 0.9 ? (x.hideControls(), (e = !0)) : e && !S && t > 0.9 && x.showControls();
            }),
              p("zoomGestureEnded", function () {
                (e = !1), e && !S && x.showControls();
              });
          },
          W = [
            {
              name: "caption",
              option: "captionEl",
              onInit: function (e) {
                o = e;
              },
            },
            {
              name: "share-modal",
              option: "shareEl",
              onInit: function (e) {
                l = e;
              },
              onTap: function () {
                N();
              },
            },
            {
              name: "button--share",
              option: "shareEl",
              onInit: function (e) {
                a = e;
              },
              onTap: function () {
                N();
              },
            },
            { name: "button--zoom", option: "zoomEl", onTap: e.toggleDesktopZoom },
            {
              name: "counter",
              option: "counterEl",
              onInit: function (e) {
                s = e;
              },
            },
            { name: "button--close", option: "closeEl", onTap: e.close },
            { name: "button--arrow--left", option: "arrowEl", onTap: e.prev },
            { name: "button--arrow--right", option: "arrowEl", onTap: e.next },
            {
              name: "button--fs",
              option: "fullscreenEl",
              onTap: function () {
                n.isFullscreen() ? n.exit() : n.enter();
              },
            },
            {
              name: "preloader",
              option: "preloaderEl",
              onInit: function (e) {
                d = e;
              },
            },
          ],
          U = function () {
            var e,
              n,
              o,
              r = function (i) {
                if (i)
                  for (var r = i.length, s = 0; s < r; s++) {
                    (e = i[s]), (n = e.className);
                    for (var a = 0; a < W.length; a++) (o = W[a]), n.indexOf("pswp__" + o.name) > -1 && (v[o.option] ? (t.removeClass(e, "pswp__element--disabled"), o.onInit && o.onInit(e)) : t.addClass(e, "pswp__element--disabled"));
                  }
              };
            r(i.children);
            var s = t.getChildByClass(i, "pswp__top-bar");
            s && r(s.children);
          };
        (x.init = function () {
          t.extend(e.options, T, !0),
            (v = e.options),
            (i = t.getChildByClass(e.scrollWrap, "pswp__ui")),
            (p = e.listen),
            B(),
            p("beforeChange", x.update),
            p("doubleTap", function (t) {
              var n = e.currItem.initialZoomLevel;
              e.getZoomLevel() !== n ? e.zoomTo(n, t, 333) : e.zoomTo(v.getDoubleTapZoom(!1, e.currItem), t, 333);
            }),
            p("preventDragEvent", function (e, t, n) {
              var i = e.target || e.srcElement;
              i && i.getAttribute("class") && e.type.indexOf("mouse") > -1 && (i.getAttribute("class").indexOf("__caption") > 0 || /(SMALL|STRONG|EM)/i.test(i.tagName)) && (n.prevent = !1);
            }),
            p("bindEvents", function () {
              t.bind(i, "pswpTap click", E), t.bind(e.scrollWrap, "pswpTap", x.onGlobalTap), e.likelyTouchDevice || t.bind(e.scrollWrap, "mouseover", x.onMouseOver);
            }),
            p("unbindEvents", function () {
              C || N(),
                b && clearInterval(b),
                t.unbind(document, "mouseout", M),
                t.unbind(document, "mousemove", z),
                t.unbind(i, "pswpTap click", E),
                t.unbind(e.scrollWrap, "pswpTap", x.onGlobalTap),
                t.unbind(e.scrollWrap, "mouseover", x.onMouseOver),
                n && (t.unbind(document, n.eventK, x.updateFullscreen), n.isFullscreen() && ((v.hideAnimationDuration = 0), n.exit()), (n = null));
            }),
            p("destroy", function () {
              v.captionEl && (r && i.removeChild(r), t.removeClass(o, "pswp__caption--empty")), l && (l.children[0].onclick = null), t.removeClass(i, "pswp__ui--over-close"), t.addClass(i, "pswp__ui--hidden"), x.setIdle(!1);
            }),
            v.showAnimationDuration || t.removeClass(i, "pswp__ui--hidden"),
            p("initialZoomIn", function () {
              v.showAnimationDuration && t.removeClass(i, "pswp__ui--hidden");
            }),
            p("initialZoomOut", function () {
              t.addClass(i, "pswp__ui--hidden");
            }),
            p("parseVerticalMargin", R),
            U(),
            v.shareEl && a && l && (C = !0),
            P(),
            q(),
            j(),
            H();
        }),
          (x.setIdle = function (e) {
            (u = e), A(i, "ui--idle", e);
          }),
          (x.update = function () {
            S && e.currItem ? (x.updateIndexIndicator(), v.captionEl && (v.addCaptionHTMLFn(e.currItem, o), A(o, "caption--empty", !e.currItem.title)), (k = !0)) : (k = !1), C || N(), P();
          }),
          (x.updateFullscreen = function (i) {
            i &&
              setTimeout(function () {
                e.setScrollOffset(0, t.getScrollY());
              }, 50),
              t[(n.isFullscreen() ? "add" : "remove") + "Class"](e.template, "pswp--fs");
          }),
          (x.updateIndexIndicator = function () {
            v.counterEl && (s.innerHTML = e.getCurrentIndex() + 1 + v.indexIndicatorSep + v.getNumItemsFn());
          }),
          (x.onGlobalTap = function (n) {
            n = n || window.event;
            var i = n.target || n.srcElement;
            if (!g)
              if (n.detail && "mouse" === n.detail.pointerType) {
                if (D(i)) return void e.close();
                t.hasClass(i, "pswp__img") && (1 === e.getZoomLevel() && e.getZoomLevel() <= e.currItem.fitRatio ? v.clickToCloseNonZoomable && e.close() : e.toggleDesktopZoom(n.detail.releasePoint));
              } else if ((v.tapToToggleControls && (S ? x.hideControls() : x.showControls()), v.tapToClose && (t.hasClass(i, "pswp__img") || D(i)))) return void e.close();
          }),
          (x.onMouseOver = function (e) {
            e = e || window.event;
            var t = e.target || e.srcElement;
            A(i, "ui--over-close", D(t));
          }),
          (x.hideControls = function () {
            t.addClass(i, "pswp__ui--hidden"), (S = !1);
          }),
          (x.showControls = function () {
            (S = !0), k || x.update(), t.removeClass(i, "pswp__ui--hidden");
          }),
          (x.supportsFullscreen = function () {
            var e = document;
            return !!(e.exitFullscreen || e.mozCancelFullScreen || e.webkitExitFullscreen || e.msExitFullscreen);
          }),
          (x.getFullscreenAPI = function () {
            var t,
              n = document.documentElement,
              i = "fullscreenchange";
            return (
              n.requestFullscreen
                ? (t = { enterK: "requestFullscreen", exitK: "exitFullscreen", elementK: "fullscreenElement", eventK: i })
                : n.mozRequestFullScreen
                ? (t = { enterK: "mozRequestFullScreen", exitK: "mozCancelFullScreen", elementK: "mozFullScreenElement", eventK: "moz" + i })
                : n.webkitRequestFullscreen
                ? (t = { enterK: "webkitRequestFullscreen", exitK: "webkitExitFullscreen", elementK: "webkitFullscreenElement", eventK: "webkit" + i })
                : n.msRequestFullscreen && (t = { enterK: "msRequestFullscreen", exitK: "msExitFullscreen", elementK: "msFullscreenElement", eventK: "MSFullscreenChange" }),
              t &&
                ((t.enter = function () {
                  return (c = v.closeOnScroll), (v.closeOnScroll = !1), "webkitRequestFullscreen" !== this.enterK ? e.template[this.enterK]() : void e.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT);
                }),
                (t.exit = function () {
                  return (v.closeOnScroll = c), document[this.exitK]();
                }),
                (t.isFullscreen = function () {
                  return document[this.elementK];
                })),
              t
            );
          });
      };
      return e;
    });
  